webpackJsonp([1],{

/***/ 1149:
/*!****************************************************************************!*\
  !*** ./src/containers/delete-account/components/TablePaginationActions.js ***!
  \****************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icons_md__ = __webpack_require__(/*! react-icons/md */ 267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_IconButton__ = __webpack_require__(/*! @material-ui/core/es/IconButton */ 166);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var styles = function styles(theme) {
    return {
        root: {
            flexShrink: 0,
            color: theme.palette.text.secondary,
            marginLeft: theme.spacing.unit * 2.5
        }
    };
};

var TablePaginationActions = function (_React$Component) {
    _inherits(TablePaginationActions, _React$Component);

    function TablePaginationActions() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TablePaginationActions);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TablePaginationActions.__proto__ || Object.getPrototypeOf(TablePaginationActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleFirstPageButtonClick = function (event) {
            _this.props.onChangePage(event, 0);
        }, _this.handleBackButtonClick = function (event) {
            _this.props.onChangePage(event, _this.props.page - 1);
        }, _this.handleNextButtonClick = function (event) {
            _this.props.onChangePage(event, _this.props.page + 1);
        }, _this.handleLastPageButtonClick = function (event) {
            _this.props.onChangePage(event, Math.max(0, Math.ceil(_this.props.count / _this.props.rowsPerPage) - 1));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TablePaginationActions, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                count = _props.count,
                page = _props.page,
                rowsPerPage = _props.rowsPerPage,
                theme = _props.theme;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: classes.root },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_IconButton__["a" /* default */],
                    {
                        onClick: this.handleFirstPageButtonClick,
                        disabled: page === 0,
                        'aria-label': 'First Page'
                    },
                    theme.direction === 'rtl' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["f" /* MdLastPage */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["e" /* MdFirstPage */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_IconButton__["a" /* default */],
                    {
                        onClick: this.handleBackButtonClick,
                        disabled: page === 0,
                        'aria-label': 'Previous Page'
                    },
                    theme.direction === 'rtl' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["b" /* MdChevronRight */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["a" /* MdChevronLeft */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_IconButton__["a" /* default */],
                    {
                        onClick: this.handleNextButtonClick,
                        disabled: page >= Math.ceil(count / rowsPerPage) - 1,
                        'aria-label': 'Next Page'
                    },
                    theme.direction === 'rtl' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["a" /* MdChevronLeft */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["b" /* MdChevronRight */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_IconButton__["a" /* default */],
                    {
                        onClick: this.handleLastPageButtonClick,
                        disabled: page >= Math.ceil(count / rowsPerPage) - 1,
                        'aria-label': 'Last Page'
                    },
                    theme.direction === 'rtl' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["e" /* MdFirstPage */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_md__["f" /* MdLastPage */], null)
                )
            );
        }
    }]);

    return TablePaginationActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_withStyles__["a" /* default */])(styles, { withTheme: true })(TablePaginationActions));

/***/ }),

/***/ 1195:
/*!*****************************************************!*\
  !*** ./src/containers/billing/jss/BillingStyles.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common__ = __webpack_require__(/*! @material-ui/core/colors/common */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(/*! ../../../assets/jss/material-dashboard-pro-react.jsx */ 175);


var white = __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common___default.a.white;
var red500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default.a['500'];
// import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";


var billingStyles = function billingStyles(theme) {
    return {
        heading: {
            fontSize: theme.typography.pxToRem(15)
        },
        cardIconTitle: Object.assign({}, __WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_jsx__["a" /* cardTitle */], {
            marginTop: "15px",
            marginBottom: "0px",
            "& small": {
                fontSize: "80%",
                fontWeight: "400"
            }
        }),
        pageTitle: {
            background: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            borderRadius: '5px',
            padding: '10px',
            marginBottom: '20px'
        },
        labelHorizontal: {
            cursor: "pointer",
            display: "inline-flex",
            fontSize: "14px",
            fontWeight: "400",
            marginRight: "0",
            lineHeight: "20px",
            "@media (min-width: 992px)": {
                textAlign: "end",
                float: "right"
            }
        },
        labelAndText: {
            lineHeight: "1.428571429",
            paddingTop: "15px"
        },
        tableCell: {
            fontSize: '14px',
            borderRight: '1px solid rgba(0, 0, 0, 0.08)'
        },
        tableRow: {
            '& th:last-child': {
                borderRight: 'none'
            }
        },
        tableContainer: {
            overflowX: 'auto',
            borderRadius: '0px 0px 5px 5px',
            borderRight: '1px solid rgba(0, 0, 0, 0.13)',
            borderLeft: '1px solid rgba(0, 0, 0, 0.13)'
        },
        billingContainer: {
            marginBottom: '50px'
        },
        billingContainerHeader: {
            background: '#F8F8F8',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            borderRadius: '5px 5px 0px 0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '5px 10px'
        },
        addBtn: {
            background: '#00CD6B',
            boxShadow: '4px 4px 18px 1px rgba(0, 205, 107, 0.35)',
            padding: '10px 20px',
            borderRadius: '3px',
            color: '#fff',
            outline: 'none',
            border: '1px solid',
            borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(27, 97, 237, 0) 100%) 1 stretch',
            "&:after": {
                content: "'Add'"
            }
        },
        editBtn: {
            background: '#fff',
            border: '3px solid',
            color: '#1B23ED',
            outline: 'none',
            borderRadius: '3px',
            padding: '10px 20px',
            borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(185, 0, 44, 0) 100%), linear-gradient(0deg, #1B23ED, #1B23ED) 1 strech',
            "&:after": {
                content: "'Edit'"
            }
        },
        emptyBillingDetailsContainer: {
            background: '#FFFFFF',
            minHeight: '100px',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            borderRadius: '0px 0px 5px 5px', padding: '5px 10px'
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (billingStyles);

/***/ }),

/***/ 1197:
/*!**********************************************************!*\
  !*** ./src/containers/billing/components/BillingForm.js ***!
  \**********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__ = __webpack_require__(/*! react-redux/es/connect/connect */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_es_bindActionCreators__ = __webpack_require__(/*! redux/es/bindActionCreators */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_es_reduxForm__ = __webpack_require__(/*! redux-form/es/reduxForm */ 730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__ = __webpack_require__(/*! redux-form/es/Field */ 373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BillingActions__ = __webpack_require__(/*! ../BillingActions */ 161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_reduxFields_ReduxSearchableSelectField__ = __webpack_require__(/*! ../../../components/reduxFields/ReduxSearchableSelectField */ 2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_country_region_data__ = __webpack_require__(/*! country-region-data */ 2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_country_region_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_country_region_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_stripe_elements__ = __webpack_require__(/*! react-stripe-elements */ 341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_material_pro_Clearfix_Clearfix__ = __webpack_require__(/*! ../../../components/material-pro/Clearfix/Clearfix */ 2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_material_pro_Grid_GridContainer__ = __webpack_require__(/*! ../../../components/material-pro/Grid/GridContainer */ 339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__ = __webpack_require__(/*! ../../../components/material-pro/Grid/GridItem */ 340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InjectedCheckoutForm__ = __webpack_require__(/*! ./InjectedCheckoutForm */ 2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_form_es_SubmissionError__ = __webpack_require__(/*! redux-form/es/SubmissionError */ 372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_material_pro_CustomButtons_Button__ = __webpack_require__(/*! ../../../components/material-pro/CustomButtons/Button */ 1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_reduxFields_ReduxInsideLabelTextField__ = __webpack_require__(/*! ../../../components/reduxFields/ReduxInsideLabelTextField */ 1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_confirmation_modal_ConfirmationModalActions__ = __webpack_require__(/*! ../../../components/confirmation-modal/ConfirmationModalActions */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__jss_InjectedCheckoutFormStyles__ = __webpack_require__(/*! ../jss/InjectedCheckoutFormStyles */ 1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__edit_info_EditInfoActions__ = __webpack_require__(/*! ./edit-info/EditInfoActions */ 246);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var BillingFrom = function (_Component) {
  _inherits(BillingFrom, _Component);

  function BillingFrom() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BillingFrom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BillingFrom.__proto__ || Object.getPrototypeOf(BillingFrom)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedCountry: null,
      useCompanyDetails: false,
      error: "",
      selectedCountryFetched: false,
      checked: false,
      checkedError: false
    }, _this.getCountries = function () {
      var countriesOptions = [];
      __WEBPACK_IMPORTED_MODULE_7_country_region_data___default.a.map(function (country) {
        return countriesOptions.push({
          value: country.countryName,
          label: country.countryName
        });
      });
      return countriesOptions;
    }, _this.getRegions = function (country) {
      var regionOptions = [];
      if (country) {
        var selectedCountryRegions = __WEBPACK_IMPORTED_MODULE_7_country_region_data___default.a.filter(function (c) {
          return c.countryName === country;
        })[0].regions;
        selectedCountryRegions.map(function (region) {
          return regionOptions.push({ value: region.name, label: region.name });
        });
      }
      return regionOptions;
    }, _this.handleCardErrors = function (e) {
      return _this.setState({ error: e.error ? e.error.message : "" });
    }, _this.handlCheckboxeChange = function (event) {
      _this.setState({ checkedError: false });
      _this.setState({ checked: event.target.checked });
    }, _this.toggleDeleteHandler = function () {
      var _this$props = _this.props,
          openConfirmationModal = _this$props.openConfirmationModal,
          deleteCredit = _this$props.deleteCredit,
          last4Digits = _this$props.billing.customer.last4Digits,
          closeInfoModal = _this$props.closeInfoModal;

      closeInfoModal();
      openConfirmationModal({ text: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          "Are you sure you wat to delete credit detailes"
        ), callback: function callback() {
          return deleteCredit(last4Digits);
        }, confirmCheckbox: false, btn1: 'Cancel', btn2: 'Confirm' });
    }, _this.onSubmit = function (props) {
      var _this$props2 = _this.props,
          company = _this$props2.company,
          stripe = _this$props2.stripe,
          createOrUpdateCredit = _this$props2.createOrUpdateCredit,
          billing = _this$props2.billing,
          useCompanyDetails = _this$props2.billing.useCompanyDetails,
          openConfirmationModal = _this$props2.openConfirmationModal;
      var _this$state = _this.state,
          error = _this$state.error,
          checked = _this$state.checked;


      function submitFlow() {
        var _this2 = this;

        var ba = useCompanyDetails ? company.content : props;
        var region = ba.country === "United States" ? ba.region : null;
        var formattedInfo = {
          name: ba.name,
          addressCity: ba.city,
          addressCountry: ba.country,
          addressState: region,
          zipCode: ba.zip
        };
        if (!billing.customer.hasOwnProperty("last4Digits")) {
          //&& checked
          if (error && error !== "") {
            throw new __WEBPACK_IMPORTED_MODULE_13_redux_form_es_SubmissionError__["a" /* default */]();
          }
          stripe.createToken({
            name: ba.name,
            address_city: ba.city,
            address_country: ba.country,
            address_state: ba.region,
            address_zip: ba.zip
          }).then(function (_ref2) {
            var token = _ref2.token;

            if (token && token.id) {
              formattedInfo.token = token.id;
              createOrUpdateCredit(formattedInfo, props.email);
            } else {
              _this2.setState({
                error:
                // <Translate value="billing.creditDetailsModal.defaultError" />
                'incomplete fields'
              });
              throw new __WEBPACK_IMPORTED_MODULE_13_redux_form_es_SubmissionError__["a" /* default */]();
            }
          });
        } else {
          createOrUpdateCredit(formattedInfo, props.email);
        }
      }

      if (billing.customer.hasOwnProperty("last4Digits")) {
        // && checked
        submitFlow.bind(_this)();
      } else {
        submitFlow.bind(_this)();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BillingFrom, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps != this.props && this.state.selectedCountryFetched === false) {
        this.setState({
          selectedCountry: this.props.billing.customer.addressCountry,
          selectedCountryFetched: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          billing = _props.billing,
          toggleCreditDetails = _props.toggleCreditDetails,
          openConfirmationModal = _props.openConfirmationModal,
          classes = _props.classes,
          closeInfoModal = _props.closeInfoModal;
      var _state = this.state,
          error = _state.error,
          checked = _state.checked,
          checkedError = _state.checkedError;


      var defaultPackagePrice = ((billing.defaultPlan && billing.defaultPlan.price || 0) / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit(this.onSubmit), style: { position: 'relative', zIndex: '0', padding: '0 15px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { maxWidth: "1000px", margin: "auto" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__components_material_pro_Grid_GridContainer__["a" /* default */],
            { justify: "center", style: { width: '100%', margin: '0' } },
            !billing.customer.hasOwnProperty("last4Digits") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 12, sm: 12, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__InjectedCheckoutForm__["a" /* default */], {
                handleCardErrors: this.handleCardErrors,
                error: error
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__components_material_pro_Grid_GridContainer__["a" /* default */],
            { justify: "center", style: { marginTop: '45px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 6, xs: 12, sm: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: classes.formLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "billing.Name" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__["a" /* default */], {
                  className: classes.formInputField,
                  name: "name",
                  required: true,
                  component: __WEBPACK_IMPORTED_MODULE_15__components_reduxFields_ReduxInsideLabelTextField__["a" /* default */]
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 6, xs: 12, sm: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: classes.formLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.Email" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__["a" /* default */], {
                  className: classes.formInputField,
                  name: "email",
                  required: true,
                  component: __WEBPACK_IMPORTED_MODULE_15__components_reduxFields_ReduxInsideLabelTextField__["a" /* default */]
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 6, xs: 12, sm: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: classes.formLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.Country" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__["a" /* default */], {
                  name: "country",
                  placeholder: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.Country" }),
                  options: this.getCountries(),
                  component: __WEBPACK_IMPORTED_MODULE_6__components_reduxFields_ReduxSearchableSelectField__["a" /* default */],
                  onChange: function onChange(e, value) {
                    return _this3.setState({ selectedCountry: value });
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 6, xs: 12, sm: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: classes.formLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.State" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__["a" /* default */], {
                  name: "region",
                  placeholder: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.State" }),
                  options: this.state.selectedCountry === "United States" ? this.getRegions(this.state.selectedCountry) : [],
                  component: __WEBPACK_IMPORTED_MODULE_6__components_reduxFields_ReduxSearchableSelectField__["a" /* default */],
                  disabled: this.state.selectedCountry !== "United States" && this.state.selectedCountry !== null
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 6, xs: 12, sm: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: classes.formLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.City" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__["a" /* default */], {
                  className: classes.formInputField,
                  name: "city",
                  component: __WEBPACK_IMPORTED_MODULE_15__components_reduxFields_ReduxInsideLabelTextField__["a" /* default */]
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__components_material_pro_Grid_GridItem__["a" /* default */],
              { md: 6, xs: 12, sm: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: classes.formLabel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "labels.Zip Code" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_es_Field__["a" /* default */], {
                  className: classes.formInputField,
                  name: "zip",
                  required: true,
                  component: __WEBPACK_IMPORTED_MODULE_15__components_reduxFields_ReduxInsideLabelTextField__["a" /* default */]
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.modalActionsContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              billing.customer.hasOwnProperty("last4Digits") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components_material_pro_CustomButtons_Button__["a" /* default */],
                {
                  simple: true,
                  onClick: this.toggleDeleteHandler,
                  className: classes.deleteBillingBtn },
                "Delete billing info"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components_material_pro_CustomButtons_Button__["a" /* default */],
                {
                  simple: true,
                  onClick: closeInfoModal,
                  className: classes.cancelBtn
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "buttons.cancel" })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__components_material_pro_CustomButtons_Button__["a" /* default */],
                {
                  type: "submit",
                  disabled: billing.deleting || billing.saving,
                  loading: billing.saving,
                  simple: true,
                  onClick: handleSubmit(function (values) {
                    return _this3.onSubmit(Object.assign({}, values, {
                      action: "save"
                    }));
                  }),
                  className: classes.submitBtn
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "buttons.save" })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_material_pro_Clearfix_Clearfix__["a" /* default */], null)
        )
      );
    }
  }]);

  return BillingFrom;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var validate = function validate(values) {
  var errors = {};
  var emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!values.email) {
    errors.email = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.email.empty" });
  } else if (!emailFormat.test(values.email)) {
    errors.email = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.email.invalid" });
  }
  if (!values.name) {
    errors.name = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.name.empty" });
  }
  if (!values.country) {
    errors.country = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.country.empty" });
  }
  if (!values.region && values.country === "United States") {
    errors.region = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.state.empty" });
  }
  if (!values.zip) {
    errors.zip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.zipCode.empty" });
  }
  if (!values.cardName) {
    errors.cardName = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_redux_i18n__["Translate"], { value: "validations.cardName.empty" });
  }
  return errors;
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var billing = _ref3.billing,
      company = _ref3.company;
  return { billing: billing, company: company };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_redux_es_bindActionCreators__["a" /* default */])({
    getCreditDetails: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["I" /* getCreditDetails */],
    createOrUpdateCredit: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["z" /* createOrUpdateCredit */],
    toggleCreditDetails: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["P" /* toggleCreditDetails */],
    openConfirmationModal: __WEBPACK_IMPORTED_MODULE_17__components_confirmation_modal_ConfirmationModalActions__["d" /* openConfirmationModal */],
    closeInfoModal: __WEBPACK_IMPORTED_MODULE_20__edit_info_EditInfoActions__["c" /* closeInfoModal */],
    deleteCredit: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["B" /* deleteCredit */]
  }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__["a" /* default */])(function (_ref4) {
  var billing = _ref4.billing;
  return { initialValues: billing.customer };
})(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_es_reduxForm__["a" /* default */])({
  form: "BillingFrom",
  validate: validate,
  enableReinitialize: true
})(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_8_react_stripe_elements__["injectStripe"])(Object(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_19__jss_InjectedCheckoutFormStyles__["a" /* default */])(BillingFrom))))));

/***/ }),

/***/ 1198:
/*!**************************************************!*\
  !*** ./src/assets/jss/reduxFields/ReduxField.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__ = __webpack_require__(/*! ../material-dashboard-pro-react.jsx */ 175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(/*! ../material-dashboard-pro-react/customCheckboxRadioSwitch.jsx */ 2358);
// ##############################
// // // ValidationForms view styles
// #############################




var reduxFieldStyles = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */], {
    cardTitle: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["a" /* cardTitle */], {
        color: "#FFFFFF"
    }),
    cardIconTitle: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["a" /* cardTitle */], {
        marginTop: "15px",
        marginBottom: "0px"
    }),
    formCategory: {
        marginBottom: "0",
        color: "#999999",
        fontSize: "14px",
        padding: "10px 0 10px"
    },
    center: {
        textAlign: "center"
    },
    justifyContentCenter: {
        justifyContent: "center"
    },
    registerButton: {
        float: "right"
    },
    formGroup: {
        paddingTop: "12px"
    },
    inlineFormControl: {
        margin: '0'
    },
    inputLabel: {
        top: '10px',
        color: '#AAAAAA !important',
        fontSize: '14px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.42857',
        zIndex: '1'
    }
});

/* harmony default export */ __webpack_exports__["a"] = (reduxFieldStyles);

/***/ }),

/***/ 1202:
/*!******************************************************************!*\
  !*** ./src/containers/billing/jss/InjectedCheckoutFormStyles.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common__ = __webpack_require__(/*! @material-ui/core/colors/common */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(/*! ../../../assets/jss/material-dashboard-pro-react.jsx */ 175);


var white = __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_common___default.a.white;
var red500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default.a['500'];
// import { cardTitle } from "../../../assets/jss/material-dashboard-pro-react.jsx";


var injectedCheckoutFormStyles = function injectedCheckoutFormStyles(theme) {
    return {
        formWrapper: {
            paddingBottom: '30px'
        },
        formLabel: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            margin: '23px 0',
            '& > div': {
                padding: '0'
            },
            '@media screen and (max-width: 600px)': {
                margin: '6px 0'
            }
        },
        formLabelCvv: {
            float: 'right',
            display: 'flex',
            flexDirection: 'column',
            marginTop: '30px',
            position: 'absolute',
            right: '10%',
            zIndex: '0',
            '& > div': {
                padding: '0'
            },
            '@media screen and (max-width: 600px)': {
                marginTop: '12px !important'
            },
            '@media screen and (max-width: 599px)': {
                right: '6%'
            }
        },
        formInput: {
            background: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            boxShadow: 'inset 4px 4px 4px rgba(0, 0, 0, 0.06)',
            borderRadius: '5px',
            padding: '18px !important',
            '& input': {
                padding: '0'
            }
        },
        formInputField: {
            background: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            boxShadow: 'inset 4px 4px 4px rgba(0, 0, 0, 0.06)',
            borderRadius: '5px',
            padding: '17.3px !important',
            outline: 'none'
        },
        frontCard: {
            background: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.34)',
            boxSizing: 'border-box',
            borderRadius: '5px',
            maxWidth: '79.04%',
            position: 'relative',
            zIndex: '1'
        },
        backCard: {
            position: 'absolute',
            border: '1px solid rgba(0, 0, 0, 0.14)',
            top: '3%',
            right: '4.7%',
            maxWidth: '79.04%',
            background: '#F1F1F1',
            height: '34.445%',
            borderRadius: '5px',
            zIndex: '0',
            '@media screen and (max-width: 599px)': {
                height: '28.445%',
                right: '8.7%'
            }
        },
        backCardGridItem: {
            padding: '0 !important'
        },
        backCardStripe: {
            background: '#D6D6D6',
            height: '70px',
            marginTop: '14px'
        },
        modalActionsContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            marginTop: '10px',
            '@media screen and (max-width: 611px)': {
                justifyContent: 'center'
            }
        },
        deleteBillingBtn: {
            padding: '9px 30px !important',
            background: '#fff !important',
            border: '3px solid !important',
            color: '#B9002C !important',
            borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(185, 0, 44, 0) 100%), linear-gradient(0deg, #B9002C, #B9002C) 1 strech !important'
        },
        cancelBtn: {
            background: '#000 !important',
            boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35) !important',
            borderRadius: '3px !important',
            width: '122px !important',
            color: '#FFFFFF !important'
        },
        submitBtn: {
            background: '#1B23ED !important',
            boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35) !important',
            borderRadius: '3px !important',
            width: '122px !important',
            color: '#FFFFFF !important'
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (injectedCheckoutFormStyles);

/***/ }),

/***/ 1203:
/*!*****************************************************************!*\
  !*** ./src/components/reduxFields/ReduxInsideLabelTextField.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_FormControl_FormControl__ = __webpack_require__(/*! @material-ui/core/es/FormControl/FormControl */ 337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_FormHelperText_FormHelperText__ = __webpack_require__(/*! @material-ui/core/es/FormHelperText/FormHelperText */ 338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_pro_CustomInput_CustomInput__ = __webpack_require__(/*! ../material-pro/CustomInput/CustomInput */ 2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_jss_reduxFields_ReduxField__ = __webpack_require__(/*! ../../assets/jss/reduxFields/ReduxField */ 1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_Grow_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow/Grow */ 217);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ReduxInsideLabelTextField = function (_Component) {
    _inherits(ReduxInsideLabelTextField, _Component);

    function ReduxInsideLabelTextField() {
        _classCallCheck(this, ReduxInsideLabelTextField);

        return _possibleConstructorReturn(this, (ReduxInsideLabelTextField.__proto__ || Object.getPrototypeOf(ReduxInsideLabelTextField)).apply(this, arguments));
    }

    _createClass(ReduxInsideLabelTextField, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                input = _props.input,
                label = _props.label,
                meta = _props.meta,
                explanation = _props.explanation,
                classes = _props.classes,
                required = _props.required,
                rest = _objectWithoutProperties(_props, ["input", "label", "meta", "explanation", "classes", "required"]);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_FormControl_FormControl__["a" /* default */],
                { error: meta.error && meta.touched, fullWidth: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_pro_CustomInput_CustomInput__["a" /* default */], {
                    id: input.name,
                    labelText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        label,
                        " ",
                        required ? ' *' : ''
                    ),
                    formControlProps: { fullWidth: true },
                    inputProps: Object.assign({}, input, rest)
                    // classes={{formControl: classes.inlineFormControl}}
                    , error: meta.error && meta.touched
                }),
                meta.error && meta.touched && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_Grow_Grow__["a" /* default */],
                    { "in": meta.error && meta.touched },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_FormHelperText_FormHelperText__["a" /* default */],
                        null,
                        meta.error
                    )
                )
            );
        }
    }]);

    return ReduxInsideLabelTextField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__assets_jss_reduxFields_ReduxField__["a" /* default */])(ReduxInsideLabelTextField));

/***/ }),

/***/ 1204:
/*!**************************************************************!*\
  !*** ./src/components/material-pro/CustomButtons/Button.jsx ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(/*! ../../../assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx */ 2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_CircularProgress_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress/CircularProgress */ 193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Button_Button__ = __webpack_require__(/*! @material-ui/core/es/Button/Button */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }


// nodejs library that concatenates classes

// material-ui components






function RegularButton(_ref) {
    var _classNames, _classNames2;

    var props = _objectWithoutProperties(_ref, []);

    var classes = props.classes,
        color = props.color,
        round = props.round,
        children = props.children,
        fullWidth = props.fullWidth,
        disabled = props.disabled,
        loading = props.loading,
        simple = props.simple,
        size = props.size,
        block = props.block,
        link = props.link,
        justIcon = props.justIcon,
        className = props.className,
        muiClasses = props.muiClasses,
        rest = _objectWithoutProperties(props, ["classes", "color", "round", "children", "fullWidth", "disabled", "loading", "simple", "size", "block", "link", "justIcon", "className", "muiClasses"]);

    var btnClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, _defineProperty(_classNames, classes.button, true), _defineProperty(_classNames, classes[size], size), _defineProperty(_classNames, classes[color], color), _defineProperty(_classNames, classes.round, round), _defineProperty(_classNames, classes.fullWidth, fullWidth), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.simple, simple), _defineProperty(_classNames, classes.block, block), _defineProperty(_classNames, classes.link, link), _defineProperty(_classNames, classes.justIcon, justIcon), _defineProperty(_classNames, className, className), _classNames));
    var loadingClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, classes.loadingContainerSimple, simple), _defineProperty(_classNames2, classes.loadingContainer, true), _classNames2));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Button_Button__["a" /* default */],
        Object.assign({}, rest, { classes: muiClasses, className: btnClasses }),
        loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: loadingClasses },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_CircularProgress_CircularProgress__["a" /* default */], { size: 16, color: "inherit" })
        ) : children
    );
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */], { withTheme: true })(RegularButton));

/***/ }),

/***/ 1205:
/*!****************************************************!*\
  !*** ./src/components/material-pro/Modal/Modal.js ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_jss_material_dashboard_pro_react_modalStyle__ = __webpack_require__(/*! ../../../assets/jss/material-dashboard-pro-react/modalStyle */ 2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_Dialog_Dialog__ = __webpack_require__(/*! @material-ui/core/es/Dialog/Dialog */ 1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Grow_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow/Grow */ 217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_DialogTitle_DialogTitle__ = __webpack_require__(/*! @material-ui/core/es/DialogTitle/DialogTitle */ 1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_DialogContent_DialogContent__ = __webpack_require__(/*! @material-ui/core/es/DialogContent/DialogContent */ 1173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal() {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    _createClass(Modal, [{
        key: "render",
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                classes = _props.classes,
                onClose = _props.onClose,
                open = _props.open,
                content = _props.content,
                title = _props.title,
                medium = _props.medium,
                small = _props.small,
                rest = _objectWithoutProperties(_props, ["classes", "onClose", "open", "content", "title", "medium", "small"]);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_Dialog_Dialog__["a" /* default */],
                Object.assign({
                    fullWidth: true,
                    disableEnforceFocus: true,
                    classes: {
                        root: classes.modalRoot,
                        paper: medium ? __WEBPACK_IMPORTED_MODULE_4_classnames__((_classnames = {}, _defineProperty(_classnames, classes.modal, true), _defineProperty(_classnames, classes.medium, !small), _classnames)) : __WEBPACK_IMPORTED_MODULE_4_classnames__((_classnames2 = {}, _defineProperty(_classnames2, classes.modal, true), _defineProperty(_classnames2, classes.big, !small), _classnames2))
                    },
                    open: !!open
                    // TransitionComponent={(props) => <Grow unmountOnExit mountOnEnter {...props}/>}
                    , TransitionComponent: __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Grow_Grow__["a" /* default */],
                    onClose: onClose
                }, rest),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_DialogTitle_DialogTitle__["a" /* default */],
                    { className: classes.modalTitle },
                    title
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_DialogContent_DialogContent__["a" /* default */],
                    {
                        id: "modal-slide-description",
                        className: classes.modalBody },
                    content
                )
            );
        }
    }]);

    return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__assets_jss_material_dashboard_pro_react_modalStyle__["a" /* default */])(Modal));

/***/ }),

/***/ 124:
/*!***********************************************************************!*\
  !*** ./src/components/confirmation-modal/ConfirmationModalActions.js ***!
  \***********************************************************************/
/*! exports provided: CLOSE_CONFIRMATION_MODAL, closeConfirmationModal, OPEN_CONFIRMATION_MODAL, openConfirmationModal */
/*! exports used: CLOSE_CONFIRMATION_MODAL, OPEN_CONFIRMATION_MODAL, closeConfirmationModal, openConfirmationModal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeConfirmationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_CONFIRMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openConfirmationModal; });

var CLOSE_CONFIRMATION_MODAL = 'CLOSE_CONFIRMATION_MODAL';
var closeConfirmationModal = function closeConfirmationModal() {
    return { type: CLOSE_CONFIRMATION_MODAL };
};

var OPEN_CONFIRMATION_MODAL = 'OPEN_CONFIRMATION_MODAL';
var openConfirmationModal = function openConfirmationModal(_ref) {
    var text = _ref.text,
        callback = _ref.callback,
        confirmCheckbox = _ref.confirmCheckbox,
        btn1 = _ref.btn1,
        btn2 = _ref.btn2;
    return {
        type: OPEN_CONFIRMATION_MODAL,
        payload: { text: text, callback: callback, confirmCheckbox: confirmCheckbox, btn1: btn1, btn2: btn2 }
    };
};

/***/ }),

/***/ 1310:
/*!************************!*\
  !*** multi ./entry.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/elly.s/self-portal-client/entry.js */1311);


/***/ }),

/***/ 1311:
/*!******************!*\
  !*** ./entry.js ***!
  \******************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(/*! react-dom */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_Main__ = __webpack_require__(/*! ./src/Main */ 1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reset_css__ = __webpack_require__(/*! reset-css */ 3234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_styles_scss__ = __webpack_require__(/*! ./src/styles.scss */ 3235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__ = __webpack_require__(/*! font-awesome/css/font-awesome.css */ 3236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flexboxgrid_css_flexboxgrid_css__ = __webpack_require__(/*! flexboxgrid/css/flexboxgrid.css */ 3237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flexboxgrid_css_flexboxgrid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_flexboxgrid_css_flexboxgrid_css__);
/* eslint-disable import/default */



// import injectTapEventPlugin from 'react-tap-event-plugin';

// require('./static/favicon.ico');




// try {  // DEPRECATED READ HERE https://www.npmjs.com/package/react-tap-event-plugin Since the problem it solves has been fixed in most browsers by now you should migrate away from this plugin.
//   injectTapEventPlugin();
// }
// catch(e) {
//   console.warn( e );
// }

Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_Main__["a" /* default */], null), document.getElementById('app'));

/***/ }),

/***/ 1316:
/*!*********************!*\
  !*** ./src/Main.js ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_styles_css__ = __webpack_require__(/*! ../css/styles.css */ 1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(/*! react-router-dom */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_login_Login__ = __webpack_require__(/*! ./containers/login/Login */ 1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_reducers__ = __webpack_require__(/*! ./redux/reducers */ 1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_app_App__ = __webpack_require__(/*! ./containers/app/App */ 1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_middlewares_index__ = __webpack_require__(/*! ./redux/middlewares/index */ 3098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(/*! react-router */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_jssPreset__ = __webpack_require__(/*! @material-ui/core/styles/jssPreset */ 405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_jssPreset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_jssPreset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_createGenerateClassName__ = __webpack_require__(/*! @material-ui/core/styles/createGenerateClassName */ 406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_createGenerateClassName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_createGenerateClassName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_jss_lib_JssProvider__ = __webpack_require__(/*! react-jss/lib/JssProvider */ 920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_jss_lib_JssProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_jss_lib_JssProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jss__ = __webpack_require__(/*! jss */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_observable__ = __webpack_require__(/*! redux-observable */ 1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__redux_epics__ = __webpack_require__(/*! ./redux/epics */ 3226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_ajax__ = __webpack_require__(/*! rxjs/ajax */ 3228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_build_url__ = __webpack_require__(/*! build-url */ 3231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_build_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_build_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_js_cookie__ = __webpack_require__(/*! js-cookie */ 3232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_ga__ = __webpack_require__(/*! react-router-ga */ 3233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_router_ga__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











// import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';



// import JssProvider from 'react-jss';









var ajaxWithXSRF = function ajaxWithXSRF(method) {
    return function (url, body, queryParams) {
        return Object(__WEBPACK_IMPORTED_MODULE_16_rxjs_ajax__["a" /* ajax */])({
            url: __WEBPACK_IMPORTED_MODULE_17_build_url___default()(url, { queryParams: method === 'GET' ? body : queryParams }),
            method: method,
            crossDomain: true,
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_18_js_cookie___default.a.get('XSRF-TOKEN')
            },
            body: method === 'GET' ? undefined : body
        });
    };
};

var epicMiddleware = Object(__WEBPACK_IMPORTED_MODULE_14_redux_observable__["b" /* createEpicMiddleware */])({
    dependencies: {
        sendPost: ajaxWithXSRF('POST'),
        sendPut: ajaxWithXSRF('PUT'),
        sendGet: ajaxWithXSRF('GET'),
        sendDelete: ajaxWithXSRF('DELETE')
    }
});

var generateClassName = __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles_createGenerateClassName___default()();
var jss = Object(__WEBPACK_IMPORTED_MODULE_13_jss__["create"])(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_jssPreset___default()());
// const store = createStore(combineReducers(reducers), applyMiddleware(apiMiddleware(axiosApi), logger));
// const store = createStore(combineReducers(reducers), applyMiddleware(...middlewares));

var store = Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_5_redux__["a" /* applyMiddleware */].apply(undefined, _toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__redux_middlewares_index__["a" /* default */]).concat([epicMiddleware])))(__WEBPACK_IMPORTED_MODULE_5_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_5_redux__["c" /* combineReducers */])(__WEBPACK_IMPORTED_MODULE_6__redux_reducers__["a" /* default */]));

// export const store = compose(applyMiddleware(...middlewares,epicMiddleware))(createStore)(combineReducers(reducers),window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

epicMiddleware.run(__WEBPACK_IMPORTED_MODULE_14_redux_observable__["a" /* combineEpics */].apply(undefined, _toConsumableArray(__WEBPACK_IMPORTED_MODULE_15__redux_epics__["a" /* default */])));

var Main = function Main() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],
        { store: store },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_jss_lib_JssProvider___default.a,
            { jss: jss, generateClassName: generateClassName },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["BrowserRouter"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19_react_router_ga___default.a,
                    { id: 'UA-63376517-7' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9_react_router__["g" /* Switch */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { exact: true, path: '/login', component: __WEBPACK_IMPORTED_MODULE_3__containers_login_Login__["a" /* default */] }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: '/', component: __WEBPACK_IMPORTED_MODULE_7__containers_app_App__["a" /* default */] })
                    )
                )
            )
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),

/***/ 1317:
/*!************************!*\
  !*** ./css/styles.css ***!
  \************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1329:
/*!***************************************!*\
  !*** ./src/containers/login/Login.js ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_grey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_common__ = __webpack_require__(/*! @material-ui/core/colors/common */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_common__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var grey500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_grey___default.a['500'];
var white = __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_common___default.a.white;
// import PersonAdd from 'material-ui/svg-icons/social/person-add';
// import Help from 'material-ui/svg-icons/action/help';
// import TextField from 'material-ui/TextField';
// import ThemeDefault from '../theme-default';

var Login = function (_Component) {
    _inherits(Login, _Component);

    function Login() {
        _classCallCheck(this, Login);

        return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
    }

    _createClass(Login, [{
        key: 'checkPopup',
        value: function checkPopup(popup) {
            var check = setInterval(function () {
                if (!popup || popup.closed || popup.closed === undefined) {
                    clearInterval(check);
                    window.location.replace('/');
                }
            }, 1000);
        }
    }, {
        key: 'startAuth',
        value: function startAuth() {
            window.popup = Login.openPopup('/auth/login');
            this.checkPopup(window.popup);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            // this.startAuth();
            window.location.replace('/auth/login');
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
            {/*<MuiThemeProvider muiTheme={ThemeDefault}>*/}
            {/*<div>*/}
            {/*<div style={styles.loginContainer}>*/}

            {/*<Paper style={styles.paper}>*/}

            {/*<form>*/}
            {/*<TextField*/}
            {/*hintText="E-mail"*/}
            {/*floatingLabelText="E-mail"*/}
            {/*fullWidth={true}*/}
            {/*/>*/}
            {/*<TextField*/}
            {/*hintText="Password"*/}
            {/*floatingLabelText="Password"*/}
            {/*fullWidth={true}*/}
            {/*type="password"*/}
            {/*/>*/}

            {/*<div>*/}
            {/*<Checkbox*/}
            {/*label="Remember me"*/}
            {/*style={styles.checkRemember.style}*/}
            {/*labelStyle={styles.checkRemember.labelStyle}*/}
            {/*iconStyle={styles.checkRemember.iconStyle}*/}
            {/*/>*/}

            {/*<Link to="/">*/}
            {/*<RaisedButton label="Login"*/}
            {/*primary={true}*/}
            {/*style={styles.loginBtn}/>*/}
            {/*</Link>*/}
            {/*</div>*/}
            {/*</form>*/}
            {/*</Paper>*/}

            {/*<div style={styles.buttonsDiv}>*/}
            {/*<FlatButton*/}
            {/*label="Register"*/}
            {/*href="/"*/}
            {/*style={styles.flatButton}*/}
            {/*icon={<PersonAdd/>}*/}
            {/*/>*/}

            {/*<FlatButton*/}
            {/*label="Forgot Password?"*/}
            {/*href="/"*/}
            {/*style={styles.flatButton}*/}
            {/*icon={<Help/>}*/}
            {/*/>*/}
            {/*</div>*/}

            {/*<div style={styles.buttonsDiv}>*/}
            {/*<Link to="/" style={{...styles.btn, ...styles.btnFacebook}}>*/}
            {/*<i className="fa fa-facebook fa-lg"/>*/}
            {/*<span style={styles.btnSpan}>Log in with Facebook</span>*/}
            {/*</Link>*/}
            {/*<Link to="/" style={{...styles.btn, ...styles.btnGoogle}}>*/}
            {/*<i className="fa fa-google-plus fa-lg"/>*/}
            {/*<span style={styles.btnSpan}>Log in with Google</span>*/}
            {/*</Link>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*</div>*/}
            {/*</MuiThemeProvider>*/}
        }
    }], [{
        key: 'openPopup',
        value: function openPopup(url) {
            var width = 600,
                height = 600;
            var left = window.innerWidth / 2 - width / 2;
            var top = window.innerHeight / 2 - height / 2;

            return window.open(url, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, \n      scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', \n      height=' + height + ', top=' + top + ', left=' + left);
        }
    }]);

    return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = {
    loginContainer: {
        minWidth: 320,
        maxWidth: 400,
        height: 'auto',
        position: 'absolute',
        top: '20%',
        left: 0,
        right: 0,
        margin: 'auto'
    },
    paper: {
        padding: 20,
        overflow: 'auto'
    },
    buttonsDiv: {
        textAlign: 'center',
        padding: 10
    },
    flatButton: {
        color: grey500
    },
    checkRemember: {
        style: {
            float: 'left',
            maxWidth: 180,
            paddingTop: 5
        },
        labelStyle: {
            color: grey500
        },
        iconStyle: {
            color: grey500,
            borderColor: grey500,
            fill: grey500
        }
    },
    loginBtn: {
        float: 'right'
    },
    btn: {
        background: '#4f81e9',
        color: white,
        padding: 7,
        borderRadius: 2,
        margin: 2,
        fontSize: 13
    },
    btnFacebook: {
        background: '#4f81e9'
    },
    btnGoogle: {
        background: '#e14441'
    },
    btnSpan: {
        marginLeft: 5
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),

/***/ 1344:
/*!*******************************!*\
  !*** ./src/redux/reducers.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_app_AppReducer__ = __webpack_require__(/*! ../containers/app/AppReducer */ 1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_delete_account_DeleteAccountReducer__ = __webpack_require__(/*! ../containers/delete-account/DeleteAccountReducer */ 1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_devices_DevicesReducer__ = __webpack_require__(/*! ../containers/devices/DevicesReducer */ 1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_signature_SignatureReducer__ = __webpack_require__(/*! ../containers/signature/SignatureReducer */ 1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_brand_BrandReducer__ = __webpack_require__(/*! ../components/brand/BrandReducer */ 1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_notifications_NotificationsReducer__ = __webpack_require__(/*! ../components/notifications/NotificationsReducer */ 1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_confirmation_modal_ConfirmationModalReducer__ = __webpack_require__(/*! ../components/confirmation-modal/ConfirmationModalReducer */ 1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_billing_components_edit_info_EditInfoReducer__ = __webpack_require__(/*! ../containers/billing/components/edit-info/EditInfoReducer */ 1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_information_modal_InformationModalReducer__ = __webpack_require__(/*! ../components/information-modal/InformationModalReducer */ 1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_login_LoginReducer__ = __webpack_require__(/*! ../containers/login/LoginReducer */ 1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_settings_SettingsReducer__ = __webpack_require__(/*! ../containers/settings/SettingsReducer */ 1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_billing_BillingReducer__ = __webpack_require__(/*! ../containers/billing/BillingReducer */ 1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_form__ = __webpack_require__(/*! redux-form */ 1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_redux_i18n__);











// import { Reducers } from '@int/rich-text-signature-redux';




 //b
// import {rootReducer as ultimaDDManager} from '@int/react-manage-members';//b
 //b

/* harmony default export */ __webpack_exports__["a"] = ({
    app: __WEBPACK_IMPORTED_MODULE_0__containers_app_AppReducer__["a" /* default */],
    account: __WEBPACK_IMPORTED_MODULE_1__containers_delete_account_DeleteAccountReducer__["a" /* default */],
    brand: __WEBPACK_IMPORTED_MODULE_4__components_brand_BrandReducer__["a" /* default */],
    confirmationModal: __WEBPACK_IMPORTED_MODULE_6__components_confirmation_modal_ConfirmationModalReducer__["a" /* default */],
    infoModal: __WEBPACK_IMPORTED_MODULE_7__containers_billing_components_edit_info_EditInfoReducer__["a" /* default */],
    informationModal: __WEBPACK_IMPORTED_MODULE_8__components_information_modal_InformationModalReducer__["a" /* default */],
    devices: __WEBPACK_IMPORTED_MODULE_2__containers_devices_DevicesReducer__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_5__components_notifications_NotificationsReducer__["a" /* default */],
    signature: __WEBPACK_IMPORTED_MODULE_3__containers_signature_SignatureReducer__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_9__containers_login_LoginReducer__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_10__containers_settings_SettingsReducer__["a" /* default */],
    billing: __WEBPACK_IMPORTED_MODULE_12__containers_billing_BillingReducer__["a" /* default */], //B
    form: __WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* reducer */],
    // ultimaDDManager,
    i18n: __WEBPACK_IMPORTED_MODULE_14_react_redux_i18n__["i18nReducer"]
});

/***/ }),

/***/ 1345:
/*!******************************************!*\
  !*** ./src/containers/app/AppReducer.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppActions__ = __webpack_require__(/*! ./AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__signature_SignatureActions__ = __webpack_require__(/*! ../signature/SignatureActions */ 369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delete_account_DeleteAccountActions__ = __webpack_require__(/*! ../delete-account/DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_brand_BrandActions__ = __webpack_require__(/*! ../../components/brand/BrandActions */ 699);






var INITIAL_STATE = {
    page: '',
    snackBar: '',
    loading: false,
    loadingBackDrop: false,
    leftDrawer: false,
    mainElement: null,
    env: 'production',
    stripe: { enabled: true }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__AppActions__["a" /* CHANGE_PAGE_HEADER */]:
            return Object.assign({}, state, action.payload);
        case __WEBPACK_IMPORTED_MODULE_0__AppActions__["e" /* SET_MAIN_ELEMENT */]:
            return Object.assign({}, state, { mainElement: action.payload });
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["k" /* GET_ENV */]:
            return Object.assign({}, state, { env: action.payload.data });
        case __WEBPACK_IMPORTED_MODULE_2__delete_account_DeleteAccountActions__["e" /* GET_DESTROY_STATUS_START */]:
        case __WEBPACK_IMPORTED_MODULE_2__delete_account_DeleteAccountActions__["c" /* GET_ACCOUNT_PII_START */]:
        case __WEBPACK_IMPORTED_MODULE_4__components_brand_BrandActions__["a" /* GET_BRAND_START */]:
            return Object.assign({}, state, { loading: true });
        case __WEBPACK_IMPORTED_MODULE_1__signature_SignatureActions__["e" /* FETCH_SIGNATURE_START */]:
            return Object.assign({}, state, { loading: true });
        case __WEBPACK_IMPORTED_MODULE_1__signature_SignatureActions__["f" /* FETCH_SIGNATURE_SUCCESS */]:
            return Object.assign({}, state, { data: action.payload, loading: false });
        case __WEBPACK_IMPORTED_MODULE_1__signature_SignatureActions__["d" /* FETCH_SIGNATURE_FAILURE */]:
            return Object.assign({}, state, { data: action.payload, loading: false });

        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["i" /* GET_DESTROY_STATUS */]:
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["d" /* GET_ACCOUNT_PII */]:
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["f" /* GET_ANY_MAIL_ACCOUNT_PII */]:
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["h" /* GET_BRAND */]:
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["a" /* DELETE_SHARE */]:
            return Object.assign({}, state, { loading: false });
        case __WEBPACK_IMPORTED_MODULE_2__delete_account_DeleteAccountActions__["b" /* DESTROY_ACCOUNT_START */]:
            return Object.assign({}, state, { loadingBackDrop: true });
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["b" /* DESTROY_ACCOUNT */]:
        case __WEBPACK_IMPORTED_MODULE_3__redux_types__["c" /* DESTROY_ANY_MAIL_ACCOUNT */]:
            return Object.assign({}, state, { loadingBackDrop: false });
        case __WEBPACK_IMPORTED_MODULE_0__AppActions__["c" /* GET_API_CONFIG_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__AppActions__["b" /* GET_API_CONFIG */]:
            if (action.error) {
                return Object.assign({}, state, { error: action.payload.message, fetching: false });
            }
            return Object.assign({}, state, action.payload.data, { fetching: false });
    }
    return state;
});

/***/ }),

/***/ 1363:
/*!***************************************************************!*\
  !*** ./src/containers/delete-account/DeleteAccountReducer.js ***!
  \***************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeleteAccountActions__ = __webpack_require__(/*! ./DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);




var INITIAL_STATE = {
    fetching: false,
    fetchingPii: false,
    fetchingPiiStatus: true,
    destroy: {},
    pii: {},
    piiStatus: {},
    brandsPii: {},
    deletingShare: false,
    deleteShareStatus: {}
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__DeleteAccountActions__["b" /* DESTROY_ACCOUNT_START */]:
            return Object.assign({}, state, { fetching: true, destroy: {} });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["b" /* DESTROY_ACCOUNT */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, destroy: {} });
            }
            return Object.assign({}, state, { fetching: false, destroy: {}, pii: {} });
        case __WEBPACK_IMPORTED_MODULE_0__DeleteAccountActions__["e" /* GET_DESTROY_STATUS_START */]:
            return Object.assign({}, state, { fetching: true, destroy: {} });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["i" /* GET_DESTROY_STATUS */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, destroy: {} });
            }
            return Object.assign({}, state, { fetching: false, destroy: action.payload.data });
        case __WEBPACK_IMPORTED_MODULE_0__DeleteAccountActions__["c" /* GET_ACCOUNT_PII_START */]:
            return Object.assign({}, state, { fetchingPii: true, pii: {} });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["d" /* GET_ACCOUNT_PII */]:
            if (action.error) {
                return Object.assign({}, state, { fetchingPii: false, pii: {} });
            }
            var data = action.payload.data;

            return Object.assign({}, state, { fetchingPii: false, pii: Object.assign({}, data, { userInfo: data.userInfo && data.userInfo.filter(function (item) {
                        return item.phone;
                    }) }) });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["f" /* GET_ANY_MAIL_ACCOUNT_PII */]:
            if (action.error) {
                return Object.assign({}, state, { fetchingPii: false, pii: {} });
            }
            return Object.assign({}, state, { fetchingPii: false, brandsPii: action.payload.data });
        case __WEBPACK_IMPORTED_MODULE_0__DeleteAccountActions__["d" /* GET_ACCOUNT_PII_STATUS_START */]:
            return Object.assign({}, state, { fetchingPiiStatus: true, piiStatus: false, pii: {} });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["e" /* GET_ACCOUNT_PII_STATUS */]:
            if (action.error) {
                return Object.assign({}, state, { fetchingPiiStatus: false });
            }
            return Object.assign({}, state, { fetchingPiiStatus: false, piiStatus: action.payload.data.isPiiExist });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["g" /* GET_ANY_MAIL_ACCOUNT_PII_STATUS */]:
            if (action.error) {
                return Object.assign({}, state, { fetchingPiiStatus: false });
            }
            return Object.assign({}, state, { fetchingPiiStatus: false, piiStatus: action.payload.data });

        case __WEBPACK_IMPORTED_MODULE_0__DeleteAccountActions__["a" /* DELETE_SHARE_START */]:
            return Object.assign({}, state, { deletingShare: true, deleteShareStatus: {} });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["a" /* DELETE_SHARE */]:
            if (action.error) {
                return Object.assign({}, state, { deletingShare: false, deleteShareStatus: { result: "error" } });
            }

            if (state.pii && state.pii.uploadsInfo && action.payload && action.payload.data && action.payload.data.url) {
                state.pii.uploadsInfo = state.pii.uploadsInfo.filter(function (obj) {
                    return obj.url != action.payload.data.url;
                });
            }

            return Object.assign({}, state, { deletingShare: false, deleteShareStatus: action.payload.data });
    }
    return state;
});

/***/ }),

/***/ 1364:
/*!**************************************************!*\
  !*** ./src/containers/devices/DevicesReducer.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DevicesActions__ = __webpack_require__(/*! ./DevicesActions */ 370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);



var INITIAL_STATE = { devices: [], features_with_action: [], fetching: false };

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__DevicesActions__["a" /* GET_DEVICES_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_1__redux_types__["j" /* GET_DEVICES */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false });
            }
            return Object.assign({}, state, action.payload.data, { fetching: false });
    }
    return state;
});

/***/ }),

/***/ 1365:
/*!******************************************************!*\
  !*** ./src/containers/signature/SignatureReducer.js ***!
  \******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignatureActions__ = __webpack_require__(/*! ./SignatureActions */ 369);


var INITIAL_STATE = { fetching: false };

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];


    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["k" /* SAVE_SIGNATURE_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["l" /* SAVE_SIGNATURE_SUCCESS */]:
            return Object.assign({}, state, action.payload, { fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["j" /* SAVE_SIGNATURE_FAILURE */]:
            return Object.assign({}, state, action.payload, { fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["e" /* FETCH_SIGNATURE_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["f" /* FETCH_SIGNATURE_SUCCESS */]:
            return Object.assign({}, state, action.payload, { fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["d" /* FETCH_SIGNATURE_FAILURE */]:
            return Object.assign({}, state, action.payload, { fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["h" /* FETCH_TWEETS_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["i" /* FETCH_TWEETS_SUCCESS */]:
            return Object.assign({}, state, { tweets: action.payload, fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["g" /* FETCH_TWEETS_FAILURE */]:
            return Object.assign({}, state, { error: action.payload, fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["b" /* FETCH_INSTAGRAM_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["c" /* FETCH_INSTAGRAM_SUCCESS */]:
            return Object.assign({}, state, { instagramPost: action.payload, fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__SignatureActions__["a" /* FETCH_INSTAGRAM_FAILURE */]:
            return Object.assign({}, state, { error: action.payload, fetching: false });
    }

    return state;
});

/***/ }),

/***/ 1366:
/*!**********************************************!*\
  !*** ./src/components/brand/BrandReducer.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);


function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        name: '',
        domain: '',
        id: '',
        theme: '',
        favicon: '',
        support: '',
        fetching: true
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__redux_types__["h" /* GET_BRAND */]:
            return Object.assign({}, state, action.payload.data, { fetching: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 1367:
/*!**************************************************************!*\
  !*** ./src/components/notifications/NotificationsReducer.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationsActions__ = __webpack_require__(/*! ./NotificationsActions */ 700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_signature_SignatureActions__ = __webpack_require__(/*! ../../containers/signature/SignatureActions */ 369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);




var INITIAL_STATE = { text: '' };

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2__redux_types__["j" /* GET_DEVICES */]:
            if (action.error) {
                return { text: "Devices was not found. " + action.payload.message };
            }
            break;
        case __WEBPACK_IMPORTED_MODULE_1__containers_signature_SignatureActions__["l" /* SAVE_SIGNATURE_SUCCESS */]:
            return { text: 'Signature saved' };
        // case DESTROY_ACCOUNT:
        //     if(action.error){
        //         return {text: `Account was not deleted. ${action.payload.message}`};
        //     }
        //     return {text: 'Account deleted'};
        case __WEBPACK_IMPORTED_MODULE_2__redux_types__["i" /* GET_DESTROY_STATUS */]:
            if (action.error) {
                return { text: "Status was not found. " + action.payload.message };
            }
            break;
        case __WEBPACK_IMPORTED_MODULE_0__NotificationsActions__["a" /* CLOSE_NOTIFICATION */]:
            return INITIAL_STATE;
    }
    return state;
});

/***/ }),

/***/ 1368:
/*!***********************************************************************!*\
  !*** ./src/components/confirmation-modal/ConfirmationModalReducer.js ***!
  \***********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmationModalActions__ = __webpack_require__(/*! ./ConfirmationModalActions */ 124);


function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        text: '',
        open: false,
        callback: null
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__ConfirmationModalActions__["b" /* OPEN_CONFIRMATION_MODAL */]:
            return Object.assign({}, state, { open: true }, action.payload);
        case __WEBPACK_IMPORTED_MODULE_0__ConfirmationModalActions__["a" /* CLOSE_CONFIRMATION_MODAL */]:
            return Object.assign({}, state, { open: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 1369:
/*!************************************************************************!*\
  !*** ./src/containers/billing/components/edit-info/EditInfoReducer.js ***!
  \************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditInfoActions__ = __webpack_require__(/*! ./EditInfoActions */ 246);


function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        text: '',
        open: false,
        callback: null
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__EditInfoActions__["b" /* OPEN_INFO_MODAL */]:
            return Object.assign({}, state, { open: true }, action.payload);
        case __WEBPACK_IMPORTED_MODULE_0__EditInfoActions__["a" /* CLOSE_INFO_MODAL */]:
            return Object.assign({}, state, { open: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 1370:
/*!*********************************************************************!*\
  !*** ./src/components/information-modal/InformationModalReducer.js ***!
  \*********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InformationModalActions__ = __webpack_require__(/*! ./InformationModalActions */ 247);


function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        text: '',
        open: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__InformationModalActions__["b" /* OPEN_INFORMATION_MODAL */]:
            return Object.assign({}, state, { open: true }, action.payload);
        case __WEBPACK_IMPORTED_MODULE_0__InformationModalActions__["a" /* CLOSE_INFORMATION_MODAL */]:
            return Object.assign({}, state, { open: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 1371:
/*!**********************************************!*\
  !*** ./src/containers/login/LoginReducer.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginActions__ = __webpack_require__(/*! ./LoginActions */ 248);


var INITIAL_STATE = { isLogin: false, fetching: true, email: '' };

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["b" /* GET_USER_LOGIN_STATUS_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["a" /* GET_USER_LOGIN_STATUS */]:
            if (action.error) {
                return Object.assign({}, INITIAL_STATE, { fetching: false });
            }
            return Object.assign({}, state, action.payload.data, { isLogin: true, fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["c" /* SESSION_EXPIRED */]:
            return Object.assign({}, state, { fetching: false, isLogin: false });
    }
    return state;
});

/***/ }),

/***/ 1372:
/*!****************************************************!*\
  !*** ./src/containers/settings/SettingsReducer.js ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SettingsActions__ = __webpack_require__(/*! ./SettingsActions */ 701);


var INITIAL_STATE = { settings: null, fetching: false, needUpdate: false };

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__SettingsActions__["b" /* GET_SETTINGS_START */]:
            return Object.assign({}, state, { fetching: true, needUpdate: false });
        case __WEBPACK_IMPORTED_MODULE_0__SettingsActions__["a" /* GET_SETTINGS */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, needUpdate: false });
            }
            return Object.assign({}, state, action.payload.data, { fetching: false, needUpdate: false });
        case __WEBPACK_IMPORTED_MODULE_0__SettingsActions__["d" /* UPDATE_SETTINGS_START */]:
            return Object.assign({}, state, { fetching: false, needUpdate: false });
        case __WEBPACK_IMPORTED_MODULE_0__SettingsActions__["c" /* UPDATE_SETTINGS */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, needUpdate: false });
            }
            return Object.assign({}, state, action.payload.data, { fetching: false, needUpdate: true });
    }
    return state;
});

/***/ }),

/***/ 1373:
/*!**************************************************!*\
  !*** ./src/containers/billing/BillingReducer.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillingActions__ = __webpack_require__(/*! ./BillingActions */ 161);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var INITIAL_STATE = {
    invoices: [],
    fetching: false,
    saving: false,
    fetchingInvoices: false,
    error: '',
    customer: {},
    needUpdate: false,
    openCreditDetails: false,
    invoicesContent: [],
    plansContent: [], //B
    emailPlans: [], //B
    defaultPlan: {}

};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["n" /* GET_CREDIT_DETAILS_START */]:
            return Object.assign({}, state, INITIAL_STATE, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["m" /* GET_CREDIT_DETAILS */]:
            if (action.error || action.payload.response == undefined) {
                return Object.assign({}, state, { fetching: false, error: action.payload.message, customer: {}, needUpdate: false });
            }
            var _action$payload$respo = action.payload.response,
                city = _action$payload$respo.addressCity,
                country = _action$payload$respo.addressCountry,
                zip = _action$payload$respo.zipCode,
                region = _action$payload$respo.addressState;

            return Object.assign({}, state, {
                fetching: false,
                needUpdate: false,
                customer: Object.assign({}, action.payload.response, { city: city, country: country, region: region, zip: zip })
            });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["u" /* TOGGLE_CREDIT_DETAILS */]:
            return Object.assign({}, state, { openCreditDetails: !state.openCreditDetails });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["f" /* CREATE_OR_UPDATE_CREDIT_START */]:
            return Object.assign({}, state, { saving: true });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["e" /* CREATE_OR_UPDATE_CREDIT */]:
            if (action.error) {
                return Object.assign({}, state, { saving: false, error: action.payload.message });
            }
            return Object.assign({}, state, { saving: false, needUpdate: true, openCreditDetails: false });

        // plans
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["t" /* GET_PLANS_START */]:
            return Object.assign({}, state, INITIAL_STATE, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["s" /* GET_PLANS */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, error: action.payload.message, plansContent: {}, needUpdate: false });
            }
            return Object.assign({}, state, {
                fetching: false,
                needUpdate: false,
                plansContent: [].concat(_toConsumableArray(state.plansContent), _toConsumableArray(action.payload.response.content)),
                defaultPlan: action.payload.response.defaultPackage
            });

        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["r" /* GET_INVOICES_START */]:
            return Object.assign({}, state, INITIAL_STATE, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["q" /* GET_INVOICES */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, error: action.payload.message, invoicesContent: [], needUpdate: false });
            }
            return Object.assign({}, state, {
                fetching: false,
                needUpdate: false,
                invoicesContent: [].concat(_toConsumableArray(state.invoicesContent), _toConsumableArray(action.payload.response))
            });

        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["o" /* GET_EMAIL_PLANS */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, error: action.payload.message, plansContent: {}, needUpdate: false });
            }
            return Object.assign({}, state, {
                fetching: false,
                needUpdate: false,
                emailPlans: [].concat(_toConsumableArray(state.emailPlans), _toConsumableArray(action.payload.response))
            });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["h" /* DELETE_CREDIT_START */]:
            return Object.assign({}, state, { deleting: true });
        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["g" /* DELETE_CREDIT */]:
            if (action.error) {
                return Object.assign({}, state, { saving: false, needUpdate: true, error: action.payload.message });
            }
            return Object.assign({}, state, { deleting: false, needUpdate: true, openCreditDetails: false });

        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["a" /* ATTACH_PLAN_TO_CLIENT */]:
            return Object.assign({}, state, { needUpdate: true });

        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["k" /* DETACH_PLAN_FROM_CLIENT */]:
            return Object.assign({}, state, { needUpdate: true });

        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["i" /* DELETE_PLANS_FROM_CLIENT */]:
            return Object.assign({}, state, { needUpdate: true });

        case __WEBPACK_IMPORTED_MODULE_0__BillingActions__["c" /* CONFIRM_3D_SECURE */]:
            return Object.assign({}, state, { needUpdate: true });

    }
    return state;
});

/***/ }),

/***/ 144:
/*!***************************************************************!*\
  !*** ./src/containers/delete-account/DeleteAccountActions.js ***!
  \***************************************************************/
/*! exports provided: DESTROY_ACCOUNT_START, destroyAccount, GET_DESTROY_STATUS_START, getDestroyStatus, GET_ACCOUNT_PII_START, getAccountPII, GET_ACCOUNT_PII_STATUS_START, getAccountPIIStatus, DELETE_SHARE_START, deleteShare */
/*! exports used: DELETE_SHARE_START, DESTROY_ACCOUNT_START, GET_ACCOUNT_PII_START, GET_ACCOUNT_PII_STATUS_START, GET_DESTROY_STATUS_START, deleteShare, destroyAccount, getAccountPII, getAccountPIIStatus, getDestroyStatus */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DESTROY_ACCOUNT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return destroyAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_DESTROY_STATUS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDestroyStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ACCOUNT_PII_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAccountPII; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ACCOUNT_PII_STATUS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAccountPIIStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_SHARE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);




var DESTROY_ACCOUNT_START = "DESTROY_ACCOUNT_START";

var destroyAccount = function destroyAccount(email, brand, onSuccess, onFailure) {
    return function (dispatch) {
        dispatch({ type: DESTROY_ACCOUNT_START });

        dispatch({
            type: brand === 'AM' ? __WEBPACK_IMPORTED_MODULE_0__redux_types__["c" /* DESTROY_ANY_MAIL_ACCOUNT */] : __WEBPACK_IMPORTED_MODULE_0__redux_types__["b" /* DESTROY_ACCOUNT */],
            onSuccess: onSuccess,
            onFailure: onFailure,
            payload: email
        });
    };
};

var GET_DESTROY_STATUS_START = "GET_DESTROY_STATUS_START";

var getDestroyStatus = function getDestroyStatus(email) {
    return function (dispatch) {
        dispatch({ type: GET_DESTROY_STATUS_START });

        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_0__redux_types__["i" /* GET_DESTROY_STATUS */],
            payload: email
        });
    };
};

var GET_ACCOUNT_PII_START = "GET_ACCOUNT_PII_START";

var getAccountPII = function getAccountPII(email, brand) {
    return function (dispatch) {
        dispatch({ type: GET_ACCOUNT_PII_START });

        var type = brand === 'AM' ? __WEBPACK_IMPORTED_MODULE_0__redux_types__["f" /* GET_ANY_MAIL_ACCOUNT_PII */] : __WEBPACK_IMPORTED_MODULE_0__redux_types__["d" /* GET_ACCOUNT_PII */];

        dispatch({
            type: type,
            payload: email
        });
    };
};

var GET_ACCOUNT_PII_STATUS_START = "GET_ACCOUNT_PII_STATUS_START";

var getAccountPIIStatus = function getAccountPIIStatus(email, brand) {
    return function (dispatch) {
        dispatch({ type: GET_ACCOUNT_PII_STATUS_START });

        var type = brand === 'AM' ? __WEBPACK_IMPORTED_MODULE_0__redux_types__["g" /* GET_ANY_MAIL_ACCOUNT_PII_STATUS */] : __WEBPACK_IMPORTED_MODULE_0__redux_types__["e" /* GET_ACCOUNT_PII_STATUS */];
        dispatch({
            type: type,
            payload: email
        });
    };
};

var DELETE_SHARE_START = "DELETE_SHARE_START";

var deleteShare = function deleteShare(url) {
    return function (dispatch) {
        dispatch({ type: DELETE_SHARE_START });

        var type = __WEBPACK_IMPORTED_MODULE_0__redux_types__["a" /* DELETE_SHARE */];

        dispatch({
            type: type,
            payload: url
        });
    };
};

/***/ }),

/***/ 1545:
/*!*******************************************!*\
  !*** ./locale-data/complete.js (ignored) ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1550:
/*!***********************************!*\
  !*** ./src/containers/app/App.js ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppRoutes__ = __webpack_require__(/*! ./components/AppRoutes */ 1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_LoginActions__ = __webpack_require__(/*! ../login/LoginActions */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(/*! react-router */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notifications_Notifications__ = __webpack_require__(/*! ../../components/notifications/Notifications */ 2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_brand_Brand__ = __webpack_require__(/*! ../../components/brand/Brand */ 2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_confirmation_modal_ConfirmationModal__ = __webpack_require__(/*! ../../components/confirmation-modal/ConfirmationModal */ 2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppActions__ = __webpack_require__(/*! ./AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_information_modal_InformationModal__ = __webpack_require__(/*! ../../components/information-modal/InformationModal */ 2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_LinearProgress__ = __webpack_require__(/*! @material-ui/core/es/LinearProgress */ 623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LoadingBackDrop__ = __webpack_require__(/*! ../../components/LoadingBackDrop */ 2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(/*! ../../utils */ 628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_DashboardLayout_NavBar_NavBar__ = __webpack_require__(/*! ./components/DashboardLayout/NavBar/NavBar */ 2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DashboardLayout_TopBar_TopBar__ = __webpack_require__(/*! ./components/DashboardLayout/TopBar/TopBar */ 3091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 154);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import Header from "./components/Header";
// import LeftDrawer from "./components/LeftDrawer";









// import MuiThemeProvider from "@material-ui/core/es/styles/MuiThemeProvider";
// import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';









var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = { navDrawerOpen: false, isMobileNavOpen: false }, _this.componentDidUpdate = function () {
      var _this$props = _this.props,
          setMainElement = _this$props.setMainElement,
          mainElement = _this$props.app.mainElement,
          isLogin = _this$props.user.isLogin;


      if (isLogin && __WEBPACK_IMPORTED_MODULE_14__utils__["b" /* inPopUp */]()) {
        console.log("Popup will be closed");
        window.close();
      }

      if (!mainElement && _this.mainElement) {
        setMainElement(_this.mainElement);
      }
    }, _this.setMobileNavOpen = function () {
      _this.setState({ isMobileNavOpen: !_this.state.isMobileNavOpen });
    }, _this.setMobileNavClose = function () {
      _this.setState({ isMobileNavOpen: false });
    }, _this.handleChangeRequestNavDrawer = function () {
      return _this.setState({ navDrawerOpen: !_this.state.navDrawerOpen });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          getEnv = _props.getEnv,
          getUserLoginStatus = _props.getUserLoginStatus,
          getApiConfig = _props.getApiConfig;

      getUserLoginStatus();
      getEnv();
      getApiConfig();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var stripeScript = document.createElement("script");
      stripeScript.src = "https://js.stripe.com/v3/";
      stripeScript.id = "stripeScript";
      document.getElementsByTagName("head")[0].appendChild(stripeScript);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          navDrawerOpen = _state.navDrawerOpen,
          isMobileNavOpen = _state.isMobileNavOpen;
      var _props2 = this.props,
          user = _props2.user,
          classes = _props2.classes,
          brand = _props2.brand,
          app = _props2.app,
          history = _props2.history,
          location = _props2.location;

      var paneName = void 0;
      if (location && location.pathname && location.pathname !== "/") {
        paneName = location.pathname.replace("/", "");
        paneName = paneName.charAt(0).toUpperCase() + paneName.slice(1);
      }

      return (
        // <MuiThemeProvider theme={brand.id === 'BM' ? TypeAppTheme : BlueMailTheme}>
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { background: '#fff' } },
          user.fetching || brand.fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.progressContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_LinearProgress__["a" /* default */], {
              color: "primary",
              classes: { root: classes.progressContainer }
            })
          ) : !user.isLogin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Redirect */], { to: "/login" }) : !brand.fetching && brand.id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.root },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_DashboardLayout_TopBar_TopBar__["a" /* default */], { onMobileNavOpen: this.setMobileNavOpen }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_DashboardLayout_NavBar_NavBar__["a" /* default */], {
              onMobileClose: this.setMobileNavOpen,
              isMobileNavOpen: isMobileNavOpen,
              setMobileNavClose: this.setMobileNavClose
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "main",
              {
                className: classes.content,
                ref: function ref(el) {
                  return _this2.mainElement = el;
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__material_ui_core__["f" /* Hidden */],
                { lgUp: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "pane-name" },
                  paneName
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: classes.innerContent },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_AppRoutes__["a" /* default */], null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_notifications_Notifications__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_confirmation_modal_ConfirmationModal__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_information_modal_InformationModal__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_LoadingBackDrop__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_brand_Brand__["a" /* default */], null)
        )
        // </MuiThemeProvider>

      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var drawerWidth = 240;

var styles = function styles(theme) {
  return {
    root: {
      position: "relative",
      display: "flex",
      width: "100%",
      height: "100%"
    },
    appBar: _defineProperty({
      position: "absolute",
      marginLeft: drawerWidth
    }, theme.breakpoints.up("md"), {
      width: "calc(100% - " + drawerWidth + "px)"
    }),
    toolbar: theme.mixins.toolbar,
    drawerPaper: _defineProperty({
      width: drawerWidth,
      backgroundColor: "#fafafa"
    }, theme.breakpoints.up("md"), {
      position: "relative"
    }),
    content: {
      flexGrow: 1,
      backgroundColor: "#fff",
      marginTop: 64,
      overflowY: "auto",
      overflowX: "hidden",
      height: "93.6%%",
      padding: "0 12px"
    },
    innerContent: {
      height: "100%",
      padding: "16px 0"
    },
    navIconHide: {
      left: -14
    },
    menuIcon: {
      "&:focus": {
        outline: "unset !important"
      },
      right: -22
    },
    logoutIcon: {
      fontSize: "2rem"
    },
    headerTitle: _defineProperty({
      flex: 1
    }, theme.breakpoints.up("sm"), {
      paddingLeft: 8
    }),
    progressContainer: {
      position: "absolute",
      width: "100%",
      height: "3px"
    },
    activeLink: {
      borderLeft: "4px solid rgb(66, 133, 244) !important",
      paddingLeft: "17px !important",
      color: theme.palette.primary.main + " !important"
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      app = _ref2.app,
      brand = _ref2.brand;
  return { user: user, app: app, brand: brand };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
    getUserLoginStatus: __WEBPACK_IMPORTED_MODULE_3__login_LoginActions__["d" /* getUserLoginStatus */],
    setMainElement: __WEBPACK_IMPORTED_MODULE_10__AppActions__["i" /* setMainElement */],
    getEnv: __WEBPACK_IMPORTED_MODULE_10__AppActions__["h" /* getEnv */],
    getApiConfig: __WEBPACK_IMPORTED_MODULE_10__AppActions__["g" /* getApiConfig */]
  }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_styles_withStyles__["a" /* default */])(styles, { withTheme: true })(App)));

/***/ }),

/***/ 1551:
/*!****************************************************!*\
  !*** ./src/containers/app/components/AppRoutes.js ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(/*! react-router-dom */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_devices_Devices__ = __webpack_require__(/*! ../../../containers/devices/Devices */ 1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__int_signature_lib_Main__ = __webpack_require__(/*! @int/signature/lib/Main */ 1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__delete_account_DeleteAccount__ = __webpack_require__(/*! ../../delete-account/DeleteAccount */ 2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Welcome__ = __webpack_require__(/*! ./Welcome */ 2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_Account__ = __webpack_require__(/*! ../../account/Account */ 2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__billing_Billing__ = __webpack_require__(/*! ../../billing/Billing */ 2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_emails_SharedEmails__ = __webpack_require__(/*! ../../shared-emails/SharedEmails */ 2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__settings_Settings__ = __webpack_require__(/*! ../../settings/Settings */ 2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__profile_Profile__ = __webpack_require__(/*! ../../profile/Profile */ 2611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__subscription_Subscription__ = __webpack_require__(/*! ../../subscription/Subscription */ 2615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__avatar_Avatars__ = __webpack_require__(/*! ../../avatar/Avatars */ 2616);














var AppRoutes = function AppRoutes() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { exact: true, path: '/', component: __WEBPACK_IMPORTED_MODULE_3__int_signature_lib_Main__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/account', component: __WEBPACK_IMPORTED_MODULE_6__account_Account__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/delete-account', component: __WEBPACK_IMPORTED_MODULE_4__delete_account_DeleteAccount__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/billing', component: __WEBPACK_IMPORTED_MODULE_7__billing_Billing__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/devices', component: __WEBPACK_IMPORTED_MODULE_2__containers_devices_Devices__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/signature', component: __WEBPACK_IMPORTED_MODULE_3__int_signature_lib_Main__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/shared-emails', component: __WEBPACK_IMPORTED_MODULE_8__shared_emails_SharedEmails__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/settings', component: __WEBPACK_IMPORTED_MODULE_9__settings_Settings__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/profile', component: __WEBPACK_IMPORTED_MODULE_10__profile_Profile__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/avatar', component: __WEBPACK_IMPORTED_MODULE_12__avatar_Avatars__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { path: '/subscription', component: __WEBPACK_IMPORTED_MODULE_11__subscription_Subscription__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"], { render: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    '404 Page Not Found'
                );
            } })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (AppRoutes);

/***/ }),

/***/ 1552:
/*!*******************************************!*\
  !*** ./src/containers/devices/Devices.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DevicesActions__ = __webpack_require__(/*! ./DevicesActions */ 370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress */ 163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_DeviceExpPanel__ = __webpack_require__(/*! ./component/DeviceExpPanel */ 1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_styles_createTypography__ = __webpack_require__(/*! @material-ui/core/es/styles/createTypography */ 888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_colors_grey__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var grey600 = __WEBPACK_IMPORTED_MODULE_10__material_ui_core_colors_grey___default.a['600'];

var styles = function styles(theme) {
    return {
        heading: {
            fontSize: theme.typography.pxToRem(15),
            flexBasis: '33.33%',
            flexShrink: 0
        },
        secondaryHeading: {
            fontSize: theme.typography.pxToRem(15),
            color: theme.palette.text.secondary
        },
        devicesList: {
            marginTop: '10px',
            maxWidth: '600px'
        },
        loadingCircleContainer: {
            textAlign: 'center',
            paddingTop: '35px'
        },
        bigClearText: {
            fontSize: 20,
            fontWeight: __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_styles_createTypography__["a" /* default */].fontWeightLight,
            color: grey600
        }
    };
};

var Devices = function (_Component) {
    _inherits(Devices, _Component);

    function Devices() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Devices);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Devices.__proto__ || Object.getPrototypeOf(Devices)).call.apply(_ref, [this].concat(args))), _this), _this.state = { openedListItem: null }, _this.handleListItemClick = function (index) {
            return _this.setState({ openedListItem: _this.state.openedListItem === index ? null : index });
        }, _this.renderDevices = function () {
            var _this$props = _this.props,
                classes = _this$props.classes,
                _this$props$devices = _this$props.devices,
                fetching = _this$props$devices.fetching,
                devices = _this$props$devices.devices;

            if (fetching) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.loadingCircleContainer },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_CircularProgress__["a" /* default */], { size: 80, thickness: 5 })
                );
            } else if (devices.length === 0) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.loadingCircleContainer },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h4",
                        { className: classes.bigClearText },
                        "No devices found"
                    )
                );
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { id: "devices" },
                devices.map(function (device, index) {
                    var isOpened = _this.state.openedListItem === index;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_DeviceExpPanel__["a" /* default */], { isOpened: isOpened, device: device, classes: _this.props.classes,
                        handleListItemClick: _this.handleListItemClick, index: index, key: device.device_id, z: true });
                })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Devices, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var user = this.props.user;

            this.props.getDevices(user.email);
            this.props.changePageHeader('Devices', true);
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
                { container: true, justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
                    { item: true, xs: 12, sm: 8, className: this.props.classes.devicesList },
                    this.renderDevices()
                )
            );
        }
    }]);

    return Devices;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref2) {
    var devices = _ref2.devices,
        user = _ref2.user,
        brand = _ref2.brand;

    return { devices: devices, user: user, brand: brand };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        getDevices: __WEBPACK_IMPORTED_MODULE_3__DevicesActions__["b" /* getDevices */],
        changePageHeader: __WEBPACK_IMPORTED_MODULE_6__app_AppActions__["f" /* changePageHeader */]
    }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(Devices)));

/***/ }),

/***/ 1591:
/*!************************************************************!*\
  !*** ./src/containers/devices/component/DeviceExpPanel.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_ExpansionPanel__ = __webpack_require__(/*! @material-ui/core/es/ExpansionPanel */ 399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_ExpansionPanelSummary__ = __webpack_require__(/*! @material-ui/core/es/ExpansionPanelSummary */ 400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Hidden__ = __webpack_require__(/*! @material-ui/core/Hidden */ 892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Fade__ = __webpack_require__(/*! @material-ui/core/es/Fade */ 266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_ExpansionPanelDetails__ = __webpack_require__(/*! @material-ui/core/es/ExpansionPanelDetails */ 407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Button__ = __webpack_require__(/*! @material-ui/core/es/Button */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_optional_js__ = __webpack_require__(/*! optional-js */ 1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_optional_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_optional_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_md__ = __webpack_require__(/*! react-icons/md */ 267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_LabelAndText__ = __webpack_require__(/*! ../../../components/common/LabelAndText */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DevicesActions__ = __webpack_require__(/*! ../DevicesActions */ 370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_confirmation_modal_ConfirmationModalActions__ = __webpack_require__(/*! ../../../components/confirmation-modal/ConfirmationModalActions */ 124);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var DeviceExpPanel = function (_Component) {
    _inherits(DeviceExpPanel, _Component);

    function DeviceExpPanel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DeviceExpPanel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeviceExpPanel.__proto__ || Object.getPrototypeOf(DeviceExpPanel)).call.apply(_ref, [this].concat(args))), _this), _this.removeOrCancel = function (isCancellation) {
            var _this$props = _this.props,
                openConfirmationModal = _this$props.openConfirmationModal,
                setCommand = _this$props.setCommand,
                brand = _this$props.brand,
                email = _this$props.user.email,
                _this$props$device = _this$props.device,
                vendorId = _this$props$device.vendor_id,
                deviceId = _this$props$device.device_id,
                d_model = _this$props$device.d_model;

            var command = 'remote_wipe';
            var status = isCancellation ? 4 : null;
            var callback = function callback() {
                return setCommand({ email: email, vendorId: vendorId, deviceId: deviceId, status: status, command: command });
            };
            if (isCancellation) {
                return callback();
            }
            openConfirmationModal({ text: "Are you sure you want to remove this account from " + d_model + "?", callback: callback });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DeviceExpPanel, [{
        key: "getOptionalDateFormatted",
        value: function getOptionalDateFormatted(optional) {
            var _this2 = this;

            return optional.map(function (time) {
                return _this2.getDateFormated(time);
            }).orElse("Unknown");
        }
    }, {
        key: "getDateFormated",
        value: function getDateFormated(time) {
            var date = new Date(time);
            return date.toLocaleString();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                device = _props.device,
                classes = _props.classes,
                isOpened = _props.isOpened,
                handleListItemClick = _props.handleListItemClick,
                index = _props.index;

            var parsedLastSeen = this.getOptionalDateFormatted(__WEBPACK_IMPORTED_MODULE_9_optional_js__["ofNullable"](device.last_seen).map(function (last_seen) {
                return parseFloat(last_seen);
            }));
            var removeSent = device.commands.reduce(function (acc, item) {
                return acc || item.command === 'remote_wipe' && item.status === 1;
            }, false);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_ExpansionPanel__["a" /* default */],
                { expanded: isOpened,
                    onChange: function onChange() {
                        return handleListItemClick(index);
                    } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_ExpansionPanelSummary__["a" /* default */],
                    { expandIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_icons_md__["d" /* MdExpandMore */], null) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Typography__["a" /* default */],
                        { className: classes.heading },
                        device.d_model
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Hidden___default.a,
                        { xsDown: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Fade__["a" /* default */],
                            { "in": !isOpened },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Typography__["a" /* default */],
                                { className: classes.secondaryHeading },
                                parsedLastSeen
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_ExpansionPanelDetails__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__["a" /* default */],
                        { container: true, justify: "center", style: { opacity: isOpened ? 1 : 0 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__["a" /* default */],
                            { item: true, xs: 12, style: { backgroundColor: 'white' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_LabelAndText__["a" /* default */], { label: "Last Seen", content: parsedLastSeen })
                        )
                    )
                )
            );
        }
    }]);

    return DeviceExpPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref2) {
    var user = _ref2.user,
        brand = _ref2.brand;

    return { user: user, brand: brand };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({
        setCommand: __WEBPACK_IMPORTED_MODULE_14__DevicesActions__["c" /* setCommand */],
        openConfirmationModal: __WEBPACK_IMPORTED_MODULE_15__components_confirmation_modal_ConfirmationModalActions__["d" /* openConfirmationModal */]
    }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DeviceExpPanel));

/***/ }),

/***/ 161:
/*!**************************************************!*\
  !*** ./src/containers/billing/BillingActions.js ***!
  \**************************************************/
/*! exports provided: GET_CREDIT_DETAILS, GET_CREDIT_DETAILS_START, getCreditDetails, getCreditDetailsFulfilled, CREATE_OR_UPDATE_CREDIT_START, CREATE_OR_UPDATE_CREDIT, createOrUpdateCredit, GET_PLANS_START, GET_PLANS, getPlans, GET_INVOICES_START, GET_INVOICES, getInvoices, GET_EMAIL_PLANS_START, GET_EMAIL_PLANS, getEmailPlans, ATTACH_PLAN_TO_CLIENT, DETACH_PLAN_FROM_CLIENT, ATTACH_PLAN_TO_CLIENT_START, DETACH_PLAN_FROM_CLIENT_START, attachPlanToClient, detachPlanFromClient, DELETE_PLAN_FROM_CLIENT, DELETE_PLAN_FROM_CLIENT_START, deletePlanFromClient, DELETE_PLANS_FROM_CLIENT, DELETE_PLANS_FROM_CLIENT_START, deletePlansFromClient, getEmailPlansFulfilled, getInvoicesFulfilled, getAvailablePlansFulfilled, createOrUpdateCreditFulfilled, atachPlanToClientFulfilled, deletePlanFromClientFulfilled, deletePlansFromClientFulfilled, TOGGLE_CREDIT_DETAILS, toggleCreditDetails, DELETE_CREDIT_START, DELETE_CREDIT, deleteCredit, deleteCreditFulfilled, CONFIRM_3D_SECURE, CONFIRM_3D_SECURE_START, confirm3dSecure, confirm3dSecureFulfilled */
/*! exports used: ATTACH_PLAN_TO_CLIENT, ATTACH_PLAN_TO_CLIENT_START, CONFIRM_3D_SECURE, CONFIRM_3D_SECURE_START, CREATE_OR_UPDATE_CREDIT, CREATE_OR_UPDATE_CREDIT_START, DELETE_CREDIT, DELETE_CREDIT_START, DELETE_PLANS_FROM_CLIENT, DELETE_PLANS_FROM_CLIENT_START, DETACH_PLAN_FROM_CLIENT, DETACH_PLAN_FROM_CLIENT_START, GET_CREDIT_DETAILS, GET_CREDIT_DETAILS_START, GET_EMAIL_PLANS, GET_EMAIL_PLANS_START, GET_INVOICES, GET_INVOICES_START, GET_PLANS, GET_PLANS_START, TOGGLE_CREDIT_DETAILS, atachPlanToClientFulfilled, attachPlanToClient, confirm3dSecure, confirm3dSecureFulfilled, createOrUpdateCredit, createOrUpdateCreditFulfilled, deleteCredit, deleteCreditFulfilled, deletePlanFromClientFulfilled, deletePlansFromClient, deletePlansFromClientFulfilled, detachPlanFromClient, getAvailablePlansFulfilled, getCreditDetails, getCreditDetailsFulfilled, getEmailPlans, getEmailPlansFulfilled, getInvoices, getInvoicesFulfilled, getPlans, toggleCreditDetails */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_CREDIT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_CREDIT_DETAILS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getCreditDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getCreditDetailsFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_OR_UPDATE_CREDIT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_OR_UPDATE_CREDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return createOrUpdateCredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_PLANS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_INVOICES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_INVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_EMAIL_PLANS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_EMAIL_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getEmailPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTACH_PLAN_TO_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DETACH_PLAN_FROM_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTACH_PLAN_TO_CLIENT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DETACH_PLAN_FROM_CLIENT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return attachPlanToClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return detachPlanFromClient; });
/* unused harmony export DELETE_PLAN_FROM_CLIENT */
/* unused harmony export DELETE_PLAN_FROM_CLIENT_START */
/* unused harmony export deletePlanFromClient */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_PLANS_FROM_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_PLANS_FROM_CLIENT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return deletePlansFromClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getEmailPlansFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getInvoicesFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getAvailablePlansFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return createOrUpdateCreditFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return atachPlanToClientFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deletePlanFromClientFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return deletePlansFromClientFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TOGGLE_CREDIT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return toggleCreditDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_CREDIT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_CREDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return deleteCredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return deleteCreditFulfilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONFIRM_3D_SECURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONFIRM_3D_SECURE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return confirm3dSecure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return confirm3dSecureFulfilled; });
//noinspection NpmUsedModulesInstalled
var GET_CREDIT_DETAILS = "GET_CREDIT_DETAILS";
var GET_CREDIT_DETAILS_START = "GET_CREDIT_DETAILS_START";

//B epic attached 
var getCreditDetails = function getCreditDetails(payload, error) {
    return { type: GET_CREDIT_DETAILS_START, payload: payload, error: error };
};

var getCreditDetailsFulfilled = function getCreditDetailsFulfilled(payload, error) {
    return { type: GET_CREDIT_DETAILS, payload: payload, error: error };
};

var CREATE_OR_UPDATE_CREDIT_START = 'CREATE_OR_UPDATE_CREDIT_START';
var CREATE_OR_UPDATE_CREDIT = 'CREATE_OR_UPDATE_CREDIT';

var createOrUpdateCredit = function createOrUpdateCredit(info, email) {
    return {
        type: CREATE_OR_UPDATE_CREDIT_START,
        payload: { info: info, email: email }
    };
};

//B
var GET_PLANS_START = 'GET_PLANS_START';
var GET_PLANS = 'GET_PLANS';

var getPlans = function getPlans(info, email) {
    return {
        type: GET_PLANS_START,
        payload: { info: info, email: email }
    };
};

var GET_INVOICES_START = 'GET_INVOICES_START';
var GET_INVOICES = 'GET_INVOICES';

var getInvoices = function getInvoices(info, email) {
    return {
        type: GET_INVOICES_START,
        payload: { info: info, email: email }
    };
};

//B
var GET_EMAIL_PLANS_START = 'GET_EMAIL_PLANS_START';
var GET_EMAIL_PLANS = 'GET_EMAIL_PLANS';

var getEmailPlans = function getEmailPlans(info, email) {
    return {
        type: GET_EMAIL_PLANS_START,
        payload: { info: info, email: email }
    };
};

//B
var ATTACH_PLAN_TO_CLIENT = 'ATTACH_PLAN_TO_CLIENT';
var DETACH_PLAN_FROM_CLIENT = 'DETACH_PLAN_FROM_CLIENT';
var ATTACH_PLAN_TO_CLIENT_START = 'ATTACH_PLAN_TO_CLIENT_START';
var DETACH_PLAN_FROM_CLIENT_START = 'DETACH_PLAN_FROM_CLIENT_START';

var attachPlanToClient = function attachPlanToClient(planId) {
    return {
        type: ATTACH_PLAN_TO_CLIENT_START,
        payload: { planId: planId }
    };
};

var detachPlanFromClient = function detachPlanFromClient(planId) {
    return {
        type: DETACH_PLAN_FROM_CLIENT_START,
        payload: { planId: planId }
    };
};

//B
var DELETE_PLAN_FROM_CLIENT = 'DELETE_PLAN_FROM_CLIENT';
var DELETE_PLAN_FROM_CLIENT_START = 'DELETE_PLAN_FROM_CLIENT_START';

var deletePlanFromClient = function deletePlanFromClient(planId) {
    return {
        type: ATTACH_PLAN_TO_CLIENT,
        payload: { planId: planId }
    };
};

var DELETE_PLANS_FROM_CLIENT = 'DELETE_PLANS_FROM_CLIENT';
var DELETE_PLANS_FROM_CLIENT_START = 'DELETE_PLANS_FROM_CLIENT_START';

var deletePlansFromClient = function deletePlansFromClient() {
    return {
        type: DELETE_PLANS_FROM_CLIENT_START,
        payload: {}
    };
};

var getEmailPlansFulfilled = function getEmailPlansFulfilled(payload, error) {
    return { type: GET_EMAIL_PLANS, payload: payload, error: error };
};

var getInvoicesFulfilled = function getInvoicesFulfilled(payload, error) {
    return { type: GET_INVOICES, payload: payload, error: error };
};

var getAvailablePlansFulfilled = function getAvailablePlansFulfilled(payload, error) {
    return { type: GET_PLANS, payload: payload, error: error };
};

var createOrUpdateCreditFulfilled = function createOrUpdateCreditFulfilled(payload, error) {
    return { type: CREATE_OR_UPDATE_CREDIT, payload: payload, error: error };
};

var atachPlanToClientFulfilled = function atachPlanToClientFulfilled(payload, error) {
    return { type: ATTACH_PLAN_TO_CLIENT, payload: payload, error: error };
};

var deletePlanFromClientFulfilled = function deletePlanFromClientFulfilled(payload, error) {
    return { type: DETACH_PLAN_FROM_CLIENT, payload: payload, error: error };
};

var deletePlansFromClientFulfilled = function deletePlansFromClientFulfilled(payload, error) {
    return { type: DELETE_PLANS_FROM_CLIENT, payload: payload, error: error };
};

var TOGGLE_CREDIT_DETAILS = 'TOGGLE_CREDIT_DETAILS';

var toggleCreditDetails = function toggleCreditDetails() {
    return { type: TOGGLE_CREDIT_DETAILS };
};

var DELETE_CREDIT_START = 'DELETE_CREDIT_START';
var DELETE_CREDIT = 'DELETE_CREDIT';

var deleteCredit = function deleteCredit(credit) {
    return {
        type: DELETE_CREDIT_START,
        payload: credit
    };
};
var deleteCreditFulfilled = function deleteCreditFulfilled(payload, error) {
    return { type: DELETE_CREDIT, payload: payload, error: error };
};

var CONFIRM_3D_SECURE = 'CONFIRM_3D_SECURE';
var CONFIRM_3D_SECURE_START = 'CONFIRM_3D_SECURE_START';

var confirm3dSecure = function confirm3dSecure(payload) {
    return {
        type: CONFIRM_3D_SECURE_START,
        payload: payload
    };
};

var confirm3dSecureFulfilled = function confirm3dSecureFulfilled(payload, error) {
    return { type: CONFIRM_3D_SECURE, payload: payload, error: error };
};

// export const IS_STRIPE_CUSTOMER_EXISTS = "IS_STRIPE_CUSTOMER_EXISTS";
// export const IS_STRIPE_CUSTOMER_EXISTS_START = "IS_STRIPE_CUSTOMER_EXISTS_START";
//
// export function isStripeCustomerExists() {
//     return function (dispatch) {
//         dispatch({
//             type: IS_STRIPE_CUSTOMER_EXISTS_START,
//         });
//         const payload = axios.get('/api/payment/customer');
//         dispatch({
//             type: IS_STRIPE_CUSTOMER_EXISTS,
//             payload
//         });
//     }
// }

/***/ }),

/***/ 175:
/*!*********************************************************!*\
  !*** ./src/assets/jss/material-dashboard-pro-react.jsx ***!
  \*********************************************************/
/*! exports provided: drawerWidth, drawerMiniWidth, transition, container, containerFluid, boxShadow, card, defaultFont, primaryColor, warningColor, dangerColor, successColor, infoColor, roseColor, grayColor, primaryBoxShadow, infoBoxShadow, successBoxShadow, warningBoxShadow, dangerBoxShadow, roseBoxShadow, orangeCardHeader, greenCardHeader, redCardHeader, blueCardHeader, purpleCardHeader, roseCardHeader, warningCardHeader, successCardHeader, dangerCardHeader, infoCardHeader, primaryCardHeader, cardActions, cardHeader, defaultBoxShadow, tooltip, title, cardTitle, cardSubtitle, cardLink, changePrimaryColor */
/*! exports used: cardTitle, dangerColor, defaultFont, grayColor, infoColor, primaryColor, roseColor, successColor, warningColor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export drawerWidth */
/* unused harmony export drawerMiniWidth */
/* unused harmony export transition */
/* unused harmony export container */
/* unused harmony export containerFluid */
/* unused harmony export boxShadow */
/* unused harmony export card */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return primaryColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return warningColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dangerColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return successColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return infoColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return roseColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return grayColor; });
/* unused harmony export primaryBoxShadow */
/* unused harmony export infoBoxShadow */
/* unused harmony export successBoxShadow */
/* unused harmony export warningBoxShadow */
/* unused harmony export dangerBoxShadow */
/* unused harmony export roseBoxShadow */
/* unused harmony export orangeCardHeader */
/* unused harmony export greenCardHeader */
/* unused harmony export redCardHeader */
/* unused harmony export blueCardHeader */
/* unused harmony export purpleCardHeader */
/* unused harmony export roseCardHeader */
/* unused harmony export warningCardHeader */
/* unused harmony export successCardHeader */
/* unused harmony export dangerCardHeader */
/* unused harmony export infoCardHeader */
/* unused harmony export primaryCardHeader */
/* unused harmony export cardActions */
/* unused harmony export cardHeader */
/* unused harmony export defaultBoxShadow */
/* unused harmony export tooltip */
/* unused harmony export title */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cardTitle; });
/* unused harmony export cardSubtitle */
/* unused harmony export cardLink */
/* unused harmony export changePrimaryColor */
/*!

 =========================================================
 * Material Dashboard PRO React - v1.2.0 based on Material Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2018 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

var drawerWidth = 260;

var drawerMiniWidth = 80;

var transition = {
    transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
};

var containerFluid = {
    paddingRight: "15px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto",
    "&:before,&:after": {
        display: "table",
        content: '" "'
    },
    "&:after": {
        clear: "both"
    }
};

var container = {
    paddingRight: "15px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto",
    // "@media (min-width: 768px)": {
    //     width: "750px"
    // },
    // "@media (min-width: 992px)": {
    //     width: "970px"
    // },
    // "@media (min-width: 1200px)": {
    //     width: "1170px"
    // },
    "&:before,&:after": {
        display: "table",
        content: '" "'
    },
    "&:after": {
        clear: "both"
    }
};

var boxShadow = {
    boxShadow: "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
};

var card = {
    display: "inline-table",
    overflow: "auto",
    position: "relative",
    width: "100%",
    margin: "25px 0",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
    borderRadius: "6px",
    color: "rgba(0, 0, 0, 0.87)",
    background: "#fff"
};

var defaultFont = {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: "400",
    lineHeight: "1.5em"
};

var primaryColor = "#00acc1";

var warningColor = "#ff9800";
var dangerColor = "#f44336";
var successColor = "#4caf50";
var infoColor = "#00acc1";
var roseColor = "#e91e63";
var grayColor = "#999999";

var primaryBoxShadow = {
    boxShadow: "0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)"
    // "0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"
};

var infoBoxShadow = {
    boxShadow: "0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)"
};
var successBoxShadow = {
    boxShadow: "0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)"
};
var warningBoxShadow = {
    boxShadow: "0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)"
};
var dangerBoxShadow = {
    boxShadow: "0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)"
};
var roseBoxShadow = {
    boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)"
};

// old card headers
var orangeCardHeader = Object.assign({
    background: "linear-gradient(60deg, #ffa726, #fb8c00)"
}, warningBoxShadow);
var greenCardHeader = Object.assign({
    background: "linear-gradient(60deg, #66bb6a, #43a047)"
}, successBoxShadow);
var redCardHeader = Object.assign({
    background: "linear-gradient(60deg, #ef5350, #e53935)"
}, dangerBoxShadow);
var blueCardHeader = Object.assign({
    background: "linear-gradient(60deg, #26c6da, #00acc1)"
}, infoBoxShadow);
var purpleCardHeader = Object.assign({
    background: "linear-gradient(60deg, #ab47bc, #8e24aa)"
}, primaryBoxShadow);
// new card headers
var warningCardHeader = Object.assign({
    background: "linear-gradient(60deg, #ffa726, #fb8c00)"
}, warningBoxShadow);
var successCardHeader = Object.assign({
    background: "linear-gradient(60deg, #66bb6a, #43a047)"
}, successBoxShadow);
var dangerCardHeader = Object.assign({
    background: "linear-gradient(60deg, #ef5350, #e53935)"
}, dangerBoxShadow);
var infoCardHeader = Object.assign({
    background: "linear-gradient(60deg, #26c6da, #00acc1)"
}, infoBoxShadow);
var primaryCardHeader = Object.assign({
    background: "linear-gradient(60deg, #26c6da, #00acc1)"
}, primaryBoxShadow);
var roseCardHeader = Object.assign({
    background: "linear-gradient(60deg, #ec407a, #d81b60)"
}, roseBoxShadow);

var cardActions = Object.assign({
    margin: "0 20px 10px",
    paddingTop: "10px",
    borderTop: "1px solid #eeeeee",
    height: "auto"
}, defaultFont);

var cardHeader = {
    margin: "-20px 15px 0",
    borderRadius: "3px",
    padding: "15px"
};

var defaultBoxShadow = {
    border: "0",
    borderRadius: "3px",
    boxShadow: "0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    padding: "10px 0",
    transition: "all 150ms ease 0s"
};

var tooltip = {
    padding: "10px 15px",
    minWidth: "130px",
    color: "#FFFFFF",
    lineHeight: "1.7em",
    background: "rgba(85,85,85,0.9)",
    border: "none",
    borderRadius: "3px",
    opacity: "1!important",
    boxShadow: "0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
    maxWidth: "200px",
    textAlign: "center",
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    textShadow: "none",
    textTransform: "none",
    letterSpacing: "normal",
    wordBreak: "normal",
    wordSpacing: "normal",
    wordWrap: "normal",
    whiteSpace: "normal",
    lineBreak: "auto"
};

var title = {
    color: "#3C4858",
    textDecoration: "none",
    fontWeight: "300",
    marginTop: "30px",
    marginBottom: "25px",
    minHeight: "32px",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    "& small": {
        color: "#777",
        fontSize: "65%",
        fontWeight: "400",
        lineHeight: "1"
    }
};

var cardTitle = Object.assign({}, title, {
    marginTop: "0",
    marginBottom: "3px",
    minHeight: "auto",
    "& a": Object.assign({}, title, {
        marginTop: ".625rem",
        marginBottom: "0.75rem",
        minHeight: "auto"
    })
});

var cardSubtitle = {
    marginTop: "-.375rem"
};

var cardLink = {
    "& + $cardLink": {
        marginLeft: "1.25rem"
    }
};

var changePrimaryColor = function changePrimaryColor(brand) {
    switch (brand) {
        case "BM":
            primaryColor = "#038BFA";
            primaryBoxShadow = "0 12px 20px -10px #038bfa52, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px #038bfa47";
            primaryCardHeader = "linear-gradient(60deg, #038BFA, #0075d4)";
            break;
        default:
            primaryColor = "#038BFA";
            primaryBoxShadow = "0 12px 20px -10px #038bfa52, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px #038bfa47";
            primaryCardHeader = "linear-gradient(60deg, #038BFA, #0075d4);";
            break;

    }
};



/***/ }),

/***/ 2148:
/*!********************************************************!*\
  !*** ./src/containers/delete-account/DeleteAccount.js ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeleteAccountActions__ = __webpack_require__(/*! ./DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_colors_common__ = __webpack_require__(/*! @material-ui/core/colors/common */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_colors_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_colors_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Button__ = __webpack_require__(/*! @material-ui/core/es/Button */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_confirmation_modal_ConfirmationModalActions__ = __webpack_require__(/*! ../../components/confirmation-modal/ConfirmationModalActions */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_icons_fa__ = __webpack_require__(/*! react-icons/fa */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress */ 163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_UploadsInfoTable__ = __webpack_require__(/*! ./components/UploadsInfoTable */ 597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DaInfoTable__ = __webpack_require__(/*! ./components/DaInfoTable */ 599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UserInfoTable__ = __webpack_require__(/*! ./components/UserInfoTable */ 2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_RtscInfo__ = __webpack_require__(/*! ./components/RtscInfo */ 610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_es_Dialog__ = __webpack_require__(/*! @material-ui/core/es/Dialog */ 334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_es_DialogActions__ = __webpack_require__(/*! @material-ui/core/es/DialogActions */ 335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_es_DialogContent__ = __webpack_require__(/*! @material-ui/core/es/DialogContent */ 336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_es__ = __webpack_require__(/*! @material-ui/core/es */ 2196);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var white = __WEBPACK_IMPORTED_MODULE_5__material_ui_core_colors_common___default.a.white;
var red500 = __WEBPACK_IMPORTED_MODULE_6__material_ui_core_colors_red___default.a["500"];

















var env = "production";

var Account = function (_Component) {
  _inherits(Account, _Component);

  function Account(props) {
    _classCallCheck(this, Account);

    var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));

    _this.openConfirmationModal = function () {
      var _this$props = _this.props,
          user = _this$props.user,
          brand = _this$props.brand,
          destroyAccount = _this$props.destroyAccount;

      _this.handleClose();
      _this.props.openConfirmationModal({
        text: "Are you sure you want to delete this account?",
        callback: function callback() {
          return destroyAccount(user.email, brand.id);
        },
        confirmCheckbox: true
      });
    };

    _this.handleClose = function () {
      _this.setState({ open: false });
    };

    _this.handleOpen = function () {
      _this.setState({ open: true });
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Account, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          changePageHeader = _props.changePageHeader,
          getAccountPIIStatus = _props.getAccountPIIStatus,
          user = _props.user,
          brand = _props.brand;

      changePageHeader("Delete Account");
      getAccountPIIStatus(user.email, brand.id);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // const {user, brand, account, getDestroyStatus, getAccountPII} = nextProps;
      // if (!account.fetchingPii && !account.pii.hasOwnProperty("index") && brand.id && user.email) {
      //     getAccountPII(user.email, brand.id)
      // }
      //     if(!nextProps.account.fetching && nextProps.account.destroy.status && nextProps.account.destroy.status==='REQUESTED') {
      //         setTimeout(() => getDestroyStatus(user.email, brand.id), 1000)
      //     }
    }
  }, {
    key: "renderDestroyStatusIcon",
    value: function renderDestroyStatusIcon(status) {
      switch (status) {
        case "REQUESTED":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], { size: 15 });
        case "FAILED":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_icons_fa__["d" /* FaWindowClose */], { color: "red" });
        default:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_icons_fa__["a" /* FaCheck */], { color: "green" });
      }
    }
  }, {
    key: "getDateFormated",
    value: function getDateFormated(time) {
      var date = new Date(time);
      return date.toLocaleString();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          classes = _props2.classes,
          user = _props2.user,
          brand = _props2.brand,
          account = _props2.account,
          getDestroyStatus = _props2.getDestroyStatus,
          getAccountPII = _props2.getAccountPII;
      var open = this.state.open;


      console.log(this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !account.fetchingPiiStatus && account.piiStatus ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
            { container: true, justify: "center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
              { xs: 11, sm: 9, md: 7, item: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_19__material_ui_core_es_Typography__["a" /* default */],
                {
                  gutterBottom: true,
                  variant: "headline",
                  className: classes.serviceHeadLine
                },
                "How to Permanently Delete Your Account and All Information From " + brand.name + " Cloud"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
            {
              container: true,
              justify: "center",
              className: classes.serviceContent,
              spacing: 24
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
              { xs: 11, sm: 9, md: 7, item: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_19__material_ui_core_es_Typography__["a" /* default */],
                {
                  component: "p",
                  className: classes.serviceContentText
                },
                "Permanently deleting your account, removes your account details from " + brand.name + " cloud. After this is complete, you will no longer have access to your account on " + brand.name + " and all traces of your account will be removed instantly as we do not store your emails on our servers.\n\nIf you would like to permanently delete your account, please do the following:\n1. Remove your account from the " + brand.name + " app on ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  { style: { fontWeight: 800 } },
                  "all"
                ),
                " of your devices.",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "li",
                  { style: { paddingLeft: "1.5rem" } },
                  "You can remove your account within the app by tapping More (o o o) | Various Account Settings | Tap the account you wish to delete | Edit Account | Remove Account | Confirm with OK"
                ),
                "2. Click the \u201CDelete Account\u201D button below and wait for confirmation.\n\nPlease Note: You will need to do the steps above for every account you wish to delete on " + brand.name + ". This is a permanent action and cannot be undone."
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
            { container: true, justify: "center", className: classes.serviceContent },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
              { item: true, xs: 12, sm: 6, lg: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
                { container: true, justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
                  { item: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Button__["a" /* default */],
                    {
                      style: { marginRight: '10px' },
                      variant: "raised",
                      color: "secondary",
                      onClick: this.handleOpen
                    },
                    "Delete Account"
                  )
                ),
                (env === "development" || env === "staging") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
                  { item: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Button__["a" /* default */],
                    {
                      variant: "raised",
                      color: "primary",
                      onClick: function onClick() {
                        return getDestroyStatus(user.email);
                      }
                    },
                    "Get Delete Status"
                  )
                ),
                account.destroy.detailsList && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__["a" /* default */],
                  { item: true, xs: 12 },
                  account.destroy.detailsList.map(function (d, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Grow__["a" /* default */],
                      { "in": true, key: d.id, timeout: index * 700 + 500 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        null,
                        d.component + ": ",
                        _this2.renderDestroyStatusIcon(d.status)
                      )
                    );
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_DaInfoTable__["a" /* default */], { classes: classes }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_UploadsInfoTable__["a" /* default */], { classes: classes }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_RtscInfo__["a" /* default */], { classes: classes })
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "center", paddingTop: "30px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_20__material_ui_core_es_Dialog__["a" /* default */],
          { open: open, onClose: this.handleClose },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_23__material_ui_core_es__["a" /* DialogTitle */],
            null,
            "Are you sure? Your data will be permanently deleted"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_21__material_ui_core_es_DialogActions__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Button__["a" /* default */],
              { onClick: this.handleClose, color: "primary" },
              "Cancel"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Button__["a" /* default */],
              { onClick: this.openConfirmationModal, color: "primary" },
              "Ok"
            )
          )
        )
      );
    }
  }]);

  return Account;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = function styles(theme) {
  return {
    heading: {
      fontSize: theme.typography.pxToRem(15)
    },
    deleteButton: {
      backgroundColor: red500,
      color: white
    },
    pageContainer: {
      padding: 24,
      marginBottom: 40
    },
    tableWrapper: {
      overflowX: "auto"
    },
    title: {
      color: "rgba(0, 0, 0, 0.54)",
      padding: "0.7em 0",
      fontSize: "1.5rem",
      fontWeight: 400,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.20588em"
    },
    accountEmail: {
      padding: ".3em 0 .7em 0",
      fontSize: "1rem",
      fontWeight: 400,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    loadingCircleContainer: {
      textAlign: "center",
      paddingTop: "35px"
    },
    serviceHeadLine: {
      fontSize: 24,
      paddingTop: 32,
      lineHeight: "42px"
    },
    serviceContent: _defineProperty({
      marginTop: 16
    }, theme.breakpoints.down("sm"), {
      marginTop: 0
    }),
    serviceContentText: {
      color: "rgba(0,0,0,0.65)",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      whiteSpace: "pre-wrap"
    },
    contactsList: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      paddingRight: 1,
      maxHeight: 300,
      margin: "-10px 0px 12px"
    },
    groupsList: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      paddingRight: 1,
      maxHeight: 600,
      margin: "12px 0px"
    },
    ultraProfile: {
      padding: 15
    },
    gridList: {
      // width: 500,
      // height: 450,
      maxHeight: 400,
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)"
    },
    expPanel: {
      width: "100%",
      boxShadow: "unset"
    }
  };
};

function mapStateToProps(_ref) {
  var account = _ref.account,
      user = _ref.user,
      brand = _ref.brand;

  return { account: account, user: user, brand: brand };
}

function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
    destroyAccount: __WEBPACK_IMPORTED_MODULE_3__DeleteAccountActions__["g" /* destroyAccount */],
    changePageHeader: __WEBPACK_IMPORTED_MODULE_7__app_AppActions__["f" /* changePageHeader */],
    getDestroyStatus: __WEBPACK_IMPORTED_MODULE_3__DeleteAccountActions__["j" /* getDestroyStatus */],
    getAccountPII: __WEBPACK_IMPORTED_MODULE_3__DeleteAccountActions__["h" /* getAccountPII */],
    openConfirmationModal: __WEBPACK_IMPORTED_MODULE_11__components_confirmation_modal_ConfirmationModalActions__["d" /* openConfirmationModal */],
    deleteShare: __WEBPACK_IMPORTED_MODULE_3__DeleteAccountActions__["f" /* deleteShare */],
    getAccountPIIStatus: __WEBPACK_IMPORTED_MODULE_3__DeleteAccountActions__["i" /* getAccountPIIStatus */]
  }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(Account)));

/***/ }),

/***/ 2155:
/*!*******************************************************!*\
  !*** ./src/containers/shared-emails/scrollbarCss.css ***!
  \*******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2194:
/*!*******************************************************************!*\
  !*** ./src/containers/delete-account/components/UserInfoTable.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TablePaginationActions__ = __webpack_require__(/*! ./TablePaginationActions */ 1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Table__ = __webpack_require__(/*! @material-ui/core/es/Table */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody__ = __webpack_require__(/*! @material-ui/core/TableBody */ 221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__ = __webpack_require__(/*! @material-ui/core/es/TableRow */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__ = __webpack_require__(/*! @material-ui/core/es/TableCell */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter__ = __webpack_require__(/*! @material-ui/core/TableFooter */ 600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_TablePagination__ = __webpack_require__(/*! @material-ui/core/es/TablePagination */ 601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead__ = __webpack_require__(/*! @material-ui/core/TableHead */ 227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var DeviceInfoList = function (_Component) {
    _inherits(DeviceInfoList, _Component);

    function DeviceInfoList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DeviceInfoList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeviceInfoList.__proto__ || Object.getPrototypeOf(DeviceInfoList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            page: 0,
            rowsPerPage: 5
        }, _this.handleChangePage = function (event, page) {
            return _this.setState({ page: page });
        }, _this.handleChangeRowsPerPage = function (event) {
            return _this.setState({ rowsPerPage: event.target.value });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DeviceInfoList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                account = _props.account,
                timeout = _props.timeout;
            var _state = this.state,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page;
            var userInfo = account.pii.userInfo;

            if (!userInfo || userInfo && userInfo.filter(function (user) {
                return user.phone;
            }).length === 0) {
                return null;
            }
            var emptyRows = rowsPerPage - Math.min(rowsPerPage, userInfo.length - page * rowsPerPage);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Grow__["a" /* default */],
                { "in": true, timeout: timeout || 1000 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Paper__["a" /* default */],
                    { className: classes.pageContainer },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { className: classes.title },
                        "User Info"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: classes.tableWrapper },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Table__["a" /* default */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__["a" /* default */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                        null,
                                        "Phone Numbers"
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody___default.a,
                                null,
                                userInfo.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (n) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__["a" /* default */],
                                        { key: n.phone },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                            null,
                                            n.phone
                                        )
                                    );
                                })
                            ),
                            userInfo.length > 5 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__["a" /* default */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_TablePagination__["a" /* default */], {
                                        colSpan: 5,
                                        count: userInfo.length,
                                        rowsPerPage: rowsPerPage,
                                        page: page,
                                        rowsPerPageOptions: [5],
                                        onChangePage: this.handleChangePage,
                                        onChangeRowsPerPage: this.handleChangeRowsPerPage,
                                        Actions: __WEBPACK_IMPORTED_MODULE_3__TablePaginationActions__["a" /* default */]
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return DeviceInfoList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref2) {
    var account = _ref2.account;

    return { account: account };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch);
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DeviceInfoList));

/***/ }),

/***/ 2329:
/*!**************************************************!*\
  !*** ./src/containers/app/components/Welcome.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AppActions__ = __webpack_require__(/*! ../AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageBase__ = __webpack_require__(/*! ../../../components/PageBase */ 2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(/*! ../../../utils */ 628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_fa__ = __webpack_require__(/*! react-icons/fa */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_hash_link__ = __webpack_require__(/*! react-router-hash-link */ 2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_hash_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_router_hash_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom_es_Link__ = __webpack_require__(/*! react-router-dom/es/Link */ 627);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var styles = function styles(theme) {
  return {
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    },
    section: {
      marginTop: "10px",
      maxWidth: "600px"
    },
    section2: {
      marginTop: "10px",
      maxWidth: "600px",
      padding: "0 14px !important"
    },
    welcomeContainer: {
      textAlign: "center"
    },
    welcomeText: {
      fontSize: "16px",
      margin: "16px 0",
      color: "#000000a6",
      whiteSpace: "pre-line"
    },
    root: {
      paddingTop: "30px",
      paddingBottom: "30px",
      paddingRight: '20px'
    },
    accountBox: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: "rgba(0,0,0,0.65)",
      paddingLeft: "20px"
    },
    icon: {
      fill: "#3f51b5",
      fontSize: "34px"
    },
    headline: {
      paddingLeft: "20px",
      color: '#000'
    }
  };
};

var Welcome = function (_Component) {
  _inherits(Welcome, _Component);

  function Welcome() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Welcome);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Welcome.__proto__ || Object.getPrototypeOf(Welcome)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.props.changePageHeader("My Account");
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Welcome, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          user = _props.user,
          brand = _props.brand,
          classes = _props.classes,
          app = _props.app;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            {
              item: true,
              xs: 12,
              md: 6,
              lg: 4,
              className: __WEBPACK_IMPORTED_MODULE_10_classnames__(classes.section, classes.welcomeContainer)
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* getAppProps */](brand).logoBig }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Typography__["a" /* default */],
              { component: "p", className: classes.welcomeText },
              "Welcome " + (user.name || user.email) + "\n                            to " + brand.name + "\u2019s My Account center"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { xs: 12, md: 6, lg: 4, item: true, className: classes.section2 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_router_dom_es_Link__["a" /* default */],
              { to: "/account", style: { textDecoration: "none" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Paper__["a" /* default */],
                { className: classes.root, elevation: 1 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: classes.accountBox },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_icons_fa__["b" /* FaCog */], { className: classes.icon }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Typography__["a" /* default */],
                    {
                      variant: "headline",
                      color: "inherit",
                      className: classes.headline
                    },
                    "Account Management"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Welcome;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref2) {
  var app = _ref2.app,
      user = _ref2.user,
      brand = _ref2.brand;

  return { app: app, user: user, brand: brand };
}

function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
    changePageHeader: __WEBPACK_IMPORTED_MODULE_5__AppActions__["f" /* changePageHeader */]
  }, dispatch);
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(Welcome)));

/***/ }),

/***/ 2330:
/*!************************************!*\
  !*** ./src/components/PageBase.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_Divider__ = __webpack_require__(/*! @material-ui/core/es/Divider */ 1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Icon__ = __webpack_require__(/*! @material-ui/core/es/Icon */ 598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom_es_Link__ = __webpack_require__(/*! react-router-dom/es/Link */ 627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);









var PageBase = function PageBase(_ref) {
    var title = _ref.title,
        navigation = _ref.navigation,
        children = _ref.children,
        icon = _ref.icon,
        classes = _ref.classes,
        link = _ref.link;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Paper__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router_dom_es_Link__["a" /* default */],
            { to: link, className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(classes.header, 'page-base-header') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: classes.titleWrapper },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__["a" /* default */],
                    { container: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__["a" /* default */],
                        { item: true, xs: 2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Icon__["a" /* default */],
                            { color: "primary", className: classes.icon },
                            icon
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grid__["a" /* default */],
                        { item: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "span",
                            { className: classes.title },
                            title
                        )
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_Divider__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.content },
            children
        )
    );
};

var styles = function styles(theme) {
    return {
        content: {
            padding: 20
        },
        titleWrapper: {
            color: 'rgba(0,0,0,0.65)',
            display: 'table-cell',
            fontSize: '24px',
            lineHeight: '32px',
            verticalAlign: 'middle'
        },
        title: {
            flex: 1,
            lineHeight: '38px'
        },
        header: {
            padding: '30px 20px',
            display: 'block'
        },
        icon: {
            paddingRight: 20,
            fontSize: 35
        }
    };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(PageBase));

/***/ }),

/***/ 2332:
/*!*****************************************!*\
  !*** ./src/images/typeapp-logo-big.png ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2333:
/*!******************************************!*\
  !*** ./src/images/bluemail-logo-big.png ***!
  \******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2334:
/*!**********************************************!*\
  !*** ./src/images/bluemailplus-logo-big.png ***!
  \**********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2335:
/*!****************************************!*\
  !*** ./src/images/ultima-logo-big.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2336:
/*!**************************************!*\
  !*** ./src/images/blix-logo-big.png ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2337:
/*!*************************************!*\
  !*** ./src/images/typeapp-logo.png ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2338:
/*!**************************************!*\
  !*** ./src/images/bluemail-logo.png ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAArCAYAAABVV4fPAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAASAAAAEgARslrPgAADL9JREFUeNrtmnmQHHUVxz+/7p6ZnZ3ZbLIL2SQbsjmEBJEQCSAGIYCcXgUqgtwRxcItPFIiFogHKlaBigiRoyglgnIJEq4QiIocAcKNQkgkCxuMm90cu5vsOTPdzz/eb3Z7Z2dmZ1eoLWS+VV3T092/473v7x2/1w1llFFGGWWUUUYZZbwnYcbSaNqpLwDGgMwHOURE1kHwBJh0y60HjrdMZYwAZ7QNpp32Ehg3iuFk4DZgGXArmKWITJj6xbXjLVMZI6BkS592+isgAoYaRL4Ocj4iNSCICBD0IdwOcik4TeDTctvB4y1fGXlQEunTTv8HkAa8eSA/QjgRgggihEjHnqxBgosReQxjpOX2j463jGXkYETS68/4J2BckKNFgh8DCxExlmSGko79lU0gPwG5BUxvy+2LxlvOMkIoSnr9Ga+CMUlEzgG5UESm5pBLAdIB2SUiN4JcDs4W8Nlyx6HjLW8ZFCC9/szXgQAwM0AuQuQMkMqQGwckD+nDrgcgqxD5HtubXqB2FlvuPGy8ZX7fYxjp9WetB8czBOmDEfkpyOESiIl64DpDSc2eS/iaBIDgB0JfyseoB1gH8n0IVoBJb7lz8XjL/b7GENLrz9oAmBgEJ4N8H5E5xsDH9o5z2hGTmL5bBGMABMcYDIIf6P+hELbvzHDPk1tZsWYrqbQPyHZErgK5GkwHCFv+dMR4y/++hAGYfvYbKHFmd5ClInIeBNVBIOw7M8Z1jfXMqosONBKBptYMvamAvadHcQvs9ju7M1xwwxuseHIrjiMgkgK5S0R+6DjOhiAIaL3ryPHWwXsaDY2dAC4QsZfSgN+8rLpgG2/Gua20P/drJi74ygIJ/EuBT4C4YAhEWDQvMZRw4K6nuvnFPZ3sPyfKz5fUEo/mzwerEx5HLJjEyrXbyfg+QBQ4BdgrCPxLjPiP1H1udab1rqPeSQXMBva3l14Amoop4P8EnwIusOdXACsaGjujwKHAbsA24HEg1bysGi/T00bVPqce7fd3LAP2BAZidOALydhQhWV8Yc26Pja2pPngHhFe/3eKmiqX+hoPzx0+m6q4g+f4pFIZjIYBI8hCkOW4FZdWTj/k2vqz1/ubb5o70MaSNxk4GF3B4fhhgF7gTaAJ6AcIEftx4Fp7fp595l1DyNIWAjPsXDuAJ4D+fAvOtvGAjwBTbZsdwJNZYkaJKVZX2XOAKuAy4CBgLfAJYDuAZ5wIGGdRkOnZ0+/djog/hOAgXTVsBGPAdaCjO+A7N+0glRFOPDjBl4+pIlkx1NdL4BNkeggyvs0HlDc3Xrt7JDn1BL+79WYnkujMI8h84PdAPg2kgf8ATwNXAU83NHYK44cI8C3UiwFsAT4DPFukzQzgt8Be9v8QYkaJJmBF6LwoPOOq63YrajDGI9PbhgQp1KA0Ey+EQGBHV0DLjgxX37+TSUmXs45M5jwlOXbq4CWnEqnaA2NcJN2NMd5I81wPvI6+KxCgDl0UJ6MWdibw1BiU9W5hCnAM8GxDY2fYC2WtHOBwYNY7NN4j9igJIW0bnFg1nhsh09OKZHoHrufCGHXUVXGHb59QzW2Pd7N2Qx+rX+7hc4sqh1m7QjBujEjVDLxEHRgHxBeMQ8gFFMJtwA9Dk5kEnA1cCnwAdeMvAn3vkBLfCRwPXEd+y61E43BkVD3mQZHwURDDTMzxEkQS9WR626C3k1xL9xxDokJ139Hls8+MKNNr+3gG6E9DEOQbRnAiSaITZ+JW1ISuG9FjRIgVUKxQO4DlwGeBQ1Brr6YA6Q2NndXAAUAM2AS8GhLMAPug7rYfeA7obF5WnVWeQS13HlAB7EK9zrYCc92GxtP90Hi6Ms8zc9EYnAba0fwlH3ERoAH1CJ4dewPQliXcPreHlQEr29vFlOkMFFkGjgDjRvAqpyhBZqjVGgP7zYySiDm88laKr/5mGw+/1IvnGBbMjuaxcoMbryFaMzeHcEumMaVYej70W4UBxNFkqhDmArcCDwDn5zzr2msP2GfmhpReiXqR+y15D9rfFWj8zheXNgAvAUngWMDJWl7IAo9AE7j16A4jH+ENwJWhcbPHfcASIBrq71jgXnscO5LiPAn8ArcMXryWpm0VtHf5TEoO6umo/eKcujjBn57s5u2tGWIRw3H7xzl9cRInxHkqA+vaKpHkB3BNlDz5gWTHKhUhQWczuLpfAXaO0DQ7s3yDmZxnYDA5uwi18PVACxpOFqGW7wG35PTVjWbuB6LkTgP+Hbo/EXX9AKtR8nMxBbgGDQG96MLoQhfkQXZsF7gxNP9i8g2Bh/gFb7oGVj7fjbCFCz+/+8B+fUKlw0UnTeL4hZW82ZqhrtrlgD1jTEwM6qy9W7h+dT83P24ITCS7XctFqe59FnBYQ2Onh2aXDcA59vqb6Batq4R+RoNDgW+g1n4vsBRoBhbY8Q5AF8VqBj0O6AL5K/AlS9IhwO2hxbq/bdsOrEKtNhefBI6zsl4D/Ax17YuBG9AFvwS4G93qjQpFSQdIp+G+pzv4z7Z+Lj6ljoP2SmAMdPcFbGzp55n13cyaHGHOFIeJiRgAb7UFXHF/PytfSuP7Rb13qe79LHvkogXdi/5ltIKPAAc4CdjdKvWXwEZ77znUuheidY35wN9CbePoQvw7uqv4FBoO+lArPBa19lXAy2jBKhcbgcuBHuAOBhfVE8AalPRZQC1jIb2we2eIo3h2QxffvD7F0hPrqEpE+d3qnTyzvou+/gyuE/DA2na+dEwN9ZOruHqVz/NNmRL4NEr6yB5pE/BW6EEDTEcTmO+iLvCPFNtflg5Bk8KF9v9O+/9jdlwfJS2NeoGGnHETaL5xH7qlPMyS9Brqyo+2z61ErbcydwLNy6ofbWjsfBRNCGegXgfUpWfTdYf8OcWIKG7pIVEcoLktzcW3bAfHo7s3wACea0Bg3dt9XLJ8MxUVUbqCatxoghHJNIjBkRJIXw78gMEtjkFd5xXofvhHVqkvjkUJeRBDawEAM4E/D5v54KQn5NyLomSsQfOAfdEq4Wuoq98bjfGrbR/DLN2WUE9AQ9iHGKyywWgSoALwZAT3DmCMi3FjOG6M3rTWRxyHwe8mAMcxpDIB/bt6gG4kndSCj1dRrGsZqr+C8AFpXladskoBTd5uRK1gjlVsIdJHq6jwpDrRjDxToJ/NOddjqEVuRgsm89HE7Vb7WwE8BvwLzfDjefpcgrr3Cag3eJnB8DCbPFu80UAtXQqpxWDcGMarxDgleBKjaZlIgN/bTpDahVtRg1MxCePkltDDuh0dJ6H96dto3IujFlkIPqNz/Sk0Vu6BknMisJX8Xw+nGV5kyQr0IPAVNFQch4aIfjQxzJY9w8IL+oLkXJTwbcDFwJ1WTg8tO58zKoXlYDCm56jEuBEcL4nxYozJoxiQTD+Zrs2Yvna8xGScaLXd9w8MJrl1gFGiFrUsUIsohHarbFDr8lDLtTMdEhsNGsdfRQsss9GEbTMMr4CFiij58AKa+B0JXILG/1dRS88HQauN0+z/R4Gb0ZwlO7ck/yOGx3Tj4kQSmEgCY9yx9WpnJwYIhCC1k1R6F25FLV6iDuPFx9xvqEo2C3WDSXRv/HSRZttRi61H97nz0RccUXQblPvxXhqN458GaoBvo3F4ox2/BrXaHorXvDuAh9D9evbFysPoC5lC6LPygO4eatAFV40mhh8PPTsmiwmRbjBeJU60CuPGxtJXAVgvEfj4PW0EqZ24lXW48VqM45Xqdk8AGhoaO7MuxwM+jCZFoO7y0SLtO1ASF6Hxfzn6BiyJ7pmr8rR5ALgJ+Boai2eglTZQ6z/Qjvksg5aYDw8D30StdweatReS2QCt6HZvDpr4/QHdAs5EPU/WQ0UYnkSWBM94cSQINjnRZMrxEtExlkRLhmT6yOzcRNDfgVs5eV1yTkNv7+aRimkssEcY2XfqfwZ+hSZcWcWR5/xmNEafgWb+89CQcIdV9IU5bXrRFzo7gNNtm33tvWz9/SHUKxRLTDag++svoAskN9kMb0MNGusvR638cNQTHYbWJK5EF+gFaB4zfQSZTZ5rmOlnb0TEn2AcbylaCSqabofog8DX9+/iox+++jnXfAgCRDL2g8kBZEDWYtzLEGluvXvolzPWhdYDR5G/eGHQxOoVtEqWCSV381DXi1X266F7Fai17GP72Ag8g1rhYp0XDwFtoTYeGkoWoPHWR2sGr9nFEqDZ+mI09u9CizHdofl+GP1g4mWGvgKuQIs1U1CXv4rBl0aTUG/SYOf1IpoPzELDkWP7+mc+mQv13bys2n4jt6QpK1yckuOEIIGSO0B6iPARSBcVzqQgoPXuY0obsowyyiijjDLKKKOMMsooo4wyyijj/wz/BXUTof8KmnsBAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA1LTA3VDA5OjE1OjIwKzAyOjAwSFfdmgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNS0wN1QwOToxNToyMCswMjowMDkKZSYAAAAASUVORK5CYII="

/***/ }),

/***/ 2339:
/*!******************************************!*\
  !*** ./src/images/bluemailplus-logo.png ***!
  \******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2340:
/*!************************************!*\
  !*** ./src/images/ultima-logo.png ***!
  \************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2341:
/*!**********************************!*\
  !*** ./src/images/blix-logo.png ***!
  \**********************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2342:
/*!*****************************************!*\
  !*** ./src/images/bluemail-favicon.png ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2343:
/*!*********************************************!*\
  !*** ./src/images/bluemailplus-favicon.png ***!
  \*********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2344:
/*!***************************************!*\
  !*** ./src/images/ultima-favicon.png ***!
  \***************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABXBJREFUeNrUV1tMm1Uc79cLtN9X2g8KLTCYbZlsRhBQF8iiAUeM+sBgxgd9WIRkMdEHJ76YbIljD5q4aLYaH0y8DB+MSlwEfJDEmKCGiZo5ZiHi1BYoHV2h0Au93/z/8XzN2fErdmpiPMnp+c71//vf/1Uo/uPG3eqFuzpet8LQAx3Hbmb7S+hz0Kd/vPJs8F8FAIQHYXiSEC+ljUJ3AJC5fwQACLfDcAF6+9+U8nnoZ4pJhCuB6wvsej6X9qczEWcuG/fHY6vzuKbjG1qUKp1ZoxG7OE4pMFdQCkcBxFLJAOSIZzPR+XBo/oPAxtczMA1Bj5MtA+k8Tmrr+3oFwf4Ep9SYqesoARsrCa4U4vl8LhoOOV9Yv/H5JEx9sdhKWu4ez+81GYwthwFkory8RrDU9x0vK6vqZSTxAA1CzT5itT91DxB8A8RYQJ5MrPUvu9/5ahdpoWGeIAYqanUN9/p9UzUr7ncd9Q2PuXnBepwcRTs6DX1YVgLAgcHW9PSMSi20UMsdrCUTgj2UavbCnSHqyNCvP7/6PoyHUDXA1Em1xtBF7dske7hJAjWWB48xxM/QxIlqziGX9D24wwqlDdQ0Cgxdgu/eNe8njobbjrVSxnlCkoKS4r5RxzcepR5ZAuIjFPFzxC7EElxvRzrEVhaSyfVoKrXxBbU/IH0oqUU7uhA1f0/62Nf8/OMwPHeTK4JholdglwHQDoBFAsKDQyQ0TwOwkvjyhwqAe16svLuN8d9xsler0+1x0K/nsgm3d/Xj4WTCl8O5vuJ2s9ny0CmlSmujQWBIJt+rwa0f+GrzYQWzPydJwKRSCXp6V9K9WHXwUcafl1KpQOfW5ncT8D2FIt6O/OL3ej46iVJh1UDahhRHaCnQKuAxklGb0xL3Wm1tMyPe8WuLr6xLOobuQk5Qz+Cuk9S5QqKCM4FixqIsFg8kyajVejOzNsEeInoOS2GZEjHd0ul00MkClAAYM5ltv4z4jDKgrEXA+pi5KBkaaWEw8lYmdRcABNKpoF8m7ytSyYCbebi/CIANlUonyLkjaTqlssxcTAWK7ciiS+ZyKBS84mTWBwDcgAyAakHfdIRZ6ya2pDFV39/JGPOOkavwR6MxarLZWA24YhenVFdKJzYDl8Zh3aQ3HDADd3bq8sOWukeSN3yfzRJpiQax9U2wl/sYAAfgXMhY2dGt4/ee4jiuTMov4GVDhVyACPFRSBxHqMQBVhNqXna91QR+vsdS1+eQyfNBwkmpVZLUhgHA+YIKSMgMh0NXZ+lTIJmzMFxDP4dI5pB5SGSJY5BKJv2Tu1VIEvGCCgixXCq1WSFU7BPUamG/JMKq6kPToIqVaPS3CMep5rVaCyQVlSD3cj6fnfF6xl7c3Ji5jGc1GoOQz2eCWEGBlzkTce/I4sLI2aIFCaiiFwqJGshcb1Pixow4AnvoUo1YaFSaurq02rpOILITPTPZqCu27R6DSmmM3LkTCyPkC9WaiF+fASamQNKsq/4pAGHmOhjc/P7lSlPnS7S1wuU5AOGBfbvv+qeoe0wuqLoAqZI8tIUTN8bs2QN25V31fOiTk5qaiWg+JJLNRm1UThgnbtdPdD4Ba6N/8b8B8/0glbrbip2XC8EBfcV+KS0H4UE3E/0wDpwm+WKZSKidRM2eIuX71VsBYKJCplikALESDndtaHzgEc9A8rpYMoDycnOTVJbhA6n01iwY2Lc4rzDc0cfUdrINXTEeX7245h1/Tc7wdvMCA0TDQV6wt8aiLicUEd+QJGOSrBq9wCh2tJaVm2wQWgW1SrCjFwDYKOaNeNyzEAn/dBnOuoqV77sBqCWEfCxyEi1ryR8QNkvuBDLoa3AvrPg/td8FGACgj1BxwxKBJAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 2345:
/*!****************************************!*\
  !*** ./src/images/typeapp-favicon.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAE4UlEQVRYw62XXUxbZRjH39OObBN1ivQceurHpTGReeOld97uZt6ZLJFLTdRwo86FqHwMOqDls1C+YQubMkU2Y2bUDBkk7mLA+NrYVhm4lc/BgLaU0o+/z3tKS0tbzmnmm7wJkLS/3/M8//ecF8bSWMZBmOTLOCVfgpX2z/J5XKfdTz9fkb9Htfwj8oz9eIP9n+tVQC/34UMCDMoXECIgVPcl3JR7kWcCMp4JLl/B+/JFTGmCJtsX4SD5E2mDjdM4RK22HlRxbg/wXh/w2oWQukgPmo2TOKwJbnLjOWr3NbUv/XUOysptnIXcFdQylhumx3hRvXINcBPtpa2wwNvWMYgV97VKDMpTOJJ65rztGmZ78jdEFxcwFN3SLtGD9tSBU0n5uz8BxcPA2vaewNU7a+gZX0X+L7PaJfrwQeJR05D2z4eQcnWProQ7YZkhCZVgdmPOtBozCuWca2j9R38GMEXD3wmEouB7K17lbxUD8zCU0DjOTUOqXVSX6MUnUYGjVZuDOR1+9dbRl0qVDjg3fAkZMJSMwmC+C7FyBmK1E1LjOn0muYTY5keGxTWhwIWrkFk1gocKH0Jq2dIk4XSH4gWKR2Aom4Kh4h+CP4ZYtwyRBHJavQmfz27xQVeyAFa0AKEDbzHWhFOsOhRiVaGQruAeDA3rqhJOz97sc6vGYSidJLgDYtUjgi9BbHgKqckNqXUbOR2B6Oey7F4IxfNgxSRQsgRm8X3GmA1WRWBXQjg9iazqRc0CJ87PwFB+H6J1DiLNXmxYhdjkom56IbX7IXWGkNMJHLO5qWoOXwzDz66AVXjoSDagNyqwK8G+HMMx88OUAjMbewLL7gCuOTzontqCaHsC0b6pjFJq24HUQZkheGbNZgx8meBPwEpXwSq3+xnN/3qcQETii9vILLyTNM0/OBKP4fCin+a+Aak5Ag/SBo5aniaBr4GVrYOd2xxJLhCR+GoCRwrGYeyMf7i8Qy+i/n93sBMMIUR5dLqCqB31EdxDc/cpcJGqP1y+qoQt2nIOL9uFm6kr5e5RxurRl1RAkQiG2JlpZHx9W6kqVsLY6UdO7QJy6uNDJ7UHYGgLIMO8shc2Duct53CzUjltF1hVYICHsDqlQESi4AH0p+ml0+zdJxFQjpsUE7rsFj/0pUvxYVPgNArzRhheToEs94C638WPYd6BAhGJb2bBT8grje59z4VguHJ6uGQ10Rk/u5gYtv3wCoJXeEHdz2dCL15XFYhk4rtHYGfu4qW6jYRgvty4BaFkMUnYInDXLnwrDK/chtCF4+FnsQ03NUvwUBU4kGmh8065EKntL9S6wvMuThG2JHBWg2kZCPOFVg1jiJXgFX47B6UjhU71sPF5c3jlLtziA7NT+yNL76Hbaz0epCXBQUVObWGLwgls2eHhW9CNITPuTiC00+1Vq0BEgsO0hC1SNYdb/WDN9P5JuuxoTluCw1TCFge3oefNyOz3L/0QXZ1tGEhbggNThS0WXoth4Xc8f+DNWD9BV+d63EhbggOThS0Grvsb2Zr+N9AN0X3NTrfXdCU4MDZsHGwNKG0X/lCpPOlqx0lWh9n0JHb24DWY54FLOXNN3XBQN1rxMVUxrlmkDtP0iM/XTe47as+6hMt0h7PjU8pIGwnRaxwjyq7HX/R7J3+4CN04LqdR8X8v0p+tDcUjrgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 2346:
/*!*************************************!*\
  !*** ./src/images/blix-favicon.png ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABSklEQVQ4jWPMidlrwMDAsIGBgUGegTTwkIGBIYCJTM0MUD0bmNA1x6RpgjGxhjAh8xw9ZBk4uVkZnj76AmYTA1AM4ORiYXj68DPDk4dfwGxiAE5V5raSDA7usmCDLp17w3Bgx2OG29ffY6jDasD3b78Ztq27z3Dy8HO4YakFugxrl9yGi8EAE4ZuBgawF969+cGQX20Ext+//WGY1HaOwStIEcNrWA0QEuFgyKsyBCsGYZDt377+AXtBz1iUsBeERTnBtk5sPQfmN/ZbgcVArhIW5cBtAEiTtBwPw9vX38E2B8eogsVBbHNbCQYZeV6G/Tse4/bCxTOv4U6cPeEy3CWT2s4znDz8gnAggpwIUgQLOJAXQHwQAAUgUdEIsgGkGeR8kHdA4M6ND+BoxQZABoByFUp+uHT2NRgTAR6CvBAANYRU8JCBgSEAAAGlh6YE7vAAAAAAAElFTkSuQmCC"

/***/ }),

/***/ 2347:
/*!******************************!*\
  !*** ./src/typeapp-theme.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__ = __webpack_require__(/*! @material-ui/core/es/styles/createMuiTheme */ 146);



var grey900 = __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default.a['900'];
var red500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default.a['500'];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__["a" /* default */])({
    palette: {
        primary: {
            main: '#038BFA'
        },
        secondary: {
            main: red500
        }
    },
    appBar: {
        height: 57,
        color: '#038BFA'
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: '#038BFA'
    },
    toolbar: {
        height: 160
    }
}));

/***/ }),

/***/ 2348:
/*!*******************************!*\
  !*** ./src/ultimahq-theme.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__ = __webpack_require__(/*! @material-ui/core/es/styles/createMuiTheme */ 146);



var grey900 = __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default.a['900'];
var red500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default.a['500'];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__["a" /* default */])({
    palette: {
        primary: {
            main: '#3d46a3'
        },
        secondary: {
            main: red500
        }
    },
    appBar: {
        height: 57,
        color: '#3d46a3'
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: '#3d46a3'
    },
    toolbar: {
        height: 160
    }
}));

/***/ }),

/***/ 2349:
/*!*******************************!*\
  !*** ./src/bluemail-theme.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__ = __webpack_require__(/*! @material-ui/core/es/styles/createMuiTheme */ 146);



var grey900 = __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default.a['900'];
var red500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default.a['500'];

var primaryColor = '#216CEB';
var primaryShadow = '0 12px 20px -10px #216ceb57, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px #216ceb52';
var primarySmallShadow = '0 2px 2px 0 #216ceb2e, 0 3px 1px -2px #3175e854, 0 1px 5px 0 #216ceb24';
var primaryBackground = 'linear-gradient(60deg, #216ceb, #1b5ece)';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__["a" /* default */])({
    palette: {
        primary: {
            main: primaryColor
        },
        secondary: {
            main: red500
        }
    },
    button: {
        shadows: {
            primary: primaryShadow,
            primarySmall: primarySmallShadow
        }
    },
    sideBar: {
        shadows: {
            primary: primaryShadow
        }
    },
    appBar: {
        height: 57,
        color: primaryColor
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: primaryColor
    },
    toolbar: {
        height: 160
    },
    cardHeader: {
        primary: {
            background: primaryBackground,
            boxShadow: primaryShadow
        }
    },
    shape: {
        borderRadius: "1px"
    }
}));

/***/ }),

/***/ 2350:
/*!***************************!*\
  !*** ./src/blix-theme.js ***!
  \***************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__ = __webpack_require__(/*! @material-ui/core/es/styles/createMuiTheme */ 146);



var grey900 = __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_grey___default.a['900'];
var red500 = __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_red___default.a['500'];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_createMuiTheme__["a" /* default */])({
    palette: {
        primary: {
            main: '#6c5cbd'
        },
        secondary: {
            main: red500
        }
    },
    appBar: {
        height: 57,
        color: '#6c5cbd'
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: '#6c5cbd'
    },
    toolbar: {
        height: 160
    }
}));

/***/ }),

/***/ 2352:
/*!*******************************************!*\
  !*** ./src/containers/account/Account.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__delete_account_components_DaInfoTable__ = __webpack_require__(/*! ../delete-account/components/DaInfoTable */ 599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__delete_account_components_RtscInfo__ = __webpack_require__(/*! ../delete-account/components/RtscInfo */ 610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__ = __webpack_require__(/*! @material-ui/core/es/Button */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common__ = __webpack_require__(/*! @material-ui/core/colors/common */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress */ 163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__ = __webpack_require__(/*! ../delete-account/DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_confirmation_modal_ConfirmationModalActions__ = __webpack_require__(/*! ../../components/confirmation-modal/ConfirmationModalActions */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_icons_fa__ = __webpack_require__(/*! react-icons/fa */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_information_modal_InformationModalActions__ = __webpack_require__(/*! ../../components/information-modal/InformationModalActions */ 247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__delete_account_components_UploadsInfoTable__ = __webpack_require__(/*! ../delete-account/components/UploadsInfoTable */ 597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_es_AppBar__ = __webpack_require__(/*! @material-ui/core/es/AppBar */ 612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_es_Tabs__ = __webpack_require__(/*! @material-ui/core/es/Tabs */ 626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_es_Tab__ = __webpack_require__(/*! @material-ui/core/es/Tab */ 625);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


























var white = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common___default.a.white;
var red500 = __WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red___default.a["500"];

var styles = function styles(theme) {
  return {
    heading: {
      fontSize: theme.typography.pxToRem(15)
    },
    deleteButton: {
      backgroundColor: red500,
      color: white
    },
    pageContainer: {
      padding: 24,
      marginBottom: 40
    },
    tableWrapper: {
      overflowX: "auto"
    },
    title: {
      color: "rgba(0, 0, 0, 0.54)",
      padding: "0.7em 0",
      fontSize: "1.5rem",
      fontWeight: 400,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.20588em"
    },
    accountEmail: {
      padding: ".3em 0 .7em 0",
      fontSize: "1rem",
      fontWeight: 400,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    loadingCircleContainer: {
      textAlign: "center",
      paddingTop: "35px"
    },
    contactsList: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      paddingRight: 1,
      maxHeight: 300,
      margin: "-10px 0px 12px"
    },
    groupsList: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      paddingRight: 1,
      maxHeight: 600,
      margin: "12px 0px"
    },
    ultraProfile: {
      padding: 15
    },
    gridList: {
      // width: 500,
      // height: 450,
      maxHeight: 400,
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)"
    },
    expPanel: {
      width: "100%",
      boxShadow: "unset"
    },
    cardContent: {
      verticalAlign: "middle",
      paddingTop: 24
    },
    cardTitle: {
      alignSelf: "center",
      fontSize: "16px"
    },
    media: {
      height: 160,
      backgroundPosition: "center"
    },
    rightArrowIcon: {
      fontSize: 30
    },
    serviceHeadLine: {
      fontSize: 24,
      paddingTop: 32,
      lineHeight: "42px"
    },
    serviceContent: _defineProperty({
      marginTop: 16
    }, theme.breakpoints.down("sm"), {
      marginTop: 0
    }),
    serviceContentText: {
      color: "rgba(0,0,0,0.65)",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      whiteSpace: "pre-wrap"
    },
    serviceDivider: {
      marginTop: 56
    },
    infoTable: {
      marginBottom: 42
    },
    textAlignCenter: {
      textAlign: "center"
    },
    tableCell: {
      verticalAlign: "middle"
    },
    noInfoInTab: {
      padding: 24
    },
    button: {
      minWidth: 200
    },
    link: {
      color: "#0867b7 !important"
    }
  };
};

var Account = function (_Component) {
  _inherits(Account, _Component);

  function Account() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Account);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Account.__proto__ || Object.getPrototypeOf(Account)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeTab: 0 }, _this.openConfirmationModal = function () {
      var _this$props = _this.props,
          user = _this$props.user,
          brand = _this$props.brand,
          destroyAccount = _this$props.destroyAccount,
          openInformationModal = _this$props.openInformationModal,
          getAccountPIIStatus = _this$props.getAccountPIIStatus;

      _this.props.openConfirmationModal("Are you sure you want to delete your " + user.email + " account?", function () {
        return destroyAccount(user.email, brand.id, function () {
          getAccountPIIStatus(user.email, brand.id);
          openInformationModal("You have successfully deleted your account");
        }, function () {
          return openInformationModal("There was an error deleting your account. Please try again.");
        });
      });
    }, _this.renderButton = function () {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          user = _this$props2.user,
          app = _this$props2.app,
          brand = _this$props2.brand,
          account = _this$props2.account,
          getDestroyStatus = _this$props2.getDestroyStatus,
          getAccountPII = _this$props2.getAccountPII;

      if (account.fetchingPiiStatus) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: classes.loadingCircleContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], { size: 50 })
        );
      } else if (account.piiStatus) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__["a" /* default */],
              {
                variant: "raised",
                color: "secondary",
                className: classes.button,
                onClick: _this.openConfirmationModal
              },
              "Delete Account"
            )
          ),
          (app.env === "development" || app.env === "staging") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__["a" /* default */],
              {
                variant: "raised",
                color: "primary",
                className: classes.button,
                onClick: function onClick() {
                  return getDestroyStatus(user.email);
                }
              },
              "Get Delete Status"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__["a" /* default */],
              {
                variant: "raised",
                color: "primary",
                className: classes.button,
                onClick: function onClick() {
                  return getAccountPII(user.email, brand.id);
                }
              },
              "Show Personal Data"
            )
          ),
          account.destroy.detailsList && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: 12 },
            account.destroy.detailsList.map(function (d, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Grow__["a" /* default */],
                { "in": true, key: d.id, timeout: index * 700 + 500 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  d.component + ": ",
                  _this.renderDestroyStatusIcon(d.status)
                )
              );
            })
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__["a" /* default */],
        { className: classes.pageContainer },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Typography__["a" /* default */],
          {
            component: "p",
            className: __WEBPACK_IMPORTED_MODULE_18_classnames__(classes.serviceContentText, classes.textAlignCenter)
          },
          "Account not registered"
        )
      );
    }, _this.toggleTabs = function (e, activeTab) {
      return _this.setState({ activeTab: activeTab });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Account, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          user = _props.user,
          brand = _props.brand,
          changePageHeader = _props.changePageHeader,
          getAccountPIIStatus = _props.getAccountPIIStatus;

      changePageHeader("Delete your account", true);
      getAccountPIIStatus(user.email, brand.id);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props2 = this.props,
          user = _props2.user,
          brand = _props2.brand,
          getAccountPII = _props2.getAccountPII;

      getAccountPII(user.email, brand.id);
    }
  }, {
    key: "renderDestroyStatusIcon",
    value: function renderDestroyStatusIcon(status) {
      switch (status) {
        case "REQUESTED":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], { size: 15 });
        case "FAILED":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_icons_fa__["d" /* FaWindowClose */], { color: "red" });
        default:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_icons_fa__["a" /* FaCheck */], { color: "green" });
      }
    }
  }, {
    key: "getDateFormated",
    value: function getDateFormated(time) {
      var date = new Date(time);
      return date.toLocaleString();
    }

    // componentWillMount = () => {
    //     this.props.changePageHeader('Account Management', true);
    // };

  }, {
    key: "render",
    value: function render() {
      var activeTab = this.state.activeTab;
      var _props3 = this.props,
          classes = _props3.classes,
          brand = _props3.brand,
          account = _props3.account;

      var tabs = Object.values(account.brandsPii).map(function (_ref2, index) {
        var daInfo = _ref2.daInfo,
            uploadsInfo = _ref2.uploadsInfo,
            rtsc = _ref2.rtsc;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__delete_account_components_DaInfoTable__["a" /* default */], { classes: classes, content: daInfo }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__delete_account_components_UploadsInfoTable__["a" /* default */], { classes: classes, content: uploadsInfo }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__delete_account_components_RtscInfo__["a" /* default */], { classes: classes, content: rtsc })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { padding: "10px 20px", textAlign: "center" } },
        account.fetchingPii ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { paddingTop: "30px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center", className: classes.serviceContent, spacing: 24 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: 12, sm: 10 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__delete_account_components_DaInfoTable__["a" /* default */], { classes: classes }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__delete_account_components_RtscInfo__["a" /* default */], { classes: classes })
          ),
          Object.keys(account.brandsPii).length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: 12, sm: 10 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_21__material_ui_core_es_AppBar__["a" /* default */],
              { position: "static" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22__material_ui_core_es_Tabs__["a" /* default */],
                { value: activeTab, onChange: this.toggleTabs },
                Object.keys(account.brandsPii).map(function (b) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_es_Tab__["a" /* default */], { key: b, label: b });
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__["a" /* default */],
              null,
              tabs[activeTab]
            )
          )
        )
      )
      //             <div style={{padding: '10px'}}>
      //                 {/*<ServiceSection headLine="Delete your account or services"*/}
      //                 {/*text={`If you are no longer interested in using ${brand.name} services, you can delete them here.`}*/}
      //                 {/*image="http://da-v4-mbl.digitalbrandsinc.netdna-cdn.com/wp-content/uploads/2012/08/delete-612x320.jpg"*/}
      //                 {/*cardTitle="Delete Account" link="delete-account"/>*/}

      //                 {!account.fetchingPiiStatus && account.piiStatus ?
      //                     <div>
      //                         <Grid container justify='center'>
      //                             <Grid xs={12} sm={7} item>
      //                                 <Typography gutterBottom variant="headline" className={classes.serviceHeadLine}>
      //                                     {`How to Permanently Delete Your Account and All Information From ${brand.name} Cloud`}
      //                                 </Typography>
      //                             </Grid>
      //                         </Grid>
      //                         <Grid container justify='center' className={classes.serviceContent} spacing={24}>
      //                             <Grid xs={12} sm={7} item>
      //                                 <Typography component="p" className={classes.serviceContentText}>
      //                                     {`Permanently deleting your account, removes your account details from ${brand.name} cloud. After this is complete, you will no longer have access to your account on ${brand.name} and all traces of your account will be removed instantly as we do not store your emails on our servers.

      // If you would like to permanently delete your account, please do the following:
      // 1. Remove your account from the ${brand.name} app on `}
      //                                     <strong style={{fontWeight: 800}}>all</strong>
      //                                     {` of your devices.`}
      //                                     <li style={{paddingLeft: '1.5rem'}}>You can remove your account within the app by
      //                                         tapping More (o o o) | Various Account Settings | Tap the account you wish to
      //                                         delete | Edit Account | Remove Account | Confirm with OK
      //                                     </li>
      //                                     {`2. Click the “Delete Account” button below and wait for confirmation.

      // Please Note: You will need to do the steps above for every account you wish to delete on ${brand.name}. This is a permanent action and cannot be undone.`}
      //                                 </Typography>
      //                             </Grid>
      //                         </Grid>
      //                     </div> :
      //                     <div/>
      //                 }
      //                 <Grid container justify='center' className={classes.serviceContent}>
      //                     <Grid xs={12} sm={7} item>
      //                         {this.renderButton()}
      //                     </Grid>
      //                 </Grid>
      //                 <Grid container justify='center' className={classes.serviceContent} spacing={24}>
      //                     <Grid item xs={12} sm={10}>
      //                         <DaInfoTable classes={classes}/>
      //                         <UploadsInfoTable classes={classes}/>
      //                         <RtscInfo classes={classes}/>
      //                     </Grid>
      //                         {Object.keys(account.brandsPii).length > 0 &&
      //                     <Grid item xs={12} sm={10}>
      //                         <AppBar position="static">
      //                             <Tabs value={activeTab} onChange={this.toggleTabs}>
      //                                 {Object.keys(account.brandsPii).map(b => <Tab key={b} label={b}/>)}
      //                             </Tabs>
      //                         </AppBar>
      //                         <Paper>
      //                             {/* {tabs[activeTab]} */}
      //                         </Paper>
      //                     </Grid>}
      //                 </Grid>

      //             </div>
      ;
    }
  }]);

  return Account;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref3) {
  var user = _ref3.user,
      brand = _ref3.brand,
      account = _ref3.account,
      app = _ref3.app;

  return { user: user, brand: brand, account: account, app: app };
}

function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
    changePageHeader: __WEBPACK_IMPORTED_MODULE_6__app_AppActions__["f" /* changePageHeader */],
    getDestroyStatus: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["j" /* getDestroyStatus */],
    getAccountPII: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["h" /* getAccountPII */],
    destroyAccount: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["g" /* destroyAccount */],
    openConfirmationModal: __WEBPACK_IMPORTED_MODULE_16__components_confirmation_modal_ConfirmationModalActions__["d" /* openConfirmationModal */],
    getAccountPIIStatus: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["i" /* getAccountPIIStatus */],
    openInformationModal: __WEBPACK_IMPORTED_MODULE_19__components_information_modal_InformationModalActions__["d" /* openInformationModal */],
    deleteShare: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["f" /* deleteShare */]
  }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(Account)));

/***/ }),

/***/ 2353:
/*!*******************************************!*\
  !*** ./src/containers/billing/Billing.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jss_BillingStyles__ = __webpack_require__(/*! ./jss/BillingStyles */ 1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BillingActions__ = __webpack_require__(/*! ./BillingActions */ 161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_CircularProgress_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress/CircularProgress */ 193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_material_pro_Grid_GridContainer__ = __webpack_require__(/*! ../../components/material-pro/Grid/GridContainer */ 339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_material_pro_Grid_GridItem__ = __webpack_require__(/*! ../../components/material-pro/Grid/GridItem */ 340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_FormLabel_FormLabel__ = __webpack_require__(/*! @material-ui/core/es/FormLabel/FormLabel */ 621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CreditDetailsModal__ = __webpack_require__(/*! ./components/CreditDetailsModal */ 2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__ = __webpack_require__(/*! react-stripe-elements */ 341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SubscribeModal__ = __webpack_require__(/*! ./components/SubscribeModal */ 2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_confirmation_modal_ConfirmationModalActions__ = __webpack_require__(/*! ../../components/confirmation-modal/ConfirmationModalActions */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_BillingForm__ = __webpack_require__(/*! ./components/BillingForm */ 1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_edit_info_EditInfo__ = __webpack_require__(/*! ./components/edit-info/EditInfo */ 2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_edit_info_EditInfoActions__ = __webpack_require__(/*! ./components/edit-info/EditInfoActions */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_InvoicesTable__ = __webpack_require__(/*! ./components/InvoicesTable */ 2402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_BillingContainer__ = __webpack_require__(/*! ./components/BillingContainer */ 2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Trial__ = __webpack_require__(/*! ../../components/Trial */ 2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var Billing = function (_Component) {
    _inherits(Billing, _Component);

    function Billing() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Billing);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Billing.__proto__ || Object.getPrototypeOf(Billing)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            stripe: null
        }, _this.handlePaymentDetails = function (text) {
            _this.props.openInfoModal({
                content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__["StripeProvider"],
                    { stripe: _this.state.stripe },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__["Elements"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_BillingForm__["a" /* default */], null)
                    )
                ),
                text: text
            });
        }, _this.toggleDeleteHandler = function () {
            var _this$props = _this.props,
                openConfirmationModal = _this$props.openConfirmationModal,
                deleteCredit = _this$props.deleteCredit,
                last4Digits = _this$props.billing.customer.last4Digits;

            openConfirmationModal({ text: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    "Are you sure you want to delete credit detailes"
                ), callback: function callback() {
                    return deleteCredit(last4Digits);
                }, confirmCheckbox: false, btn1: 'Cancel', btn2: 'Confirm' });
        }, _this.renderLabelAndText = function (label, text) {
            var classes = _this.props.classes;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__components_material_pro_Grid_GridContainer__["a" /* default */],
                { className: classes.labelAndText },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__components_material_pro_Grid_GridItem__["a" /* default */],
                    { xs: 12, sm: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_FormLabel_FormLabel__["a" /* default */],
                        null,
                        label,
                        ":"
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__components_material_pro_Grid_GridItem__["a" /* default */],
                    { xs: 12, sm: 9 },
                    text
                )
            );
        }, _this.renderBody = function () {
            var _this$props2 = _this.props,
                billing = _this$props2.billing,
                app = _this$props2.app,
                toggleCreditDetails = _this$props2.toggleCreditDetails,
                classes = _this$props2.classes;

            if (app.fetching || billing.fetching) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { textAlign: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_CircularProgress_CircularProgress__["a" /* default */], { size: 45 })
                );
            }
            if (!app.stripe.enabled) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_redux_i18n__["Translate"], { value: "billing.billingNotEnabledForDomain" })
                );
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_BillingContainer__["a" /* default */], { handlePaymentDetails: _this.handlePaymentDetails });
        }, _this.renderBody2 = function (env) {
            var app = _this.props.app;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                app.stripe.enabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__["StripeProvider"],
                    { stripe: _this.state.stripe },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__["Elements"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_SubscribeModal__["a" /* default */], { env: env })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Billing, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this.props.getCreditDetails();
            this.props.getInvoices();
            this.props.changePageHeader('Billing');
            // this.props.toggleCreditDetails()
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var app = nextProps.app,
                billing = nextProps.billing,
                getCreditDetails = nextProps.getCreditDetails,
                closeInfoModal = nextProps.closeInfoModal;


            if (billing.needUpdate) {
                getCreditDetails();
                closeInfoModal();
                this.props.getPlans();
                this.props.getEmailPlans();
                this.props.getInvoices();
            }
            if (!app.fetching && !billing.fetching && app.stripe.stripePublishableKey) {
                if (window.Stripe) {
                    this.setState({ stripe: window.Stripe(app.stripe.stripePublishableKey) });
                } else {
                    var stripeScript = document.getElementById('stripeScript');
                    stripeScript.addEventListener('load', function () {
                        _this2.setState({ stripe: window.Stripe(app.stripe.stripePublishableKey) });
                    });
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                app = _props.app,
                _props$billing = _props.billing,
                openCreditDetails = _props$billing.openCreditDetails,
                invoicesContent = _props$billing.invoicesContent;

            return app && app.env === 'production' || app.env === 'Production' || app.env === "staging" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Trial__["a" /* default */], { routeName: "Billing" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                this.renderBody(),
                app.stripe.enabled && this.state.stripe && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__["StripeProvider"],
                    { stripe: this.state.stripe },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_react_stripe_elements__["Elements"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CreditDetailsModal__["a" /* default */], { open: openCreditDetails })
                    )
                ),
                invoicesContent && invoicesContent.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.pageTitle },
                    "Billing History"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_InvoicesTable__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    null,
                    "Subscribe beta"
                ),
                this.renderBody2(app.env),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_edit_info_EditInfo__["a" /* default */], null)
            );
        }
    }]);

    return Billing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref2) {
    var app = _ref2.app,
        billing = _ref2.billing;
    return { app: app, billing: billing };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({ getCreditDetails: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["I" /* getCreditDetails */], toggleCreditDetails: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["P" /* toggleCreditDetails */], getPlans: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["O" /* getPlans */], getInvoices: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["M" /* getInvoices */], deleteCredit: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["B" /* deleteCredit */], getEmailPlans: __WEBPACK_IMPORTED_MODULE_5__BillingActions__["K" /* getEmailPlans */], openConfirmationModal: __WEBPACK_IMPORTED_MODULE_14__components_confirmation_modal_ConfirmationModalActions__["d" /* openConfirmationModal */], openInfoModal: __WEBPACK_IMPORTED_MODULE_17__components_edit_info_EditInfoActions__["d" /* openInfoModal */], closeInfoModal: __WEBPACK_IMPORTED_MODULE_17__components_edit_info_EditInfoActions__["c" /* closeInfoModal */], changePageHeader: __WEBPACK_IMPORTED_MODULE_21__app_AppActions__["f" /* changePageHeader */] }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__jss_BillingStyles__["a" /* default */])(Billing)));

/***/ }),

/***/ 2356:
/*!*****************************************************************!*\
  !*** ./src/containers/billing/components/CreditDetailsModal.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BillingForm__ = __webpack_require__(/*! ./BillingForm */ 1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_material_pro_Modal_Modal__ = __webpack_require__(/*! ../../../components/material-pro/Modal/Modal */ 1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BillingActions__ = __webpack_require__(/*! ../BillingActions */ 161);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CreditDetailsModal = function (_Component) {
    _inherits(CreditDetailsModal, _Component);

    function CreditDetailsModal() {
        _classCallCheck(this, CreditDetailsModal);

        return _possibleConstructorReturn(this, (CreditDetailsModal.__proto__ || Object.getPrototypeOf(CreditDetailsModal)).apply(this, arguments));
    }

    _createClass(CreditDetailsModal, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                _props$billing = _props.billing,
                saving = _props$billing.saving,
                customer = _props$billing.customer,
                openCreditDetails = _props$billing.openCreditDetails,
                toggleCreditDetails = _props.toggleCreditDetails;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_material_pro_Modal_Modal__["a" /* default */], {
                open: openCreditDetails,
                disableBackdropClick: saving,
                onClose: function onClose() {
                    return toggleCreditDetails();
                },
                title: customer.last4Digits ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__["Translate"], { value: "billing.creditDetailsModal.headers.edit", last4Digits: customer.last4Digits }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__["Translate"], { value: "billing.creditDetailsModal.headers.add" }),
                content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BillingForm__["a" /* default */], null)
            });
        }
    }]);

    return CreditDetailsModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var billing = _ref.billing;
    return { billing: billing };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({ toggleCreditDetails: __WEBPACK_IMPORTED_MODULE_6__BillingActions__["P" /* toggleCreditDetails */] }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(CreditDetailsModal));

/***/ }),

/***/ 2357:
/*!******************************************************************!*\
  !*** ./src/components/reduxFields/ReduxSearchableSelectField.js ***!
  \******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_pro_Grid_GridContainer__ = __webpack_require__(/*! ../material-pro/Grid/GridContainer */ 339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_pro_Grid_GridItem__ = __webpack_require__(/*! ../material-pro/Grid/GridItem */ 340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_jss_reduxFields_ReduxField__ = __webpack_require__(/*! ../../assets/jss/reduxFields/ReduxField */ 1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_FormControl_FormControl__ = __webpack_require__(/*! @material-ui/core/es/FormControl/FormControl */ 337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_FormLabel_FormLabel__ = __webpack_require__(/*! @material-ui/core/es/FormLabel/FormLabel */ 621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grow_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow/Grow */ 217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_FormHelperText_FormHelperText__ = __webpack_require__(/*! @material-ui/core/es/FormHelperText/FormHelperText */ 338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_InputLabel_InputLabel__ = __webpack_require__(/*! @material-ui/core/es/InputLabel/InputLabel */ 1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_virtualized_styles_css__ = __webpack_require__(/*! react-virtualized/styles.css */ 2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_virtualized_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_virtualized_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_virtualized_select_styles_css__ = __webpack_require__(/*! react-virtualized-select/styles.css */ 2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_virtualized_select_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_virtualized_select_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_virtualized_select__ = __webpack_require__(/*! react-virtualized-select */ 2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_virtualized_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_virtualized_select__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import Select from 'react-select';









// import 'react-select/dist/react-select.css'




var customStyles = {
    menu: function menu(provided, state) {
        return Object.assign({}, provided, {
            color: state.selectProps.menuColor,
            height: "180px",
            zIndex: '2'
        });
    },
    menuList: function menuList(provided, state) {
        return Object.assign({}, provided, {
            color: state.selectProps.menuColor,
            height: "180px",
            zIndex: '2'
        });
    },
    control: function control(provided, state) {
        return Object.assign({}, provided, {
            color: state.selectProps.menuColor,
            height: "56px"
        });
    }
};

var ReduxSearchableSelectField = function (_Component) {
    _inherits(ReduxSearchableSelectField, _Component);

    function ReduxSearchableSelectField() {
        _classCallCheck(this, ReduxSearchableSelectField);

        return _possibleConstructorReturn(this, (ReduxSearchableSelectField.__proto__ || Object.getPrototypeOf(ReduxSearchableSelectField)).apply(this, arguments));
    }

    _createClass(ReduxSearchableSelectField, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                label = _props.label,
                input = _props.input,
                meta = _props.meta,
                options = _props.options,
                placeholder = _props.placeholder,
                classes = _props.classes,
                disabled = _props.disabled;

            var newInput = { value: input.value, label: input.value };
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_FormControl_FormControl__["a" /* default */],
                { error: meta.error && meta.touched, fullWidth: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_pro_Grid_GridContainer__["a" /* default */],
                    null,
                    label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2__material_pro_Grid_GridItem__["a" /* default */],
                        { xs: 12, sm: 2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_FormLabel_FormLabel__["a" /* default */],
                            { className: classes.labelHorizontal },
                            label
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2__material_pro_Grid_GridItem__["a" /* default */],
                        { xs: 12, sm: label ? 10 : 12 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_virtualized_select___default.a, {
                            id: "select-label",
                            options: options,
                            classNamePrefix: "react-select",
                            onChange: function onChange(value) {
                                return input.onChange(value.value);
                            },
                            value: newInput.value,
                            clearable: false,
                            disabled: disabled,
                            placeholder: placeholder
                        }),
                        meta.error && meta.touched && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Grow_Grow__["a" /* default */],
                            { "in": meta.error && meta.touched },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_FormHelperText_FormHelperText__["a" /* default */],
                                null,
                                meta.error
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ReduxSearchableSelectField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__assets_jss_reduxFields_ReduxField__["a" /* default */])(ReduxSearchableSelectField));

/***/ }),

/***/ 2358:
/*!***********************************************************************************!*\
  !*** ./src/assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx ***!
  \***********************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__ = __webpack_require__(/*! ../material-dashboard-pro-react.jsx */ 175);


var customCheckboxRadioSwitch = {
    checkboxAndRadio: {
        position: "relative",
        display: "block",
        marginTop: "10px",
        marginBottom: "10px"
    },
    checkboxAndRadioHorizontal: {
        position: "relative",
        display: "block",
        "&:first-child": {
            marginTop: "10px"
        },
        "&:not(:first-child)": {
            marginTop: "-14px"
        },
        marginTop: "0",
        marginBottom: "0"
    },
    checked: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["f" /* primaryColor */] + "!important"
    },
    checkedIcon: {
        width: "20px",
        height: "20px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    uncheckedIcon: {
        width: "0px",
        height: "0px",
        padding: "9px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    disabledCheckboxAndRadio: {
        "& $checkedIcon,& $uncheckedIcon,& $radioChecked,& $radioUnchecked": {
            borderColor: "#000000",
            opacity: "0.26",
            color: "#000000"
        }
    },
    label: {
        cursor: "pointer",
        paddingLeft: "0",
        color: "#AAAAAA",
        fontSize: "14px",
        lineHeight: "1.428571429",
        fontWeight: "400",
        display: "inline-flex",
        transition: "0.3s ease all"
    },
    labelHorizontal: {
        // color: "rgba(0, 0, 0, 0.26)",
        cursor: "pointer",
        display: "inline-flex",
        fontSize: "14px",
        lineHeight: "1.428571429",
        fontWeight: "400",
        paddingTop: "16px",
        marginRight: "0",
        "@media (min-width: 992px)": {
            float: "right",
            textAlign: "end"
        }
    },
    labelHorizontalRadioCheckbox: {
        paddingTop: "22px"
    },
    labelLeftHorizontal: {
        color: "rgba(0, 0, 0, 0.26)",
        cursor: "pointer",
        display: "inline-flex",
        fontSize: "14px",
        lineHeight: "1.428571429",
        fontWeight: "400",
        paddingTop: "22px",
        marginRight: "0"
    },
    labelError: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["b" /* dangerColor */]
    },
    radio: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["f" /* primaryColor */] + "!important"
    },
    radioChecked: {
        width: "16px",
        height: "16px",
        border: "1px solid " + __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["f" /* primaryColor */],
        borderRadius: "50%"
    },
    radioUnchecked: {
        width: "0px",
        height: "0px",
        padding: "7px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "50%"
    },
    inlineChecks: {
        marginTop: "8px"
    },
    iconCheckbox: {
        height: "116px",
        width: "116px",
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["d" /* grayColor */],
        "& > span:first-child": {
            borderWidth: "4px",
            borderStyle: "solid",
            borderColor: "#CCCCCC",
            textAlign: "center",
            verticalAlign: "middle",
            borderRadius: "50%",
            color: "inherit",
            margin: "0 auto 20px",
            transition: "all 0.2s"
        },
        "&:hover": {
            color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */],
            "& > span:first-child": {
                borderColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */]
            }
        }
    },
    iconCheckboxChecked: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */],
        "& > span:first-child": {
            borderColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */]
        }
    },
    iconCheckboxIcon: {
        fontSize: "40px",
        lineHeight: "111px"
    },
    switchBase: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["f" /* primaryColor */] + "!important"
    },
    switchIcon: {
        boxShadow: "0 1px 3px 1px rgba(0, 0, 0, 0.4)",
        color: "#FFFFFF !important",
        border: "1px solid rgba(0, 0, 0, .54)",
        transform: "translateX(-4px)!important"
    },
    switchIconChecked: {
        borderColor: "#9c27b0",
        transform: "translateX(0px)!important"
    },
    switchBar: {
        width: "30px",
        height: "15px",
        backgroundColor: "rgb(80, 80, 80)",
        borderRadius: "15px",
        opacity: "0.7!important"
    },
    switchChecked: {
        "& + $switchBar": {
            backgroundColor: "rgba(156, 39, 176, 1) !important"
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (customCheckboxRadioSwitch);

/***/ }),

/***/ 2387:
/*!***********************************************************!*\
  !*** ./src/components/material-pro/Clearfix/Clearfix.jsx ***!
  \***********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(/*! prop-types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/styles/withStyles */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// mterial-ui components


var style = {
  clearfix: {
    "&:after,&:before": {
      display: "table",
      content: '" "'
    },
    "&:after": {
      clear: "both"
    }
  }
};

function Clearfix(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var classes = props.classes;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classes.clearfix });
}

Clearfix.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(Clearfix));

/***/ }),

/***/ 2388:
/*!*******************************************************************!*\
  !*** ./src/containers/billing/components/InjectedCheckoutForm.js ***!
  \*******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__ = __webpack_require__(/*! react-redux/es/connect/connect */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_es_bindActionCreators__ = __webpack_require__(/*! redux/es/bindActionCreators */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__ = __webpack_require__(/*! react-stripe-elements */ 341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_material_pro_Grid_GridContainer__ = __webpack_require__(/*! ../../../components/material-pro/Grid/GridContainer */ 339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_material_pro_Grid_GridItem__ = __webpack_require__(/*! ../../../components/material-pro/Grid/GridItem */ 340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jss_InjectedCheckoutFormStyles__ = __webpack_require__(/*! ../jss/InjectedCheckoutFormStyles */ 1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Grow_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow/Grow */ 217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_FormHelperText_FormHelperText__ = __webpack_require__(/*! @material-ui/core/es/FormHelperText/FormHelperText */ 338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_es_Field__ = __webpack_require__(/*! redux-form/es/Field */ 373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reduxFields_ReduxInsideLabelTextField__ = __webpack_require__(/*! ../../../components/reduxFields/ReduxInsideLabelTextField */ 1203);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var InjectedCheckoutForm = function (_Component) {
    _inherits(InjectedCheckoutForm, _Component);

    function InjectedCheckoutForm() {
        _classCallCheck(this, InjectedCheckoutForm);

        return _possibleConstructorReturn(this, (InjectedCheckoutForm.__proto__ || Object.getPrototypeOf(InjectedCheckoutForm)).apply(this, arguments));
    }

    _createClass(InjectedCheckoutForm, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                handleCardErrors = _props.handleCardErrors,
                error = _props.error;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__components_material_pro_Grid_GridContainer__["a" /* default */],
                    { className: classes.frontCard },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__components_material_pro_Grid_GridItem__["a" /* default */],
                        { md: 12, sm: 12, xs: 12 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "label",
                            { className: classes.formLabel },
                            "Card number",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__["CardNumberElement"], {
                                className: classes.formInput,
                                onChange: function onChange(event) {
                                    console.log("CardNumberElement [change]", event);
                                    handleCardErrors(event);
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__components_material_pro_Grid_GridItem__["a" /* default */],
                        { md: 8, sm: 7, xs: 12 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "label",
                            { className: classes.formLabel },
                            "Name on card",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form_es_Field__["a" /* default */], {
                                className: classes.formInputField,
                                name: "cardName",
                                component: __WEBPACK_IMPORTED_MODULE_11__components_reduxFields_ReduxInsideLabelTextField__["a" /* default */]
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__components_material_pro_Grid_GridItem__["a" /* default */],
                        { md: 4, sm: 5, xs: 12 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "label",
                            { className: classes.formLabel },
                            "Expiration date",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__["CardExpiryElement"], {
                                className: classes.formInput,
                                onChange: function onChange(event) {
                                    console.log("CardNumberElement [change]", event);
                                    handleCardErrors(event);
                                }
                            })
                        )
                    ),
                    error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__components_material_pro_Grid_GridItem__["a" /* default */],
                        { sm: 12, md: 12 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Grow_Grow__["a" /* default */],
                            { "in": error },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_FormHelperText_FormHelperText__["a" /* default */],
                                { error: true },
                                error
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__components_material_pro_Grid_GridContainer__["a" /* default */],
                    { className: classes.backCard },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__components_material_pro_Grid_GridItem__["a" /* default */],
                        { md: 12, sm: 12, xs: 12, className: classes.backCardGridItem },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classes.backCardStripe }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "label",
                            { className: classes.formLabelCvv },
                            "CVV / CVC",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__["CardCvcElement"], {
                                className: classes.formInput,
                                onChange: function onChange(event) {
                                    console.log("CardNumberElement [change]", event);
                                    handleCardErrors(event);
                                }
                            })
                        )
                    )
                )
            );
        }
    }]);

    return InjectedCheckoutForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    _objectDestructuringEmpty(_ref);

    return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux_es_bindActionCreators__["a" /* default */])({}, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__jss_InjectedCheckoutFormStyles__["a" /* default */])(InjectedCheckoutForm)));

/***/ }),

/***/ 2389:
/*!*****************************************************************!*\
  !*** ./src/components/material-pro/CustomInput/CustomInput.jsx ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_components_customInputStyle_jsx__ = __webpack_require__(/*! ../../../assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx */ 2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_es_Clear__ = __webpack_require__(/*! @material-ui/icons/es/Clear */ 2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_es_Check__ = __webpack_require__(/*! @material-ui/icons/es/Check */ 2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_FormControl_FormControl__ = __webpack_require__(/*! @material-ui/core/es/FormControl/FormControl */ 337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TextField_TextField__ = __webpack_require__(/*! @material-ui/core/es/TextField/TextField */ 1194);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }


// nodejs library to set properties for components










function CustomInput(_ref) {
  var _classNames, _classNames2, _classNames4;

  var props = _objectWithoutProperties(_ref, []);

  var classes = props.classes,
      formControlProps = props.formControlProps,
      labelText = props.labelText,
      id = props.id,
      labelProps = props.labelProps,
      inputProps = props.inputProps,
      error = props.error,
      white = props.white,
      inputRootCustomClasses = props.inputRootCustomClasses,
      success = props.success;


  var labelClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, _defineProperty(_classNames, " " + classes.labelRootError, error), _defineProperty(_classNames, " " + classes.labelRootSuccess, success && !error), _classNames));
  var underlineClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, classes.underlineError, error), _defineProperty(_classNames2, classes.underlineSuccess, success && !error), _defineProperty(_classNames2, classes.underline, true), _defineProperty(_classNames2, classes.whiteUnderline, white), _classNames2));
  var marginTop = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}, inputRootCustomClasses, inputRootCustomClasses !== undefined));
  var inputClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames4 = {}, _defineProperty(_classNames4, classes.input, true), _defineProperty(_classNames4, classes.whiteInput, white), _classNames4));
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(formControlProps.className, classes.formControl);
  } else {
    formControlClasses = classes.formControl;
  }
  var feedbackClasses = classes.feedback;
  if (inputProps !== undefined) {
    if (inputProps.endAdornment !== undefined) {
      feedbackClasses = feedbackClasses + " " + classes.feedbackRight;
    }
  }
  return (
    // <FormControl {...formControlProps} className={formControlClasses}>
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", Object.assign({
      label: labelText || '',
      id: id
    }, inputProps))
    //   {error ? (
    //     <Clear className={feedbackClasses + " " + classes.labelRootError} />
    //   ) : success ? (
    //     <Check className={feedbackClasses + " " + classes.labelRootSuccess} />
    //   ) : null}
    // </FormControl>

  );
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__assets_jss_material_dashboard_pro_react_components_customInputStyle_jsx__["a" /* default */])(CustomInput));

/***/ }),

/***/ 2390:
/*!*************************************************************************************!*\
  !*** ./src/assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx ***!
  \*************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__ = __webpack_require__(/*! ../../material-dashboard-pro-react.jsx */ 175);


var customInputStyle = {
    disabled: {
        "&:before": {
            borderColor: "transparent !important"
        }
    },
    underline: {
        "&:hover:not($disabled):before,&:before": {
            borderColor: "#D2D2D2 !important",
            borderWidth: "1px !important"
        },
        "&:after": {
            borderColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["f" /* primaryColor */]
        }
    },
    underlineError: {
        "&:after": {
            borderColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["b" /* dangerColor */]
        }
    },
    underlineSuccess: {
        "&:after": {
            borderColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["h" /* successColor */]
        }
    },
    labelRoot: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["c" /* defaultFont */], {
        color: "#AAAAAA !important",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        top: "10px",
        "& + $underline": {
            marginTop: "0px"
        }
    }),
    labelRootError: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["b" /* dangerColor */] + " !important"
    },
    labelRootSuccess: {
        color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["h" /* successColor */] + " !important"
    },
    feedback: {
        position: "absolute",
        bottom: "3px",
        right: "0",
        zIndex: "2",
        display: "block",
        width: "1em",
        height: "1em",
        textAlign: "center",
        pointerEvents: "none"
    },
    feedbackRight: {
        marginRight: "22px"
    },
    formControl: {
        position: "relative",
        "& svg,& .fab,& .far,& .fal,& .fas": {
            color: "#495057"
        }
    },
    whiteUnderline: {
        "&:hover:not($disabled):before,&:before": {
            backgroundColor: "#FFFFFF"
        },
        "&:after": {
            backgroundColor: "#FFFFFF"
        }
    },
    input: {
        color: "#495057",
        "&,&::placeholder": {
            fontSize: "14px",
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: "400",
            lineHeight: "1.42857",
            opacity: "1"
        },
        "&::placeholder": {
            color: "#AAAAAA"
        }
    },
    whiteInput: {
        "&,&::placeholder": {
            color: "#FFFFFF",
            opacity: "1"
        }
    },
    shrink: {
        transform: 'translate(0, 1.5px) scale(0.9)',
        transformOrigin: 'top left'
    }
};

/* harmony default export */ __webpack_exports__["a"] = (customInputStyle);

/***/ }),

/***/ 2394:
/*!********************************************************************************!*\
  !*** ./src/assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx ***!
  \********************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__ = __webpack_require__(/*! ../../material-dashboard-pro-react.jsx */ 175);
// ##############################
// // // Button styles
// #############################



var buttonStyle = function buttonStyle(theme) {
    return {
        loadingContainerSimple: {
            color: theme.palette.primary.main + ' !important'
        },
        loadingContainer: {
            color: 'white',
            textAlign: 'center'
        },
        button: {
            minHeight: "auto",
            minWidth: "100px",
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["d" /* grayColor */],
            color: "#FFFFFF",
            boxShadow: "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
            border: "none",
            borderRadius: "3px",
            position: "relative",
            padding: "12px 30px",
            margin: ".3125rem 1px",
            fontSize: "12px",
            fontWeight: "400",
            textTransform: "uppercase",
            letterSpacing: "0",
            willChange: "box-shadow, transform",
            transition: "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            lineHeight: "1.42857143",
            textAlign: "center",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            touchAction: "manipulation",
            cursor: "pointer",
            "&:hover,&:focus": {
                color: "#FFFFFF",
                backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["d" /* grayColor */],
                boxShadow: "0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"
            },
            "& .fab,& .fas,& .far,& .fal": {
                position: "relative",
                display: "inline-block",
                top: "0",
                marginTop: "-1em",
                marginBottom: "-1em",
                fontSize: "1.1rem",
                marginRight: "4px",
                verticalAlign: "middle"
            },
            "& svg": {
                position: "relative",
                display: "inline-block",
                top: "0",
                width: "18px",
                height: "18px",
                marginRight: "4px",
                verticalAlign: "middle"
            },
            "&$justIcon": {
                "& .fab,& .fas,& .far,& .fal": {
                    marginTop: "0px",
                    position: "absolute",
                    width: "100%",
                    transform: "none",
                    left: "0px",
                    top: "0px",
                    height: "100%",
                    lineHeight: "41px",
                    fontSize: "20px"
                }
            }
        },
        fullWidth: {
            width: "100%"
        },
        primary: {
            backgroundColor: theme.palette.primary.main,
            boxShadow: "0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)",
            "&:hover,&:focus": {
                backgroundColor: theme.palette.primary.main,
                boxShadow: "0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)"
            }
        },
        info: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["e" /* infoColor */],
            boxShadow: "0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["e" /* infoColor */],
                boxShadow: "0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)"
            }
        },
        success: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["h" /* successColor */],
            boxShadow: "0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["h" /* successColor */],
                boxShadow: "0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)"
            }
        },
        warning: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["i" /* warningColor */],
            boxShadow: "0 2px 2px 0 rgba(255, 152, 0, 0.14), 0 3px 1px -2px rgba(255, 152, 0, 0.2), 0 1px 5px 0 rgba(255, 152, 0, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["i" /* warningColor */],
                boxShadow: "0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)"
            }
        },
        danger: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["b" /* dangerColor */],
            boxShadow: "0 2px 2px 0 rgba(244, 67, 54, 0.14), 0 3px 1px -2px rgba(244, 67, 54, 0.2), 0 1px 5px 0 rgba(244, 67, 54, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["b" /* dangerColor */],
                boxShadow: "0 14px 26px -12px rgba(244, 67, 54, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(244, 67, 54, 0.2)"
            }
        },
        rose: {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */],
            boxShadow: "0 2px 2px 0 rgba(233, 30, 99, 0.14), 0 3px 1px -2px rgba(233, 30, 99, 0.2), 0 1px 5px 0 rgba(233, 30, 99, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */],
                boxShadow: "0 14px 26px -12px rgba(233, 30, 99, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(233, 30, 99, 0.2)"
            }
        },
        white: {
            "&,&:focus,&:hover": {
                backgroundColor: "#FFFFFF",
                color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["d" /* grayColor */]
            }
        },
        twitter: {
            backgroundColor: "#55acee",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)",
            "&:hover,&:focus,&:visited": {
                backgroundColor: "#55acee",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)"
            }
        },
        facebook: {
            backgroundColor: "#3b5998",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#3b5998",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)"
            }
        },
        google: {
            backgroundColor: "#dd4b39",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#dd4b39",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"
            }
        },
        linkedin: {
            backgroundColor: "#0976b4",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(9, 118, 180, 0.14), 0 3px 1px -2px rgba(9, 118, 180, 0.2), 0 1px 5px 0 rgba(9, 118, 180, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#0976b4",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(9, 118, 180, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(9, 118, 180, 0.2)"
            }
        },
        pinterest: {
            backgroundColor: "#cc2127",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(204, 33, 39, 0.14), 0 3px 1px -2px rgba(204, 33, 39, 0.2), 0 1px 5px 0 rgba(204, 33, 39, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#cc2127",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(204, 33, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(204, 33, 39, 0.2)"
            }
        },
        youtube: {
            backgroundColor: "#e52d27",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(229, 45, 39, 0.14), 0 3px 1px -2px rgba(229, 45, 39, 0.2), 0 1px 5px 0 rgba(229, 45, 39, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#e52d27",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(229, 45, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(229, 45, 39, 0.2)"
            }
        },
        tumblr: {
            backgroundColor: "#35465c",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(53, 70, 92, 0.14), 0 3px 1px -2px rgba(53, 70, 92, 0.2), 0 1px 5px 0 rgba(53, 70, 92, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#35465c",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(53, 70, 92, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(53, 70, 92, 0.2)"
            }
        },
        github: {
            backgroundColor: "#333333",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#333333",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)"
            }
        },
        behance: {
            backgroundColor: "#1769ff",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(23, 105, 255, 0.14), 0 3px 1px -2px rgba(23, 105, 255, 0.2), 0 1px 5px 0 rgba(23, 105, 255, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#1769ff",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2)"
            }
        },
        dribbble: {
            backgroundColor: "#ea4c89",
            color: "#fff",
            boxShadow: "0 2px 2px 0 rgba(234, 76, 137, 0.14), 0 3px 1px -2px rgba(234, 76, 137, 0.2), 0 1px 5px 0 rgba(234, 76, 137, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#ea4c89",
                color: "#fff",
                boxShadow: "0 14px 26px -12px rgba(234, 76, 137, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(234, 76, 137, 0.2)"
            }
        },
        reddit: {
            backgroundColor: "#ff4500",
            color: " #fff",
            boxShadow: "0 2px 2px 0 rgba(255, 69, 0, 0.14), 0 3px 1px -2px rgba(255, 69, 0, 0.2), 0 1px 5px 0 rgba(255, 69, 0, 0.12)",
            "&:hover,&:focus": {
                backgroundColor: "#ff4500",
                color: " #fff",
                boxShadow: "0 14px 26px -12px rgba(255, 69, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 69, 0, 0.2)"
            }
        },
        simple: {
            fontSize: '15px',
            "&,&:focus,&:hover": {
                color: "#7d7d7d",
                background: "transparent",
                boxShadow: "none"
            },
            "&$primary": {
                "&,&:focus,&:hover,&:visited": {
                    color: theme.palette.primary.main
                }
            },
            "&$info": {
                "&,&:focus,&:hover,&:visited": {
                    color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["e" /* infoColor */]
                }
            },
            "&$success": {
                "&,&:focus,&:hover,&:visited": {
                    color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["h" /* successColor */]
                }
            },
            "&$warning": {
                "&,&:focus,&:hover,&:visited": {
                    color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["i" /* warningColor */]
                }
            },
            "&$rose": {
                "&,&:focus,&:hover,&:visited": {
                    color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["g" /* roseColor */]
                }
            },
            "&$danger": {
                "&,&:focus,&:hover,&:visited": {
                    color: __WEBPACK_IMPORTED_MODULE_0__material_dashboard_pro_react_jsx__["b" /* dangerColor */]
                }
            },
            "&$twitter": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#55acee"
                }
            },
            "&$facebook": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#3b5998"
                }
            },
            "&$google": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#dd4b39"
                }
            },
            "&$linkedin": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#0976b4"
                }
            },
            "&$pinterest": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#cc2127"
                }
            },
            "&$youtube": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#e52d27"
                }
            },
            "&$tumblr": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#35465c"
                }
            },
            "&$github": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#333333"
                }
            },
            "&$behance": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#1769ff"
                }
            },
            "&$dribbble": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#ea4c89"
                }
            },
            "&$reddit": {
                "&,&:focus,&:hover,&:visited": {
                    color: "#ff4500"
                }
            }
        },
        transparent: {
            "&,&:focus,&:hover": {
                color: "inherit",
                background: "transparent"
                // boxShadow: "none"
            }
        },
        disabled: {
            opacity: "0.65",
            pointerEvents: "none"
        },
        lg: {
            padding: "1.125rem 2.25rem",
            fontSize: "0.875rem",
            lineHeight: "1.333333",
            borderRadius: "0.2rem"
        },
        sm: {
            padding: "0.40625rem 1.25rem",
            fontSize: "0.6875rem",
            lineHeight: "1.5",
            borderRadius: "0.2rem"
        },
        round: {
            borderRadius: "30px"
        },
        block: {
            width: "100% !important"
        },
        link: {
            "&,&:hover,&:focus": {
                backgroundColor: "transparent",
                color: "#999999",
                boxShadow: "none"
            }
        },
        justIcon: {
            paddingLeft: "12px",
            paddingRight: "12px",
            fontSize: "20px",
            height: "41px",
            minWidth: "41px",
            width: "41px",
            "& .fab,& .fas,& .far,& .fal,& svg": {
                marginRight: "0px"
            },
            "&$lg": {
                height: "57px",
                minWidth: "57px",
                width: "57px",
                lineHeight: "56px",
                "& .fab,& .fas,& .far,& .fal": {
                    fontSize: "32px",
                    lineHeight: "56px"
                },
                "& svg": {
                    width: "32px",
                    height: "32px"
                }
            },
            "&$sm": {
                height: "30px",
                minWidth: "30px",
                width: "30px",
                "& .fab,& .fas,& .far,& .fal": {
                    fontSize: "17px",
                    lineHeight: "29px"
                },
                "& svg": {
                    width: "17px",
                    height: "17px"
                }
            }
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (buttonStyle);

/***/ }),

/***/ 2395:
/*!********************************************************************!*\
  !*** ./src/assets/jss/material-dashboard-pro-react/modalStyle.jsx ***!
  \********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ##############################
// // // Modal component styles
// #############################

var modalStyle = function modalStyle(theme) {
    return {
        modalRoot: {
            overflow: "auto",
            alignItems: "unset"
        },
        big: _defineProperty({}, theme.breakpoints.up("sm"), {
            maxWidth: "1000px",
            margin: "1.75rem"
        }),
        medium: _defineProperty({}, theme.breakpoints.up("sm"), {
            maxWidth: "690px",
            margin: "1.75rem"
        }),
        modal: {
            borderRadius: "6px",
            minWidth: '320px'
            // marginTop: "100px !important",
            // overflow: "visible",
            // position: "relative",
            // height: "fit-content"
        },
        modalHeader: {
            borderBottom: "none",
            paddingTop: "24px",
            paddingRight: "24px",
            paddingBottom: "0",
            paddingLeft: "24px",
            minHeight: "16.43px"
        },
        modalTitle: {
            margin: "0",
            lineHeight: "1.42857143",
            paddingBottom: '0'
        },
        modalCloseButton: {
            color: "#999999",
            marginTop: "-12px",
            WebkitAppearance: "none",
            padding: "0",
            cursor: "pointer",
            background: "0 0",
            border: "0",
            fontSize: "inherit",
            opacity: ".9",
            textShadow: "none",
            fontWeight: "700",
            lineHeight: "1",
            float: "right"
        },
        modalClose: {
            width: "16px",
            height: "16px"
        },
        modalBody: {
            paddingTop: "24px",
            paddingRight: "24px",
            paddingBottom: "16px",
            paddingLeft: "24px",
            position: "relative",
            overflow: "visible",
            '@media screen and (max-width: 600px)': {
                paddingLeft: "5px",
                paddingRight: "5px"
            }
        },
        modalFooter: {
            padding: "15px",
            textAlign: "right",
            paddingTop: "0",
            margin: "0"
        },
        modalFooterCenter: {
            marginLeft: "auto",
            marginRight: "auto"
        },
        instructionNoticeModal: {
            marginBottom: "25px"
        },
        imageNoticeModal: {
            maxWidth: "150px"
        },
        modalSmall: {
            width: "300px"
        },
        modalSmallBody: {
            paddingTop: "0"
        },
        modalSmallFooterFirstButton: {
            margin: "0",
            paddingLeft: "16px",
            paddingRight: "16px",
            width: "auto"
        },
        modalSmallFooterSecondButton: {
            marginBottom: "0",
            marginLeft: "5px"
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (modalStyle);

/***/ }),

/***/ 2396:
/*!*************************************************************!*\
  !*** ./src/containers/billing/components/SubscribeModal.js ***!
  \*************************************************************/
/*! exports provided: SubscribeModal, default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubscribeModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(/*! babel-runtime/regenerator */ 195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_es_AccountBalanceWallet__ = __webpack_require__(/*! @material-ui/icons/es/AccountBalanceWallet */ 2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_es_Add__ = __webpack_require__(/*! @material-ui/icons/es/Add */ 2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_es_Remove__ = __webpack_require__(/*! @material-ui/icons/es/Remove */ 2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_es_DeleteForever__ = __webpack_require__(/*! @material-ui/icons/es/DeleteForever */ 2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_material_pro_CustomButtons_Button__ = __webpack_require__(/*! ../../../components/material-pro/CustomButtons/Button */ 1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_stripe_elements__ = __webpack_require__(/*! react-stripe-elements */ 341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BillingActions__ = __webpack_require__(/*! ../BillingActions */ 161);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SubscribeModal = function (_Component) {
    _inherits(SubscribeModal, _Component);

    function SubscribeModal() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, SubscribeModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubscribeModal.__proto__ || Object.getPrototypeOf(SubscribeModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            stripe: null
        }, _this.handleRequireAction = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(subscription) {
                var requireActionInfo, subId, email, clientSecret, paymentMethodId;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                requireActionInfo = subscription.requireActionInfo, subId = subscription.stripeSubscriptionId, email = subscription.email;
                                clientSecret = requireActionInfo.clientSecret, paymentMethodId = requireActionInfo.paymentMethodId;

                                // You can also use confirmCardPayment with the PaymentIntents API automatic confirmation flow.
                                // See our confirmCardPayment documentation for more:
                                // https://stripe.com/docs/stripe-js/reference#stripe-confirm-card-payment

                                _this.props.stripe.confirmCardPayment(clientSecret, {
                                    payment_method: paymentMethodId
                                }).then(function (result) {
                                    if (result.error) {
                                        // Start code flow to handle updating the payment details.
                                        // Display error message in your UI.
                                        // The card was declined (i.e. insufficient funds, card has expired, etc).
                                        throw result;
                                    } else {
                                        if (result.paymentIntent.status === 'succeeded') {
                                            // Show a success message to your customer.
                                            // There's a risk of the customer closing the window before the callback.
                                            // We recommend setting up webhook endpoints later in this guide.
                                            // TODO: update page
                                            _this.props.confirm3dSecure({ email: email, subId: subId });
                                            _this.props.getEmailPlans();
                                            _this.setState({});
                                        }
                                    }
                                }).catch(function (error) {
                                    // console.error(`[CheckoutForm][handleSubmit]`,error)
                                    // TODO: Error
                                    // displayError(error);
                                });

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }(), _this.subscribeHandler = function (planId) {
            _this.props.attachPlanToClient(planId);
        }, _this.unSubscribeHandler = function (planId) {
            _this.props.detachPlanFromClient(planId);
        }, _this.cancelAllHandler = function () {
            _this.props.deletePlansFromClient();
        }, _this.showOnScreen = function () {
            var _this$props = _this.props,
                _this$props$billing = _this$props.billing,
                customer = _this$props$billing.customer,
                plansContent = _this$props$billing.plansContent,
                emailPlans = _this$props$billing.emailPlans,
                env = _this$props.env;

            var plansObjects = [].concat(_toConsumableArray(plansContent));
            var emailPlansObjects = [].concat(_toConsumableArray(emailPlans));

            if (env === 'production') {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "p",
                    null,
                    customer.name,
                    " ",
                    customer.country,
                    " ",
                    customer.email
                ),
                env === 'production' ? '' : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__components_material_pro_CustomButtons_Button__["a" /* default */],
                    { onClick: function onClick() {
                            return _this.cancelAllHandler();
                        }, color: "info" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_es_DeleteForever__["a" /* default */], null),
                    "CANCEL ALL"
                ),
                plansObjects.map(function (plan) {
                    var emailPlan = emailPlansObjects.find(function (item) {
                        return item.id === plan.id;
                    });
                    var subscription = emailPlan && emailPlan.emailSubscriptionsViewEntities && emailPlan.emailSubscriptionsViewEntities[0];
                    var isMarked = emailPlansObjects.some(function (item) {
                        return item.id === plan.id;
                    });
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { key: plan.id,
                            style: { backgroundColor: isMarked ? subscription.subscriptionStatus === 1 ? 'green' : 'yellow' : 'initial' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "p",
                            null,
                            plan.name,
                            " ",
                            plan.id,
                            " Status: ",
                            subscription && subscription.subscriptionStatusText || 'not subscribed',
                            " ",
                            subscription && '    |   Cancel at period end = ' + subscription.cancelAtPeriodEnd + '  |   Valid until ' + new Date(subscription.validUntil).toISOString(),
                            " "
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8__components_material_pro_CustomButtons_Button__["a" /* default */],
                            {
                                disabled: !customer.last4Digits || subscription && subscription.subscriptionStatus === 1 && subscription.cancelAtPeriodEnd === false || subscription && subscription.requireActionInfo,
                                onClick: function onClick() {
                                    return _this.subscribeHandler(plan.id);
                                }, color: "info" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_es_Add__["a" /* default */], null),
                            subscription && subscription.cancelAtPeriodEnd ? ' RESUME' : 'SUBSCRIBE'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8__components_material_pro_CustomButtons_Button__["a" /* default */],
                            { disabled: !subscription || subscription.subscriptionStatus !== 1 || subscription.subscriptionStatus === 1 && subscription.cancelAtPeriodEnd === true || !customer.last4Digits, onClick: function onClick() {
                                    return _this.unSubscribeHandler(plan.id);
                                },
                                color: "info" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_es_Remove__["a" /* default */], null),
                            "UNSUBSCRIBE"
                        ),
                        customer.last4Digits && subscription && subscription.requireActionInfo ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8__components_material_pro_CustomButtons_Button__["a" /* default */],
                            {
                                onClick: function onClick() {
                                    return _this.handleRequireAction(subscription);
                                },
                                color: "info" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_es_AccountBalanceWallet__["a" /* default */], null),
                            "Authenticate"
                        ) : ''
                    );
                })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SubscribeModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.props.getPlans();
            this.props.getEmailPlans();
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _this3 = this;

            var app = nextProps.app,
                billing = nextProps.billing;


            if (!app.fetching && !billing.fetching && app.stripe.stripePublishableKey) {
                if (window.Stripe) {
                    this.setState({ stripe: window.Stripe(app.stripe.stripePublishableKey) });
                } else {
                    var stripeScript = document.getElementById('stripeScript');
                    stripeScript.addEventListener('load', function () {
                        _this3.setState({ stripe: window.Stripe(app.stripe.stripePublishableKey) });
                    });
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                null,
                this.showOnScreen()
            );
        }
    }]);

    return SubscribeModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref3) {
    var app = _ref3.app,
        billing = _ref3.billing;
    return { app: app, billing: billing };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        getCreditDetails: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["I" /* getCreditDetails */],
        toggleCreditDetails: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["P" /* toggleCreditDetails */],
        getPlans: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["O" /* getPlans */],
        getEmailPlans: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["K" /* getEmailPlans */],
        attachPlanToClient: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["w" /* attachPlanToClient */],
        detachPlanFromClient: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["G" /* detachPlanFromClient */],
        deletePlansFromClient: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["E" /* deletePlansFromClient */],
        confirm3dSecure: __WEBPACK_IMPORTED_MODULE_10__BillingActions__["x" /* confirm3dSecure */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_9_react_stripe_elements__["injectStripe"])(SubscribeModal)));
// export default SubscribeModal

/***/ }),

/***/ 2401:
/*!*****************************************************************!*\
  !*** ./src/containers/billing/components/edit-info/EditInfo.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditInfoActions__ = __webpack_require__(/*! ./EditInfoActions */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_material_pro_Modal_Modal__ = __webpack_require__(/*! ../../../../components/material-pro/Modal/Modal */ 1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = function styles(theme) {
    return {
        big: {
            maxHeight: 435
        }
    };
};

var EditInfo = function (_Component) {
    _inherits(EditInfo, _Component);

    function EditInfo() {
        _classCallCheck(this, EditInfo);

        return _possibleConstructorReturn(this, (EditInfo.__proto__ || Object.getPrototypeOf(EditInfo)).apply(this, arguments));
    }

    _createClass(EditInfo, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                handleCardErrors = _props.handleCardErrors,
                error = _props.error,
                _props$infoModal = _props.infoModal,
                open = _props$infoModal.open,
                content = _props$infoModal.content,
                text = _props$infoModal.text,
                closeInfoModal = _props.closeInfoModal;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_material_pro_Modal_Modal__["a" /* default */], { open: open, medium: true, onClose: closeInfoModal, content: content, title: text });
        }
    }]);

    return EditInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var infoModal = _ref.infoModal,
        billing = _ref.billing;
    return { infoModal: infoModal, billing: billing };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, { closeInfoModal: __WEBPACK_IMPORTED_MODULE_1__EditInfoActions__["c" /* closeInfoModal */] })(Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(EditInfo)));

/***/ }),

/***/ 2402:
/*!************************************************************!*\
  !*** ./src/containers/billing/components/InvoicesTable.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Table__ = __webpack_require__(/*! @material-ui/core/es/Table */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody__ = __webpack_require__(/*! @material-ui/core/TableBody */ 221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_TableRow__ = __webpack_require__(/*! @material-ui/core/es/TableRow */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__ = __webpack_require__(/*! @material-ui/core/es/TableCell */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__ = __webpack_require__(/*! @material-ui/core/TableHead */ 227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var styles = function styles(theme) {
    return {
        tableContainer: {
            overflowX: 'auto',
            marginBottom: '50px',
            borderTop: '1px solid rgba(0, 0, 0, 0.13)',
            borderLeft: '1px solid rgba(0, 0, 0, 0.13)',
            borderRight: '1px solid rgba(0, 0, 0, 0.13)',
            borderRadius: '5px'
        },
        tableCell: {
            fontSize: '14px',
            borderRight: '1px solid rgba(0, 0, 0, 0.13)'
        },
        tableRow: {
            '& th:last-child': {
                borderRight: 'none'
            }
        }
    };
};

var InvoicesTable = function (_Component) {
    _inherits(InvoicesTable, _Component);

    function InvoicesTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, InvoicesTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InvoicesTable.__proto__ || Object.getPrototypeOf(InvoicesTable)).call.apply(_ref, [this].concat(args))), _this), _this.convertToLocale = function (value) {
            var parsedValue = parseInt(value);
            if (!isNaN(parsedValue)) {
                var date = new Date(parsedValue.toString().length === 10 ? parsedValue * 1000 : parsedValue);
                return date.toLocaleString();
            }
            return "N/A";
        }, _this.AmmountPaid = function (amount_paid, currency) {
            if (amount_paid) {
                var money = amount_paid / 100;
                if (currency) {
                    money = money.toLocaleString("en-US", { style: "currency", currency: currency });
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    money
                );
            } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InvoicesTable, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$billing = _props.billing,
                invoicesContent = _props$billing.invoicesContent,
                error = _props$billing.error,
                classes = _props.classes;

            return invoicesContent && invoicesContent.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: classes.tableContainer },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Table__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default.a,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_TableRow__["a" /* default */],
                            { className: classes.tableRow },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                { className: classes.tableCell },
                                "Created"
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                { className: classes.tableCell },
                                "Amount due"
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                { className: classes.tableCell },
                                "Amount paid"
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                { className: classes.tableCell },
                                "Amount remaining"
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                { className: classes.tableCell },
                                "Status"
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody___default.a,
                        null,
                        invoicesContent.map(function (invoice) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_TableRow__["a" /* default */],
                                { className: classes.tableRow, key: invoice.id },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    _this2.convertToLocale(invoice.created)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    _this2.AmmountPaid(invoice.amount_due, invoice.currency)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    _this2.AmmountPaid(invoice.amount_paid, invoice.currency)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    _this2.AmmountPaid(invoice.amount_remaining, invoice.currency)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    invoice.status
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return InvoicesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref2) {
    var infoModal = _ref2.infoModal,
        billing = _ref2.billing;
    return { infoModal: infoModal, billing: billing };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {})(Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(InvoicesTable)));

/***/ }),

/***/ 2403:
/*!***************************************************************!*\
  !*** ./src/containers/billing/components/BillingContainer.js ***!
  \***************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jss_BillingStyles__ = __webpack_require__(/*! ./../jss/BillingStyles */ 1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Table__ = __webpack_require__(/*! @material-ui/core/es/Table */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__ = __webpack_require__(/*! @material-ui/core/TableBody */ 221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableRow__ = __webpack_require__(/*! @material-ui/core/es/TableRow */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__ = __webpack_require__(/*! @material-ui/core/es/TableCell */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableHead__ = __webpack_require__(/*! @material-ui/core/TableHead */ 227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_visibility_1_png__ = __webpack_require__(/*! ../../../assets/img/visibility-1.png */ 2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_visibility_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_visibility_1_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var InvoicesTable = function (_Component) {
    _inherits(InvoicesTable, _Component);

    function InvoicesTable() {
        _classCallCheck(this, InvoicesTable);

        return _possibleConstructorReturn(this, (InvoicesTable.__proto__ || Object.getPrototypeOf(InvoicesTable)).apply(this, arguments));
    }

    _createClass(InvoicesTable, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                customer = _props.billing.customer,
                handlePaymentDetails = _props.handlePaymentDetails,
                classes = _props.classes;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: classes.billingContainer },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.billingContainerHeader },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        null,
                        "Billing Details"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { onClick: function onClick() {
                            return handlePaymentDetails('Add payment Details');
                        },
                        className: !customer.hasOwnProperty('last4Digits') ? classes.addBtn : classes.editBtn })
                ),
                !customer.hasOwnProperty('last4Digits') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.emptyBillingDetailsContainer },
                    "No payment details added"
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.tableContainer },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Table__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableHead___default.a,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableRow__["a" /* default */],
                                { className: classes.tableRow },
                                customer.last4Digits && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "Card number"
                                ),
                                customer.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "Name"
                                ),
                                customer.country && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "Country"
                                ),
                                customer.region && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "State"
                                ),
                                customer.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "Email"
                                ),
                                customer.city && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "City"
                                ),
                                customer.zip && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    "ZipCode"
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default.a,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_TableRow__["a" /* default */],
                                { className: classes.tableRow },
                                customer.last4Digits && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_9__assets_img_visibility_1_png___default.a, alt: "visibility", style: { height: '20px', width: '20px', marginRight: '10px' } }),
                                    "****-****-****-" + customer.last4Digits
                                ),
                                customer.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    customer.name
                                ),
                                customer.country && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    customer.country
                                ),
                                customer.region && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    customer.region
                                ),
                                customer.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    customer.email
                                ),
                                customer.city && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    customer.city
                                ),
                                customer.zip && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableCell__["a" /* default */],
                                    { className: classes.tableCell },
                                    customer.zip
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return InvoicesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var billing = _ref.billing;
    return { billing: billing };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {})(Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__jss_BillingStyles__["a" /* default */])(InvoicesTable)));

/***/ }),

/***/ 2404:
/*!*****************************************!*\
  !*** ./src/assets/img/visibility-1.png ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGPSURBVHgB5VSxUoNAEL2DxjL+AXZ2apMxleQL5A/U0pkk4Bdk+AJDQkFn8gWSTqtACY2ks8Q/oGcA38WDOS+EsbDLzizH7dvbfezuQcjRCT0EjEYjXVXV27IsNUqpVlVVxuyKoiRFUaxd1w3+FJAFQoApXnXSLSnUXiwWS9GoihvTNJ+xeFCttoFZgGUFDaEZkp1zqAc1BoNBL4qi9z2Gk8nkA4cvRQbYP8ifZlmWhk/eiEkhAZgOm4CMGWpliQfzPD/zPC/lJTA52xUS+Ny2Ef1R25njOE8UoAHwlfyWNTIabRiCDhnr8XjMAuoypmCdSsEYkOzoU3onY7BZ3CdswaYKHhn5J0GsnoJMdgtww1k4MgbbkvtcyBj6YKtxHKf9fv8UDtcCpsEWslph3WJ/Av2EPsL2xjqNwJ6UyAE2a8ampcgpOj1knRYP8g6/EGFssE/m8/nV7l1yntUjIoiP7FuhFHoLs2bk9q4emN6Tn85rpEP4DbLlwe/8OWBYDRS6Lj67ailsX7D5h34ORyjfel3D0KOvXdwAAAAASUVORK5CYII="

/***/ }),

/***/ 2405:
/*!*********************************!*\
  !*** ./src/components/Trial.js ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(/*! babel-runtime/regenerator */ 195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_trial_png__ = __webpack_require__(/*! ../assets/img/trial.png */ 2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_trial_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_trial_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__ = __webpack_require__(/*! @material-ui/core/Snackbar */ 1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Close__ = __webpack_require__(/*! @material-ui/icons/Close */ 2604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__ = __webpack_require__(/*! @material-ui/core/IconButton */ 229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { sendCustomAnalytics } from "../helper/analyticsHelper";





var Trial = function (_Component) {
  _inherits(Trial, _Component);

  function Trial(props) {
    var _this2 = this;

    _classCallCheck(this, Trial);

    var _this = _possibleConstructorReturn(this, (Trial.__proto__ || Object.getPrototypeOf(Trial)).call(this, props));

    _this.upgradeClicked = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(routeName) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleClose = function (event, reason) {
      // if (reason === "clickaway") {
      //   return;
      // }

      // this.setState({ open: false });
    };

    _this.state = {
      open: false,
      message: "",
      variant: ''
    };
    return _this;
  }

  _createClass(Trial, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var routeName = this.props.routeName;
      var _state = this.state,
          open = _state.open,
          message = _state.message,
          variant = _state.variant;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        {
          style: {
            textAlign: "center",
            padding: "20px",
            maxWidth: "600px",
            margin: "auto"
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_2__assets_img_trial_png___default.a, style: { maxWidth: "430px", width: '100%' } }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["m" /* Typography */],
          { variant: "h2", style: { color: '#6D6D6D' } },
          "Trial Mode"
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["m" /* Typography */],
          { style: { marginTop: "25px", fontSize: "19px", color: '#6D6D6D' } },
          "Please upgrade to benefit from additional features"
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["c" /* Button */],
          {
            onClick: function onClick() {
              return _this3.upgradeClicked(routeName);
            },
            variant: "contained",
            style: { marginTop: '30px', outline: 'none', background: '#00CD6B',
              boxShadow: '4px 4px 18px 1px rgba(0, 205, 107, 0.35)',
              borderRadius: '3px',
              width: '300px',
              color: '#FFFFFF', padding: '10px' }
          },
          "Upgrade"
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default.a, {
          className: variant,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
          },
          open: open,
          autoHideDuration: 6000,
          onClose: this.handleClose,
          message: message,
          action: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default.a,
              {
                size: "small",
                "aria-label": "close",
                color: "inherit",
                onClick: this.handleClose
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Close___default.a, { fontSize: "small" })
            )
          )
        })
      );
    }
  }]);

  return Trial;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Trial);

/***/ }),

/***/ 2406:
/*!**********************************!*\
  !*** ./src/assets/img/trial.png ***!
  \**********************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/trial.5286d436.png";

/***/ }),

/***/ 246:
/*!************************************************************************!*\
  !*** ./src/containers/billing/components/edit-info/EditInfoActions.js ***!
  \************************************************************************/
/*! exports provided: CLOSE_INFO_MODAL, closeInfoModal, OPEN_INFO_MODAL, openInfoModal */
/*! exports used: CLOSE_INFO_MODAL, OPEN_INFO_MODAL, closeInfoModal, openInfoModal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_INFO_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeInfoModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_INFO_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openInfoModal; });

var CLOSE_INFO_MODAL = 'CLOSE_INFO_MODAL';
var closeInfoModal = function closeInfoModal() {
    return { type: CLOSE_INFO_MODAL };
};

var OPEN_INFO_MODAL = 'OPEN_INFO_MODAL';
var openInfoModal = function openInfoModal(_ref) {
    var text = _ref.text,
        callback = _ref.callback,
        confirmCheckbox = _ref.confirmCheckbox,
        btn1 = _ref.btn1,
        btn2 = _ref.btn2,
        content = _ref.content;
    return {
        type: OPEN_INFO_MODAL,
        payload: { text: text, callback: callback, confirmCheckbox: confirmCheckbox, btn1: btn1, btn2: btn2, content: content }
    };
};

/***/ }),

/***/ 247:
/*!*********************************************************************!*\
  !*** ./src/components/information-modal/InformationModalActions.js ***!
  \*********************************************************************/
/*! exports provided: CLOSE_INFORMATION_MODAL, closeInformationModal, OPEN_INFORMATION_MODAL, openInformationModal */
/*! exports used: CLOSE_INFORMATION_MODAL, OPEN_INFORMATION_MODAL, closeInformationModal, openInformationModal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_INFORMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeInformationModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_INFORMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openInformationModal; });

var CLOSE_INFORMATION_MODAL = 'CLOSE_INFORMATION_MODAL';
var closeInformationModal = function closeInformationModal() {
    return { type: CLOSE_INFORMATION_MODAL };
};

var OPEN_INFORMATION_MODAL = 'OPEN_INFORMATION_MODAL';
var openInformationModal = function openInformationModal(text) {
    return {
        type: OPEN_INFORMATION_MODAL,
        payload: { text: text }
    };
};

/***/ }),

/***/ 248:
/*!**********************************************!*\
  !*** ./src/containers/login/LoginActions.js ***!
  \**********************************************/
/*! exports provided: GET_USER_LOGIN_STATUS_START, GET_USER_LOGIN_STATUS, getUserLoginStatus, SESSION_EXPIRED, sessionExpired */
/*! exports used: GET_USER_LOGIN_STATUS, GET_USER_LOGIN_STATUS_START, SESSION_EXPIRED, getUserLoginStatus, sessionExpired */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_USER_LOGIN_STATUS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_USER_LOGIN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserLoginStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SESSION_EXPIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sessionExpired; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var GET_USER_LOGIN_STATUS_START = "GET_USER_LOGIN_STATUS_START";
var GET_USER_LOGIN_STATUS = "GET_USER_LOGIN_STATUS";

var getUserLoginStatus = function getUserLoginStatus() {
    return function (dispatch) {
        dispatch({ type: GET_USER_LOGIN_STATUS_START });

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/auth-status');
        dispatch({
            type: GET_USER_LOGIN_STATUS,
            payload: payload
        });
    };
};

var SESSION_EXPIRED = "SESSION_EXPIRED";

var sessionExpired = function sessionExpired() {
    return { type: SESSION_EXPIRED };
};

/***/ }),

/***/ 2606:
/*!******************************************************!*\
  !*** ./src/containers/shared-emails/SharedEmails.js ***!
  \******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__delete_account_components_DaInfoTable__ = __webpack_require__(/*! ../delete-account/components/DaInfoTable */ 599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__delete_account_components_RtscInfo__ = __webpack_require__(/*! ../delete-account/components/RtscInfo */ 610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__ = __webpack_require__(/*! @material-ui/core/es/Button */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common__ = __webpack_require__(/*! @material-ui/core/colors/common */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red__ = __webpack_require__(/*! @material-ui/core/colors/red */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress */ 163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__ = __webpack_require__(/*! ../delete-account/DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_confirmation_modal_ConfirmationModalActions__ = __webpack_require__(/*! ../../components/confirmation-modal/ConfirmationModalActions */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_icons_fa__ = __webpack_require__(/*! react-icons/fa */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_information_modal_InformationModalActions__ = __webpack_require__(/*! ../../components/information-modal/InformationModalActions */ 247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__delete_account_components_UploadsInfoTable__ = __webpack_require__(/*! ../delete-account/components/UploadsInfoTable */ 597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_es_AppBar__ = __webpack_require__(/*! @material-ui/core/es/AppBar */ 612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_es_Tabs__ = __webpack_require__(/*! @material-ui/core/es/Tabs */ 626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_es_Tab__ = __webpack_require__(/*! @material-ui/core/es/Tab */ 625);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


























var white = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_colors_common___default.a.white;
var red500 = __WEBPACK_IMPORTED_MODULE_13__material_ui_core_colors_red___default.a["500"];

var styles = function styles(theme) {
  var _ref;

  return _ref = {
    heading: {
      fontSize: theme.typography.pxToRem(15)
    },
    deleteButton: {
      backgroundColor: red500,
      color: white
    },
    pageContainer: {
      padding: 24,
      marginBottom: 40
    },
    tableWrapper: {
      overflowX: "auto"
    },
    title: {
      color: "rgba(0, 0, 0, 0.54)",
      padding: "0.7em 0",
      fontSize: "1.5rem",
      fontWeight: 400,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.20588em"
    },
    accountEmail: {
      padding: ".3em 0 .7em 0",
      fontSize: "1rem",
      fontWeight: 400,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    loadingCircleContainer: {
      textAlign: "center",
      paddingTop: "35px"
    },
    contactsList: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      paddingRight: 1,
      maxHeight: 300,
      margin: "10px 0px 10px"
    },
    groupsList: {
      backgroundColor: theme.palette.background.paper,
      overflow: "auto",
      paddingRight: 1,
      maxHeight: 600,
      margin: "12px 0px"
    },
    ultraProfile: {
      padding: 15
    },
    gridList: {
      // width: 500,
      // height: 450,
      maxHeight: 400,
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)"
    },
    expPanel: {
      width: "100%",
      boxShadow: "unset"
    },
    cardContent: {
      verticalAlign: "middle",
      paddingTop: 24
    },
    cardTitle: {
      alignSelf: "center",
      fontSize: "16px"
    },
    media: {
      height: 160,
      backgroundPosition: "center"
    },
    rightArrowIcon: {
      fontSize: 30
    },
    serviceHeadLine: {
      fontSize: 24,
      paddingTop: 32,
      lineHeight: "42px"
    },
    serviceContent: _defineProperty({
      marginTop: 16
    }, theme.breakpoints.down("sm"), {
      marginTop: 0
    }),
    serviceContentText: {
      color: "rgba(0,0,0,0.65)",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      whiteSpace: "pre-wrap"
    },
    serviceDivider: {
      marginTop: 56
    },
    infoTable: {
      marginBottom: 42
    },
    textAlignCenter: {
      textAlign: "center"
    }
  }, _defineProperty(_ref, "loadingCircleContainer", {
    textAlign: "center"
  }), _defineProperty(_ref, "tableCell", {
    verticalAlign: "middle"
  }), _defineProperty(_ref, "noInfoInTab", {
    padding: 24
  }), _defineProperty(_ref, "button", {
    minWidth: 200
  }), _defineProperty(_ref, "link", {
    color: "#0867b7 !important"
  }), _ref;
};

var SharedEmails = function (_Component) {
  _inherits(SharedEmails, _Component);

  function SharedEmails() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, SharedEmails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SharedEmails.__proto__ || Object.getPrototypeOf(SharedEmails)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { activeTab: 0 }, _this.openConfirmationModal = function () {
      var _this$props = _this.props,
          user = _this$props.user,
          brand = _this$props.brand,
          destroyAccount = _this$props.destroyAccount,
          openInformationModal = _this$props.openInformationModal,
          getAccountPIIStatus = _this$props.getAccountPIIStatus;

      _this.props.openConfirmationModal("Are you sure you want to delete your " + user.email + " account?", function () {
        return destroyAccount(user.email, brand.id, function () {
          getAccountPIIStatus(user.email, brand.id);
          openInformationModal("You have successfully deleted your account");
        }, function () {
          return openInformationModal("There was an error deleting your account. Please try again.");
        });
      });
    }, _this.renderButton = function () {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          user = _this$props2.user,
          app = _this$props2.app,
          brand = _this$props2.brand,
          account = _this$props2.account,
          getDestroyStatus = _this$props2.getDestroyStatus,
          getAccountPII = _this$props2.getAccountPII;

      if (account.fetchingPiiStatus) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: classes.loadingCircleContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], { size: 50 })
        );
      } else if (account.piiStatus) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__["a" /* default */],
              {
                variant: "raised",
                color: "secondary",
                className: classes.button,
                onClick: _this.openConfirmationModal
              },
              "Delete Account"
            )
          ),
          (app.env === "development" || app.env === "staging") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__["a" /* default */],
              {
                variant: "raised",
                color: "primary",
                className: classes.button,
                onClick: function onClick() {
                  return getDestroyStatus(user.email);
                }
              },
              "Get Delete Status"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Button__["a" /* default */],
              {
                variant: "raised",
                color: "primary",
                className: classes.button,
                onClick: function onClick() {
                  return getAccountPII(user.email, brand.id);
                }
              },
              "Show Personal Data"
            )
          ),
          account.destroy.detailsList && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: 12 },
            account.destroy.detailsList.map(function (d, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Grow__["a" /* default */],
                { "in": true, key: d.id, timeout: index * 700 + 500 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  d.component + ": ",
                  _this.renderDestroyStatusIcon(d.status)
                )
              );
            })
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__["a" /* default */],
        { className: classes.pageContainer },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Typography__["a" /* default */],
          {
            component: "p",
            className: __WEBPACK_IMPORTED_MODULE_18_classnames__(classes.serviceContentText, classes.textAlignCenter)
          },
          "Account not registered"
        )
      );
    }, _this.toggleTabs = function (e, activeTab) {
      return _this.setState({ activeTab: activeTab });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SharedEmails, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          user = _props.user,
          brand = _props.brand,
          changePageHeader = _props.changePageHeader,
          getAccountPIIStatus = _props.getAccountPIIStatus;

      changePageHeader("Delete your account", true);
      getAccountPIIStatus(user.email, brand.id);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props2 = this.props,
          user = _props2.user,
          brand = _props2.brand,
          getAccountPII = _props2.getAccountPII;

      getAccountPII(user.email, brand.id);
    }
  }, {
    key: "renderDestroyStatusIcon",
    value: function renderDestroyStatusIcon(status) {
      switch (status) {
        case "REQUESTED":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], { size: 15 });
        case "FAILED":
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_icons_fa__["d" /* FaWindowClose */], { color: "red" });
        default:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_icons_fa__["a" /* FaCheck */], { color: "green" });
      }
    }
  }, {
    key: "getDateFormated",
    value: function getDateFormated(time) {
      var date = new Date(time);
      return date.toLocaleString();
    }

    // componentWillMount = () => {
    //     this.props.changePageHeader('Account Management', true);
    // };

  }, {
    key: "render",
    value: function render() {
      var activeTab = this.state.activeTab;
      var _props3 = this.props,
          classes = _props3.classes,
          brand = _props3.brand,
          account = _props3.account;
      var uploadsInfo = account.pii.uploadsInfo;

      console.log(this.props);
      var tabs = Object.values(account.brandsPii).map(function (_ref3, index) {
        var daInfo = _ref3.daInfo,
            uploadsInfo = _ref3.uploadsInfo,
            rtsc = _ref3.rtsc;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__delete_account_components_DaInfoTable__["a" /* default */], { classes: classes, content: daInfo }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__delete_account_components_UploadsInfoTable__["a" /* default */], { classes: classes, content: uploadsInfo }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__delete_account_components_RtscInfo__["a" /* default */], { classes: classes, content: rtsc })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "share-emails", style: { padding: "10px 20px", textAlign: "center" } },
        account.fetchingPii ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { paddingTop: "30px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_CircularProgress__["a" /* default */], null)
        ) : uploadsInfo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center", className: classes.serviceContent, spacing: 24 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: 12, sm: 10 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__delete_account_components_UploadsInfoTable__["a" /* default */], { classes: classes }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__delete_account_components_RtscInfo__["a" /* default */], { classes: classes })
          ),
          Object.keys(account.brandsPii).length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: 12, sm: 10 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_21__material_ui_core_es_AppBar__["a" /* default */],
              { position: "static" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22__material_ui_core_es_Tabs__["a" /* default */],
                { value: activeTab, onChange: this.toggleTabs },
                Object.keys(account.brandsPii).map(function (b) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_es_Tab__["a" /* default */], { key: b, label: b });
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__["a" /* default */],
              null,
              tabs[activeTab]
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Grid__["a" /* default */],
          { container: true, justify: "center", className: classes.serviceContent, spacing: 24 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_Paper__["a" /* default */],
            { style: { padding: '20px', fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' } },
            "Share your emails to see shared emails"
          )
        )
      )
      //             <div style={{padding: '10px'}}>
      //                 {/*<ServiceSection headLine="Delete your account or services"*/}
      //                 {/*text={`If you are no longer interested in using ${brand.name} services, you can delete them here.`}*/}
      //                 {/*image="http://da-v4-mbl.digitalbrandsinc.netdna-cdn.com/wp-content/uploads/2012/08/delete-612x320.jpg"*/}
      //                 {/*cardTitle="Delete Account" link="delete-account"/>*/}

      //                 {!account.fetchingPiiStatus && account.piiStatus ?
      //                     <div>
      //                         <Grid container justify='center'>
      //                             <Grid xs={12} sm={7} item>
      //                                 <Typography gutterBottom variant="headline" className={classes.serviceHeadLine}>
      //                                     {`How to Permanently Delete Your Account and All Information From ${brand.name} Cloud`}
      //                                 </Typography>
      //                             </Grid>
      //                         </Grid>
      //                         <Grid container justify='center' className={classes.serviceContent} spacing={24}>
      //                             <Grid xs={12} sm={7} item>
      //                                 <Typography component="p" className={classes.serviceContentText}>
      //                                     {`Permanently deleting your account, removes your account details from ${brand.name} cloud. After this is complete, you will no longer have access to your account on ${brand.name} and all traces of your account will be removed instantly as we do not store your emails on our servers.

      // If you would like to permanently delete your account, please do the following:
      // 1. Remove your account from the ${brand.name} app on `}
      //                                     <strong style={{fontWeight: 800}}>all</strong>
      //                                     {` of your devices.`}
      //                                     <li style={{paddingLeft: '1.5rem'}}>You can remove your account within the app by
      //                                         tapping More (o o o) | Various Account Settings | Tap the account you wish to
      //                                         delete | Edit Account | Remove Account | Confirm with OK
      //                                     </li>
      //                                     {`2. Click the “Delete Account” button below and wait for confirmation.

      // Please Note: You will need to do the steps above for every account you wish to delete on ${brand.name}. This is a permanent action and cannot be undone.`}
      //                                 </Typography>
      //                             </Grid>
      //                         </Grid>
      //                     </div> :
      //                     <div/>
      //                 }
      //                 <Grid container justify='center' className={classes.serviceContent}>
      //                     <Grid xs={12} sm={7} item>
      //                         {this.renderButton()}
      //                     </Grid>
      //                 </Grid>
      //                 <Grid container justify='center' className={classes.serviceContent} spacing={24}>
      //                     <Grid item xs={12} sm={10}>
      //                         <DaInfoTable classes={classes}/>
      //                         <UploadsInfoTable classes={classes}/>
      //                         <RtscInfo classes={classes}/>
      //                     </Grid>
      //                         {Object.keys(account.brandsPii).length > 0 &&
      //                     <Grid item xs={12} sm={10}>
      //                         <AppBar position="static">
      //                             <Tabs value={activeTab} onChange={this.toggleTabs}>
      //                                 {Object.keys(account.brandsPii).map(b => <Tab key={b} label={b}/>)}
      //                             </Tabs>
      //                         </AppBar>
      //                         <Paper>
      //                             {/* {tabs[activeTab]} */}
      //                         </Paper>
      //                     </Grid>}
      //                 </Grid>

      //             </div>
      ;
    }
  }]);

  return SharedEmails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref4) {
  var user = _ref4.user,
      brand = _ref4.brand,
      account = _ref4.account,
      app = _ref4.app;

  return { user: user, brand: brand, account: account, app: app };
}

function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
    changePageHeader: __WEBPACK_IMPORTED_MODULE_6__app_AppActions__["f" /* changePageHeader */],
    getDestroyStatus: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["j" /* getDestroyStatus */],
    getAccountPII: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["h" /* getAccountPII */],
    destroyAccount: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["g" /* destroyAccount */],
    openConfirmationModal: __WEBPACK_IMPORTED_MODULE_16__components_confirmation_modal_ConfirmationModalActions__["d" /* openConfirmationModal */],
    getAccountPIIStatus: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["i" /* getAccountPIIStatus */],
    openInformationModal: __WEBPACK_IMPORTED_MODULE_19__components_information_modal_InformationModalActions__["d" /* openInformationModal */],
    deleteShare: __WEBPACK_IMPORTED_MODULE_15__delete_account_DeleteAccountActions__["f" /* deleteShare */]
  }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(SharedEmails)));

/***/ }),

/***/ 2607:
/*!*********************************************!*\
  !*** ./src/containers/settings/Settings.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jss_SettingsStyles__ = __webpack_require__(/*! ./jss/SettingsStyles */ 2608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SettingsActions__ = __webpack_require__(/*! ./SettingsActions */ 701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_printer_1_png__ = __webpack_require__(/*! ../../assets/img/printer-1.png */ 2609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_printer_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_printer_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_share_2_png__ = __webpack_require__(/*! ../../assets/img/share-2.png */ 2610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_share_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_share_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_CircularProgress_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress/CircularProgress */ 193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom_es_Link__ = __webpack_require__(/*! react-router-dom/es/Link */ 627);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MAPPING_VALUES = {
    "disable-print": false,
    "enable-print": true,
    "disable-share": false,
    "enable-share": true
};

var Settings = function (_Component) {
    _inherits(Settings, _Component);

    function Settings(props) {
        _classCallCheck(this, Settings);

        var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

        _this.handleSelect = function (event) {
            if (event.target.value === 'disable-print' || event.target.value === 'enable-print') {
                _this.setState({ printValue: event.target.value });
            }
            if (event.target.value === 'disable-share' || event.target.value === 'enable-share') {
                _this.setState({ shareValue: event.target.value });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.updateSettings({ email: _this.props.user.email, values: { isShare: MAPPING_VALUES[_this.state.shareValue],
                    isPrint: MAPPING_VALUES[_this.state.printValue] } });
        };

        _this.state = {
            printValue: '',
            shareValue: ''
        };
        return _this;
    }

    _createClass(Settings, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var changePageHeader = this.props.changePageHeader;

            changePageHeader("Settings");
            this.props.getSettings();
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _nextProps$settings = nextProps.settings,
                isPrint = _nextProps$settings.isPrint,
                isShare = _nextProps$settings.isShare,
                needUpdate = _nextProps$settings.needUpdate,
                user = nextProps.user;

            if (needUpdate) {
                this.props.getSettings(user.email);
            }
            if (isPrint) {
                this.setState({ printValue: 'enable-print' });
            } else {
                this.setState({ printValue: 'disable-print' });
            }

            if (isShare) {
                this.setState({ shareValue: 'enable-share' });
            } else {
                this.setState({ shareValue: 'disable-share' });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                app = _props.app,
                _props$settings = _props.settings,
                fetching = _props$settings.fetching,
                isPrint = _props$settings.isPrint,
                isShare = _props$settings.isShare;

            return fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_CircularProgress_CircularProgress__["a" /* default */], { size: 45 })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { id: "settings" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.pageTitle },
                    "Settings"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: classes.deleteAccSetings },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_react_router_dom_es_Link__["a" /* default */],
                        { to: "/delete-account", style: { textDecoration: 'none' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "span",
                            { style: {
                                    width: '122px',
                                    color: 'red',
                                    border: '1px solid red',
                                    background: '#fff',
                                    boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35)',
                                    borderRadius: '3px', outline: 'none', padding: '7px 50px', marginTop: '10px' } },
                            "Delete Account"
                        )
                    )
                )
            );
        }
    }]);

    return Settings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var app = _ref.app,
        settings = _ref.settings,
        user = _ref.user;
    return { app: app, settings: settings, user: user };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({ changePageHeader: __WEBPACK_IMPORTED_MODULE_4__app_AppActions__["f" /* changePageHeader */], getSettings: __WEBPACK_IMPORTED_MODULE_7__SettingsActions__["e" /* getSettings */], updateSettings: __WEBPACK_IMPORTED_MODULE_7__SettingsActions__["f" /* updateSettings */] }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_styles_withStyles__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__jss_SettingsStyles__["a" /* default */])(Settings)));

/***/ }),

/***/ 2608:
/*!*******************************************************!*\
  !*** ./src/containers/settings/jss/SettingsStyles.js ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var settingsStyles = function settingsStyles(theme) {
    return {
        pageTitle: {
            background: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            borderRadius: '5px',
            padding: '10px',
            marginBottom: '20px'
        },
        submitBtn: {
            background: '#1B23ED !important',
            boxShadow: '4px 4px 18px 1px rgba(27, 97, 237, 0.35) !important',
            borderRadius: '3px !important',
            width: '122px !important',
            color: '#FFFFFF !important'
        },
        select: {
            border: '1px solid rgba(0, 0, 0, 0.13)',
            borderRadius: '5px',
            padding: '5px 24px 5px 5px',
            background: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMjYyMTcgOS42OTg4NEwwLjk5NTg4MyAxLjU0MjQyQzAuNTY2MjUyIDAuODc3MDEgMS4wNDM5MyAwIDEuODM1OTkgMEgxMi4zNjg2QzEzLjE2MDYgMCAxMy42MzgzIDAuODc3MDEgMTMuMjA4NyAxLjU0MjQyTDcuOTQyMzggOS42OTg4NEM3LjU0ODQ2IDEwLjMwODkgNi42NTYwOSAxMC4zMDg5IDYuMjYyMTcgOS42OTg4NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPg==") #F7F7F7 no-repeat calc(100% + 16px) !important',
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',
            backgroundRepeat: 'no-repeat !important',
            backgroundOrigin: 'content-box !important',
            backgroundSize: '1.4ex !important'
        },

        icon: {
            width: '16px',
            height: '16px'
        },
        settingsItem: {
            background: '#FFFFFF',
            border: '1px solid rgba(0, 0, 0, 0.13)',
            boxSizing: 'border-box',
            borderRadius: '5px', maxWidth: '280px', padding: '10px', display: 'flex', justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px'
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (settingsStyles);

/***/ }),

/***/ 2609:
/*!**************************************!*\
  !*** ./src/assets/img/printer-1.png ***!
  \**************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgBrZKBDYIwEEUPwgBuIGyAG7CBugFOIE6iToBOYJzAEXADGMEN8A5+k9IcpYn+5KVwvftHy0U0VcrUWDV1zAGrKimuaF6y9/LsU8Osya/WfkmwlsyWyZnbgsEKX3GX3AjFR+ZEnrM5SpkzaujCFFhbdAjRjqljq0AuKGM+gQZDXkw/6m8GcowH09N4Dz4kZzILJY3/P0dCyBykaFiaYAUTcS9mOpsmPZ6HiY0U90KJG3XIyUwgUZI2NA6Jpr0b0Awau8OSXIMr8yb/MD3tly+7oDStDl4GEwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 2610:
/*!************************************!*\
  !*** ./src/assets/img/share-2.png ***!
  \************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgBrZIBDcIwEEVvBAFImAQcAAqGA4YCJgEHzMFAARIABeBgQwE4KP/Gb9KUW7Im/ORB1/b+XdsTGa81uINZODmR8dLAHFwkMMn4v+Si6go6I3DH7ycowAq8p/g5gHkUdGSgBpW6ETzAjWtqeKaJOPmVbmhBLdGZoyTN0B3oOU+gYnZLmjjL/CBYKMECbOV7N0VQhT9CwypXloHPvuEmHXc0cxzrk/aX6EuJS3uBfTRfcj7shXbIIA4WsRvJWQa1jJdpkCKX0sqm/mKgT5FLunLG9t2mz+MS0ZjqAyOEQ7A+URMvAAAAAElFTkSuQmCC"

/***/ }),

/***/ 2611:
/*!*******************************************!*\
  !*** ./src/containers/profile/Profile.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__int_profile_v1_lib_containers_App__ = __webpack_require__(/*! @int/profile_v1/lib/containers/App */ 2612);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var data = {
    firstName: 'IAN',
    lastName: 'GELLER',
    avatar: '',
    headline: 'Designer, cat lover, bookworm, Apple pie fanatic and nature enthusiast',
    professionalSummary: 'Born and bred in Italy 30 years ago. Graduated at Polytechnic University of Bari in Architecture, I’ve always been passionate about social media and technology. I started working before ending my studies for a multi-platform company, proving my skills in Marketing and Social Media, Facebook campaigns, digital pr, community management, improving new social channels, strengthening the brand awareness, monitoring and analysing insights.\n\n When I was 28 I decided to push my boundaries and move to another country to experience new thing from a work and a personal point of view. I moved to London for a good job opportunity provided by 1000heads. I spent one year and a half working for clients such as GoPro, Salomon and Baileys.\n\n Now I’m based in Amsterdam and currently working for 1000heads as remote from a WeWork office located in the centre of the city.\n\n Favorite quotes:\n\n ‘Learn everything you can, anytime you can, from anyone you can, there will always come a time when you will be grateful you did.’ - Sarah Caldwell',
    address: '489  Caldwell Road, New York',
    webLink: 'gelletronics.com',
    fb: 'gelletronics.com',
    twitter: 'gelletronics.com',
    linkedin: 'gelletronics.com',
    instagram: 'gelletronics.com'
};

var ProfilePage = function (_Component) {
    _inherits(ProfilePage, _Component);

    function ProfilePage(props) {
        _classCallCheck(this, ProfilePage);

        return _possibleConstructorReturn(this, (ProfilePage.__proto__ || Object.getPrototypeOf(ProfilePage)).call(this, props));
    }

    _createClass(ProfilePage, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { id: "profile" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__int_profile_v1_lib_containers_App__["a" /* default */], { data: data })
            );
        }
    }]);

    return ProfilePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var app = _ref.app,
        settings = _ref.settings,
        user = _ref.user;
    return { app: app, settings: settings, user: user };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ProfilePage));

/***/ }),

/***/ 2615:
/*!*****************************************************!*\
  !*** ./src/containers/subscription/Subscription.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(/*! babel-runtime/regenerator */ 195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__delete_account_DeleteAccountActions__ = __webpack_require__(/*! ../delete-account/DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_CircularProgress_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress/CircularProgress */ 193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(/*! axios */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var styles = function styles(theme) {
    return {
        a: {
            color: "#1F6BF1 !important"
        }
    };
};

var Subscription = function (_Component) {
    _inherits(Subscription, _Component);

    function Subscription(props) {
        _classCallCheck(this, Subscription);

        var _this = _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).call(this, props));

        _this.state = { hasSubscription: false, fetchFinish: false };
        return _this;
    }

    _createClass(Subscription, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var user = this.props.user;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var user = this.props.user;


            var checkSubscrption = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://api.stripe.com/v1/customers', { headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer sk_test_51Mb1HVLeRHgXm1nry4x4vtd6kJ1mqCqBHPZcX9mohuecvE8N7mJQNbrWETsMf9evIFp3cMKv9jRL3TdBW052MeFs00k0JqwjJn'
                } }).then(function (response) {
                return response;
            }).catch(function (err) {
                return console.log(err);
            });

            var getData = function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var allData;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return checkSubscrption;

                                case 2:
                                    allData = _context.sent;

                                    if (allData.data.data.find(function (o) {
                                        return o.email === user.email;
                                    })) {
                                        console.log('res contain');
                                        _this2.setState({ hasSubscription: true });
                                        _this2.setState({ fetchFinish: true });
                                    } else {
                                        console.log('no res');
                                        _this2.setState({ hasSubscription: false });
                                        _this2.setState({ fetchFinish: true });
                                    }

                                case 4:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }));

                return function getData() {
                    return _ref.apply(this, arguments);
                };
            }();

            getData();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // fix Warning: Can't perform a React state update on an unmounted component
            this.setState = function (state, callback) {
                return;
            };
        }
    }, {
        key: 'render',
        value: function render() {

            var userEmail = this.props.user.email;
            console.log(this.state.hasSubscription);

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { id: 'subscription' },
                !this.state.fetchFinish && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'p',
                        null,
                        'Loading...'
                    )
                ),
                this.state.fetchFinish && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    this.state.hasSubscription && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        null,
                        'You are subscribed with a ',
                        userEmail,
                        ' account ',
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            { href: 'https://checkout.bluemail.me/p/login/3cs3dt1Ux4gP3PqcMM', target: '_blank' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'span',
                                { style: { color: '#1F6BF1' } },
                                'Manage Subscription'
                            )
                        )
                    ),
                    !this.state.hasSubscription && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        null,
                        'Not subscribed ',
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            { href: 'https://checkout.bluemail.me/p/login/3cs3dt1Ux4gP3PqcMM', target: '_blank' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'span',
                                { style: { color: '#1F6BF1' } },
                                'Manage Subscription'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    'If you subscribed through the ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { style: { fontWeight: '700' } },
                        'App Store'
                    ),
                    ': ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                    'Please see ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'a',
                        { href: 'https://support.apple.com/en-us/HT202039', target: '_blank' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { style: { color: '#1F6BF1' } },
                            'How to cancel a subscription from Apple'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    'If you subscribed through ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { style: { fontWeight: '700' } },
                        'Google Play'
                    ),
                    ': ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                    'Please see ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'a',
                        { href: 'https://support.google.com/googleplay/answer/7018481', target: '_blank' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { style: { color: '#1F6BF1' } },
                            'How to cancel a subscription from Google Play'
                        )
                    )
                )
            );
        }
    }]);

    return Subscription;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(_ref2) {
    var user = _ref2.user;

    return { user: user };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        getAccountPII: __WEBPACK_IMPORTED_MODULE_5__delete_account_DeleteAccountActions__["h" /* getAccountPII */]
    }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_styles_withStyles__["a" /* default */])(styles)(Subscription)));

/***/ }),

/***/ 2616:
/*!******************************************!*\
  !*** ./src/containers/avatar/Avatars.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(/*! react-dom */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_avatar_editor__ = __webpack_require__(/*! react-avatar-editor */ 1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_avatar_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_avatar_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Avatar__ = __webpack_require__(/*! material-ui/Avatar */ 2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(/*! material-ui/RaisedButton */ 2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider__ = __webpack_require__(/*! material-ui/styles/MuiThemeProvider */ 2670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Slider__ = __webpack_require__(/*! material-ui/Slider */ 2707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(/*! reactstrap */ 2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_avatarDefault_png__ = __webpack_require__(/*! ../../images/avatarDefault.png */ 2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_avatarDefault_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_avatarDefault_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Avatars = function (_Component) {
  _inherits(Avatars, _Component);

  function Avatars(props) {
    _classCallCheck(this, Avatars);

    var _this = _possibleConstructorReturn(this, (Avatars.__proto__ || Object.getPrototypeOf(Avatars)).call(this, props));

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleRemove = _this.handleRemove.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleFileChange = _this.handleFileChange.bind(_this);
    _this.setEditorRef = _this.setEditorRef.bind(_this);
    _this.handleZoomSlider = _this.handleZoomSlider.bind(_this);
    _this.state = {
      cropperOpen: false,
      img: null,
      zoom: 2,
      croppedImg: __WEBPACK_IMPORTED_MODULE_8__images_avatarDefault_png___default.a
    };
    return _this;
  }

  _createClass(Avatars, [{
    key: "handleZoomSlider",
    value: function handleZoomSlider(event, value) {
      var state = this.state;
      state.zoom = value;
      this.setState(state);
    }
  }, {
    key: "handleFileChange",
    value: function handleFileChange(e) {
      var url = window.URL.createObjectURL(e.target.files[0]);
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.in).value = "";
      var state = this.state;
      state.img = url;
      state.cropperOpen = true;
      this.setState(state);
    }
  }, {
    key: "handleSave",
    value: function handleSave(e) {
      if (this.editor) {
        var canvasScaled = this.editor.getImageScaledToCanvas();
        var croppedImg = canvasScaled.toDataURL();

        var state = this.state;
        state.img = null;
        state.cropperOpen = false;
        state.croppedImg = croppedImg;
        this.setState(state);
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(e) {
      var state = this.state;
      var croppedImg = __WEBPACK_IMPORTED_MODULE_8__images_avatarDefault_png___default.a;
      state.cropperOpen = false;
      state.croppedImg = croppedImg;
      this.setState(state);
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var state = this.state;
      state.cropperOpen = false;
      this.setState(state);
    }
  }, {
    key: "setEditorRef",
    value: function setEditorRef(editor) {
      this.editor = editor;
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider___default.a,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "avatar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_reactstrap__["b" /* Container */],
            { fluid: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_reactstrap__["b" /* Container */],
              null,
              !this.state.cropperOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                      { xl: 12, md: 12, xs: 12, className: "mt-3 mb-3 mr-auto ml-auto", style: { textAlign: 'center' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Avatar___default.a, { src: this.state.croppedImg, size: 160 })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                      { xl: 12, md: 12, xs: 12, className: "mt-2 mb-2 mr-auto ml-auto" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h3",
                        null,
                        "\u0421hange your avatar"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "p",
                        null,
                        "Upload your avatar"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                      { className: "change-remove" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                          { xl: 6, md: 6, xs: 6, className: "mt-2 mb-2 mr-auto ml-auto" },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,
                            { id: "change", containerElement: "label", style: { borderRadius: "10px", boxShadow: '0' } },
                            "Change",
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { ref: "in", type: "file", accept: "image/*", style: { display: 'none', background: 'transparent' }, onChange: this.handleFileChange })
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                          { xl: 6, md: 6, xs: 6, className: "mt-2 mb-2 mr-auto ml-auto" },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,
                            {
                              id: "remove",
                              label: "",
                              containerElement: "label",
                              onClick: this.handleRemove, style: { borderRadius: "10px", boxShadow: '0' } },
                            "Remove"
                          )
                        )
                      )
                    )
                  )
                )
              ),
              this.state.cropperOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                { className: "cropper-wrapper" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                    { xl: 12, md: 12, xs: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "h3",
                      null,
                      "Edit"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                    { xl: 12, md: 12, xs: 12, className: "mb-2" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "p",
                      null,
                      "Crop your photo"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                    { xl: 12, md: 12, xs: 12, className: "image-edit" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_avatar_editor___default.a, { ref: this.setEditorRef, image: this.state.img, scale: this.state.zoom,
                      width: 250,
                      height: 250,
                      border: 15,
                      borderRadius: 150,
                      color: [56, 56, 56, 0.5] // RGBA
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                  { className: "av-center" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Slider___default.a, {
                    id: "slider",
                    min: 1,
                    max: 10,
                    step: 0.1,
                    value: this.state.zoom,
                    onChange: this.handleZoomSlider,
                    style: { width: 160 }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                    { className: "save-cancel" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                        { xl: 6, md: 6, xs: 6, className: "mr-auto ml-auto" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,
                          {
                            id: "save",
                            label: "",
                            labelPosition: "before",
                            containerElement: "label",
                            onClick: this.handleSave, style: { borderRadius: "10px", boxShadow: '0' } },
                          "\xA0 Save \xA0"
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                        { xl: 6, md: 6, xs: 6, className: "mr-auto ml-auto" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,
                          {
                            id: "cancel",
                            label: "",
                            labelPosition: "before",
                            containerElement: "label",
                            onClick: this.handleCancel, style: { borderRadius: "10px", boxShadow: '0' } },
                          "Cancel"
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_reactstrap__["c" /* Row */],
                { className: "image-details" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_reactstrap__["a" /* Col */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "ul",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "li",
                      null,
                      "Dimensions: 1:1 ratio"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "li",
                      null,
                      "Formats: PNG, JPEG3"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "li",
                      null,
                      "Min size 110:110"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "li",
                      null,
                      "Max 512:512px"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "li",
                      null,
                      "Maximum file size: 1024KB"
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Avatars;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Avatars);

/***/ }),

/***/ 2792:
/*!**************************************!*\
  !*** ./src/images/avatarDefault.png ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatarDefault.773f9824.png";

/***/ }),

/***/ 2793:
/*!*******************************************************!*\
  !*** ./src/components/notifications/Notifications.js ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Snackbar__ = __webpack_require__(/*! @material-ui/core/es/Snackbar */ 1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_es_bindActionCreators__ = __webpack_require__(/*! redux/es/bindActionCreators */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationsActions__ = __webpack_require__(/*! ./NotificationsActions */ 700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_md__ = __webpack_require__(/*! react-icons/md */ 267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_IconButton__ = __webpack_require__(/*! @material-ui/core/es/IconButton */ 166);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Notifications = function (_Component) {
    _inherits(Notifications, _Component);

    function Notifications() {
        _classCallCheck(this, Notifications);

        return _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).apply(this, arguments));
    }

    _createClass(Notifications, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                notifications = _props.notifications,
                closeNotification = _props.closeNotification;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Snackbar__["a" /* default */], {
                open: !!notifications.text,
                onClose: closeNotification,
                autoHideDuration: 10000,
                SnackbarContentProps: {
                    'aria-describedby': 'message-id'
                },
                message: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { id: "message-id" },
                    notifications.text
                ),
                action: [
                // <Button key="undo" color="secondary" size="small" onClick={this.handleClose}>
                //     UNDO
                //    </Button>,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_IconButton__["a" /* default */],
                    {
                        key: "close",
                        "aria-label": "Close",
                        color: "inherit",
                        onClick: closeNotification
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_icons_md__["c" /* MdClose */], null)
                )]
            });
        }
    }]);

    return Notifications;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref) {
    var notifications = _ref.notifications;

    return { notifications: notifications };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_es_bindActionCreators__["a" /* default */])({
        closeNotification: __WEBPACK_IMPORTED_MODULE_4__NotificationsActions__["b" /* closeNotification */]
    }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Notifications));

/***/ }),

/***/ 2794:
/*!***************************************!*\
  !*** ./src/components/brand/Brand.js ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrandActions__ = __webpack_require__(/*! ./BrandActions */ 699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(/*! ../../utils */ 628);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Brand = function (_Component) {
    _inherits(Brand, _Component);

    function Brand() {
        _classCallCheck(this, Brand);

        return _possibleConstructorReturn(this, (Brand.__proto__ || Object.getPrototypeOf(Brand)).apply(this, arguments));
    }

    _createClass(Brand, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.getBrand();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
            document.title = nextProps.brand.name + ' - My Account';
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/png';
            link.rel = 'icon';
            link.href = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getAppProps */](nextProps.brand).favIcon;
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
        }
    }]);

    return Brand;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var brand = _ref.brand;
    return { brand: brand };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, { getBrand: __WEBPACK_IMPORTED_MODULE_2__BrandActions__["b" /* getBrand */] })(Brand));

/***/ }),

/***/ 2795:
/*!****************************************************************!*\
  !*** ./src/components/confirmation-modal/ConfirmationModal.js ***!
  \****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Button_Button__ = __webpack_require__(/*! @material-ui/core/es/Button/Button */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_DialogActions__ = __webpack_require__(/*! @material-ui/core/es/DialogActions */ 335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Dialog__ = __webpack_require__(/*! @material-ui/core/es/Dialog */ 334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_DialogContent__ = __webpack_require__(/*! @material-ui/core/es/DialogContent */ 336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_DialogContentText__ = __webpack_require__(/*! @material-ui/core/es/DialogContentText */ 615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConfirmationModalActions__ = __webpack_require__(/*! ./ConfirmationModalActions */ 124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Checkbox__ = __webpack_require__(/*! @material-ui/core/es/Checkbox */ 1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_FormControlLabel__ = __webpack_require__(/*! @material-ui/core/es/FormControlLabel */ 1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_FormHelperText__ = __webpack_require__(/*! @material-ui/core/es/FormHelperText */ 619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_FormControl__ = __webpack_require__(/*! @material-ui/core/es/FormControl */ 618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_FormLabel__ = __webpack_require__(/*! @material-ui/core/es/FormLabel */ 620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_es_DialogTitle__ = __webpack_require__(/*! @material-ui/core/es/DialogTitle */ 1177);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ConfirmationModal = function (_Component) {
    _inherits(ConfirmationModal, _Component);

    function ConfirmationModal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ConfirmationModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConfirmationModal.__proto__ || Object.getPrototypeOf(ConfirmationModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            checked: false
        }, _this.confirm = function () {
            var _this$props = _this.props,
                _this$props$confirmat = _this$props.confirmationModal,
                callback = _this$props$confirmat.callback,
                confirmCheckbox = _this$props$confirmat.confirmCheckbox,
                closeConfirmationModal = _this$props.closeConfirmationModal;
            var checked = _this.state.checked;

            if (confirmCheckbox && !checked) {
                return _this.setState({ error: 'Please check `Yes` to confirm' });
            }
            callback();
            closeConfirmationModal();
        }, _this.handleChange = function () {
            var checked = _this.state.checked;

            _this.setState({
                checked: !checked,
                error: checked ? 'Please check `Yes` to confirm' : ''
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConfirmationModal, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                brand = _props.brand,
                closeConfirmationModal = _props.closeConfirmationModal,
                _props$confirmationMo = _props.confirmationModal,
                text = _props$confirmationMo.text,
                btn1 = _props$confirmationMo.btn1,
                btn2 = _props$confirmationMo.btn2,
                _props$confirmationMo2 = _props$confirmationMo.confirmCheckbox,
                confirmCheckbox = _props$confirmationMo2 === undefined ? true : _props$confirmationMo2,
                open = _props$confirmationMo.open;
            var _state = this.state,
                checked = _state.checked,
                error = _state.error;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Dialog__["a" /* default */],
                {
                    open: open,
                    onClose: closeConfirmationModal,
                    "aria-labelledby": "form-dialog-title"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13__material_ui_core_es_DialogTitle__["a" /* default */],
                    null,
                    text
                ),
                confirmCheckbox ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_DialogContent__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_DialogContentText__["a" /* default */],
                        null,
                        "Please confirm the following:"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_FormControl__["a" /* default */],
                        { error: !!error },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_FormControlLabel__["a" /* default */], {
                            control: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_Checkbox__["a" /* default */], {
                                checked: checked,
                                onChange: this.handleChange,
                                value: "checked"
                            }),
                            label: "Yes, I want to permanently delete my account and all my information from " + brand.name
                        }),
                        error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_FormHelperText__["a" /* default */],
                            null,
                            error
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_DialogActions__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Button_Button__["a" /* default */],
                        { onClick: closeConfirmationModal, color: "primary" },
                        btn1 || 'Cancel'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Button_Button__["a" /* default */],
                        { onClick: this.confirm.bind(this), color: "primary" },
                        btn2 || 'Delete My Account'
                    )
                )
            );
        }
    }]);

    return ConfirmationModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref2) {
    var confirmationModal = _ref2.confirmationModal,
        brand = _ref2.brand;
    return { confirmationModal: confirmationModal, brand: brand };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps, { closeConfirmationModal: __WEBPACK_IMPORTED_MODULE_7__ConfirmationModalActions__["c" /* closeConfirmationModal */] })(ConfirmationModal));

/***/ }),

/***/ 2796:
/*!**************************************************************!*\
  !*** ./src/components/information-modal/InformationModal.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Button__ = __webpack_require__(/*! @material-ui/core/es/Button */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_DialogActions__ = __webpack_require__(/*! @material-ui/core/es/DialogActions */ 335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Dialog__ = __webpack_require__(/*! @material-ui/core/es/Dialog */ 334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_DialogContent__ = __webpack_require__(/*! @material-ui/core/es/DialogContent */ 336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_DialogContentText__ = __webpack_require__(/*! @material-ui/core/es/DialogContentText */ 615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InformationModalActions__ = __webpack_require__(/*! ./InformationModalActions */ 247);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var InformationModal = function (_Component) {
    _inherits(InformationModal, _Component);

    function InformationModal() {
        _classCallCheck(this, InformationModal);

        return _possibleConstructorReturn(this, (InformationModal.__proto__ || Object.getPrototypeOf(InformationModal)).apply(this, arguments));
    }

    _createClass(InformationModal, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                closeInformationModal = _props.closeInformationModal,
                _props$informationMod = _props.informationModal,
                text = _props$informationMod.text,
                open = _props$informationMod.open;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Dialog__["a" /* default */],
                { open: open, onClose: closeInformationModal, "aria-labelledby": "form-dialog-title" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_DialogContent__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_DialogContentText__["a" /* default */],
                        null,
                        text
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_DialogActions__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Button__["a" /* default */],
                        { onClick: closeInformationModal, color: "primary" },
                        "OK"
                    )
                )
            );
        }
    }]);

    return InformationModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
    var informationModal = _ref.informationModal;
    return { informationModal: informationModal };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps, { closeInformationModal: __WEBPACK_IMPORTED_MODULE_7__InformationModalActions__["c" /* closeInformationModal */] })(InformationModal));

/***/ }),

/***/ 2797:
/*!*******************************************!*\
  !*** ./src/components/LoadingBackDrop.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_CircularProgress__ = __webpack_require__(/*! @material-ui/core/es/CircularProgress */ 163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Backdrop__ = __webpack_require__(/*! @material-ui/core/es/Backdrop */ 607);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var LoadingBackDrop = function (_Component) {
    _inherits(LoadingBackDrop, _Component);

    function LoadingBackDrop() {
        _classCallCheck(this, LoadingBackDrop);

        return _possibleConstructorReturn(this, (LoadingBackDrop.__proto__ || Object.getPrototypeOf(LoadingBackDrop)).apply(this, arguments));
    }

    _createClass(LoadingBackDrop, [{
        key: "render",
        value: function render() {
            var app = this.props.app;

            if (app.loadingBackDrop) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Backdrop__["a" /* default */], { open: true, style: styles.backDrop }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_CircularProgress__["a" /* default */], { size: 100, style: styles.loadingCricle })
                );
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
        }
    }]);

    return LoadingBackDrop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = {
    loadingCricle: {
        zIndex: '9999999999',
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: '-50px 0 0 -50px',
        color: 'white'
    },
    backDrop: {
        zIndex: 99999
    }
};

var mapStateToProps = function mapStateToProps(_ref) {
    var app = _ref.app;
    return { app: app };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {})(LoadingBackDrop));

/***/ }),

/***/ 2798:
/*!************************************************************************!*\
  !*** ./src/containers/app/components/DashboardLayout/NavBar/NavBar.js ***!
  \************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(/*! react-router */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_perfect_scrollbar__ = __webpack_require__(/*! react-perfect-scrollbar */ 2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__package_json__ = __webpack_require__(/*! ../../../../../../package.json */ 2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavItem__ = __webpack_require__(/*! ./NavItem */ 2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_feather__ = __webpack_require__(/*! react-feather */ 659);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */











var navConfig = [{
  items: [{
    title: 'Signature Editor',
    icon: __WEBPACK_IMPORTED_MODULE_9_react_feather__["a" /* Activity */],
    href: '/signature'
  },
  // {
  //   title: 'Avatar',
  //   icon: Icon.Image,
  //   href: '/avatar'
  // },
  // {
  //   title: 'Profile',
  //   icon: Icon.UserCheck,
  //   href: '/profile'
  // },
  // {
  //   title: 'Welcome',
  //   icon: Icon.Home,
  //   href: '/'
  // },
  {
    title: 'Devices',
    icon: __WEBPACK_IMPORTED_MODULE_9_react_feather__["e" /* Monitor */],
    href: '/devices'
  },
  // {
  //   title: 'Show Account',
  //   icon: Icon.User,
  //   href: '/account'
  // },
  {
    title: 'Shared Emails',
    icon: __WEBPACK_IMPORTED_MODULE_9_react_feather__["c" /* Mail */],
    href: '/shared-emails'
  },
  // {
  //   title: 'Delete Account',
  //   icon: Icon.Activity,
  //   href: '/delete-account'
  // },
  {
    title: 'Subscription',
    icon: __WEBPACK_IMPORTED_MODULE_9_react_feather__["b" /* CreditCard */],
    href: '/subscription'
  },
  // {
  //   title: 'Billing',
  //   icon: Icon.DollarSign,
  //   href: '/billing'
  // },
  {
    title: 'Settings',
    icon: __WEBPACK_IMPORTED_MODULE_9_react_feather__["f" /* Settings */],
    href: '/settings'
  }]
}];

function renderNavItems(_ref) {
  var items = _ref.items,
      onMobileClose = _ref.onMobileClose,
      rest = _objectWithoutProperties(_ref, ['items', 'onMobileClose']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__material_ui_core__["h" /* List */],
    { disablePadding: true },
    items.reduce(function (acc, item) {
      return reduceChildRoutes(Object.assign({ acc: acc, item: item, onMobileClose: onMobileClose }, rest));
    }, [])
  );
}

function reduceChildRoutes(_ref2) {
  var acc = _ref2.acc,
      pathname = _ref2.pathname,
      item = _ref2.item,
      _ref2$depth = _ref2.depth,
      depth = _ref2$depth === undefined ? 0 : _ref2$depth,
      onMobileClose = _ref2.onMobileClose;

  var key = item.title + depth;

  if (item.items) {
    var open = Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["j" /* matchPath */])(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__NavItem__["a" /* default */],
      {
        depth: depth,
        icon: item.icon,
        key: key,
        info: item.info,
        open: Boolean(open),
        onMobileClose: onMobileClose,
        title: item.title
      },
      renderNavItems({
        depth: depth + 1,
        pathname: pathname,
        items: item.items
      })
    ));
  } else {
    acc.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NavItem__["a" /* default */], {
      depth: depth,
      href: item.href,
      icon: item.icon,
      key: key,
      onMobileClose: onMobileClose,
      info: item.info,
      title: item.title
    }));
  }

  return acc;
}

// const removeUnsupportedTabs = (items, env) => {
//   return items.map(tab => env === 'production' && tab.href === '/profile' ? null : tab).filter(Boolean);
// }

var removeUnsupportedTabs = function removeUnsupportedTabs(items, env, brandName) {
  return items.map(function (tab) {
    console.log(tab.href, tab.title, env, brandName); // Add this line for debugging
    if (env === 'production' && (tab.href === '/signature' && brandName === 'TypeApp' || // Check if it's the 'Signature Editor' tab for TypeApp
    tab.href === '/subscription' && brandName === 'TypeApp' || // Check if it's the 'Subscription' tab for TypeApp
    tab.href === '/shared_emails' && brandName === 'TypeApp' || // Check if it's the 'Shared Emails' tab for TypeApp
    tab.href === '/profile' // Always hide the 'Profile' tab
    )) {
      return null;
    }
    if (brandName === 'anymailapp' && (tab.href === '/signature' || // Check if it's the 'Signature Editor' tab
    tab.href === '/subscription' || // Check if it's the 'Subscription' tab
    tab.href === '/shared-emails' // Check if it's the 'Shared Emails' tab
    )) {
      return null;
    }
    return tab;
  }).filter(Boolean);
};

var NavBar = function (_Component) {
  _inherits(NavBar, _Component);

  function NavBar(props) {
    _classCallCheck(this, NavBar);

    return _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call(this, props));
  }

  _createClass(NavBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMobileNavOpen = _props.isMobileNavOpen,
          onMobileClose = _props.onMobileClose,
          brand = _props.brand,
          user = _props.user,
          setMobileNavClose = _props.setMobileNavClose,
          app = _props.app;


      console.log(brand, "Brand");
      // Remove signature tab if env eq production
      navConfig[0].items = removeUnsupportedTabs(navConfig[0].items, app.env, brand.name);
      var content = function content(onMobileClose) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: "100%", display: "flex", flexDirection: "column", width: '256px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_perfect_scrollbar___default.a,
            { options: { suppressScrollX: true } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              navConfig.map(function (config, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7__material_ui_core__["h" /* List */],
                  { key: i },
                  renderNavItems({ items: config.items, pathname: location.pathname, onMobileClose: onMobileClose })
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'version', style: { position: 'absolute', bottom: '10px', width: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: '13px', textAlign: 'center' } },
              __WEBPACK_IMPORTED_MODULE_6__package_json__["version"]
            )
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__material_ui_core__["f" /* Hidden */],
          { lgUp: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Drawer */],
            { style: { width: '256px', height: 'calc(100% - 64px)', top: '64px', zIndex: '1200' },
              anchor: 'left',
              onClose: onMobileClose,
              open: isMobileNavOpen,
              className: 'drawer',
              variant: 'temporary' },
            content(setMobileNavClose)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__material_ui_core__["f" /* Hidden */],
          { mdDown: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Drawer */],
            {
              anchor: 'left',
              className: 'drawer-reg',
              style: { width: '256px', height: 'calc(100% - 64px)', top: '64px', zIndex: '1200' },
              open: true,
              variant: 'persistent' },
            content(setMobileNavClose)
          )
        )
      );
    }
  }]);

  return NavBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref3) {
  var app = _ref3.app,
      brand = _ref3.brand;
  return { app: app, brand: brand };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, {})(NavBar));

/***/ }),

/***/ 2802:
/*!**********************!*\
  !*** ./package.json ***!
  \**********************/
/*! dynamic exports provided */
/*! exports used: version */
/***/ (function(module, exports) {

module.exports = {"name":"@int/self-portal-client","version":"3.0.12","description":"self-portal-client","license":"UNLICENSED","main":"lib/entry.js","publishConfig":{"registry":"http://npmreg"},"repository":"","author":{"name":"Asaf Yehezkel","email":"","url":""},"scripts":{"build":"poi build entry.js","build:lib":"NODE_ENV=production babel src --out-dir lib --ignore __tests__","start":"poi entry.js","prepublish":"npm run build","test":"jest","test:cover":"babel-node node_modules/isparta/bin/isparta cover --root src --report html node_modules/mocha/bin/_mocha -- --require ./tools/testSetup.js \"src/**/*.spec.js\" --reporter progress","test:cover:travis":"babel-node node_modules/isparta/bin/isparta cover --root src --report lcovonly _mocha -- --require ./tools/testSetup.js \"src/**/*.spec.js\" && cat ./coverage/lcov.info | node_modules/coveralls/bin/coveralls.js","test:watch":"npm run test -- --watch"},"files":["lib","dist","css"],"devDependencies":{"@babel/runtime":"^7.7.7","babel":"^6.23.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-jest":"^22.4.3","babel-plugin-react-require":"^3.0.0","babel-preset-env":"^1.6.1","babel-preset-react":"^6.24.1","babel-preset-react-app":"^3.1.0","babel-register":"^6.26.0","chai":"^4.1.2","compression-webpack-plugin":"^1.1.12","enzyme":"^3.3.0","enzyme-adapter-react-16":"^1.1.1","jest":"^22.4.3","mocha":"^5.0.5","node-sass":"^4.13.1","npm-run-all":"^4.1.2","poi":"^9.6.0","poi-preset-react":"^9.2.1","react-test-renderer":"^16.2.0","sass-loader":"^6.0.6","webpack-bundle-analyzer":"^2.9.1"},"dependencies":{"@babel/core":"^7.7.7","@babel/plugin-transform-runtime":"^7.7.6","@int/profile_v1":"0.0.0-4","@int/rich-text-signature-redux":"^1.0.4","@int/signature":"4.0.1","@material-ui/core":"^3.9.3","@material-ui/icons":"^1.1.0","@mui/icons-material":"^5.11.16","@mui/lab":"^5.0.0-alpha.134","@mui/material":"^5.13.5","@mui/styles":"^5.13.2","@mui/system":"^5.13.5","axios":"^0.18.0","bootstrap":"^4.4.1","build-url":"^1.1.2","classnames":"^2.2.5","clipboard":"^2.0.6","clsx":"^1.1.0","copy-to-clipboard":"^3.3.1","country-region-data":"^1.4.3","flexboxgrid":"^6.3.1","font-awesome":"^4.7.0","js-cookie":"^2.2.0","jss":"^9.8.0","material-ui":"0.20.0","moment":"^2.24.0","optional-js":"^1.2.1","rc-slider":"^8.7.1","react":"^16.12.0","react-alice-carousel":"^1.17.2","react-avatar-editor":"^13.0.0","react-color":"^2.17.3","react-copy-to-clipboard":"^5.0.2","react-device-detect":"^1.11.14","react-dom":"^16.2.0","react-feather":"^2.0.4","react-file-base64":"^1.0.3","react-file-input-previews-base64":"^1.0.6","react-form":"^2.15.0","react-icons":"^4.3.1","react-instagram-media":"^1.3.2","react-jss":"^8.3.3","react-lines-ellipsis":"^0.14.1","react-moment":"^0.9.7","react-perfect-scrollbar":"^1.5.8","react-phone-input-2":"^2.11.0","react-phone-number-input":"^2.5.2","react-redux":"^5.0.7","react-redux-i18n":"^1.9.3","react-responsive-carousel":"^3.1.51","react-router":"^4.2.0","react-router-dom":"^4.2.2","react-router-ga":"^1.2.3","react-router-hash-link":"^1.2.0","react-select":"^4.3.1","react-select-fast-filter-options":"^0.2.3","react-slick":"^0.25.2","react-spring":"^8.0.27","react-stripe-elements":"^6.1.2","react-toastify":"^5.4.0","react-tooltip":"^4.1.0","react-transition-group":"^2.2.1","react-virtualized-select":"^3.1.3","reactcss":"^1.2.3","reactstrap":"^8.2.0","redux":"^3.7.2","redux-form":"^7.2.3","redux-form-material-ui":"^4.3.3","redux-logger":"^3.0.6","redux-observable":"^1.0.0","redux-promise":"^0.5.3","redux-thunk":"^2.2.0","reset-css":"^3.0.0","rxjs":"^6.2.2","rxjs-compat":"^6.2.2","slick-carousel":"^1.8.1"},"jest":{"testRegex":"(src)/.*\\.spec\\.js$","setupFiles":["./tools/testSetup.js"]},"browserslist":["> 0.5%","last 2 versions"]}

/***/ }),

/***/ 2803:
/*!*************************************************************************!*\
  !*** ./src/containers/app/components/DashboardLayout/NavBar/NavItem.js ***!
  \*************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(/*! react-router-dom */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_ListItem__ = __webpack_require__(/*! @material-ui/core/es/ListItem */ 226);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NavItem = function (_Component) {
  _inherits(NavItem, _Component);

  function NavItem(props) {
    _classCallCheck(this, NavItem);

    var _this = _possibleConstructorReturn(this, (NavItem.__proto__ || Object.getPrototypeOf(NavItem)).call(this, props));

    _this.handleToggle = function () {
      _this.setState({ open: !_this.state.open });
    };

    return _this;
  }

  _createClass(NavItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          href = _props.href,
          depth = _props.depth,
          Icon = _props.icon,
          openProp = _props.open,
          onMobileClose = _props.onMobileClose,
          Info = _props.info;

      if (depth > 0) {
        paddingLeft = 32 + 8 * depth;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_ListItem__["a" /* default */],
        {
          button: true,
          disableGutters: true,
          key: title,
          exact: true,
          activeClassName: 'menu-btn-active',
          className: 'menu-btn',
          to: href,
          component: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"],
          onClick: onMobileClose
        },
        Icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, {
          style: { display: 'flex',
            alignItems: 'center',
            marginRight: '10px' },
          size: '20'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { marginRight: 'auto' } },
          title
        ),
        Info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Info, null)
      );
    }
  }]);

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),

/***/ 3091:
/*!************************************************************************!*\
  !*** ./src/containers/app/components/DashboardLayout/TopBar/TopBar.js ***!
  \************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(/*! react-router-dom */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_feather__ = __webpack_require__(/*! react-feather */ 659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Account__ = __webpack_require__(/*! ./Account */ 3092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_BlueMailAccount_png__ = __webpack_require__(/*! ../../../../../images/BlueMailAccount.png */ 3095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_BlueMailAccount_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_BlueMailAccount_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_type_white_100x100_svg__ = __webpack_require__(/*! ../../../../../images/type-white-100x100.svg */ 3096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_type_white_100x100_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_type_white_100x100_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_White_bplus_1_png__ = __webpack_require__(/*! ../../../../../images/White-bplus_1.png */ 3097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_White_bplus_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_White_bplus_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(/*! react-redux/es/connect/connect */ 243);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TopBar = function (_Component) {
  _inherits(TopBar, _Component);

  function TopBar() {
    _classCallCheck(this, TopBar);

    return _possibleConstructorReturn(this, (TopBar.__proto__ || Object.getPrototypeOf(TopBar)).apply(this, arguments));
  }

  _createClass(TopBar, [{
    key: 'logout',
    value: function logout() {
      window.location.replace('/auth/logout');
    }
  }, {
    key: 'getLogo',
    value: function getLogo(brandId) {
      switch (brandId) {
        case 'BL':
          {
            return __WEBPACK_IMPORTED_MODULE_5__images_BlueMailAccount_png___default.a;
          }
        case 'BP':
          {
            return __WEBPACK_IMPORTED_MODULE_7__images_White_bplus_1_png___default.a;
          }
        default:
          {
            return __WEBPACK_IMPORTED_MODULE_6__images_type_white_100x100_svg___default.a;
          }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onMobileNavOpen = _props.onMobileNavOpen,
          user = _props.user,
          brand = _props.brand;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["a" /* AppBar */],
        { style: { background: '#fff', zIndex: '1300', borderBottom: '1px solid',
            borderImage: 'linear-gradient(90deg, rgba(27, 97, 237, 0.1) 12.5%, rgba(27, 97, 237, 0.1) 87.5%) 1 stretch', boxShadow: 'none' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["l" /* Toolbar */],
          { style: { minHeight: '64px', justifyContent: 'space-between' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["f" /* Hidden */],
            { lgUp: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["g" /* IconButton */],
              {
                onClick: onMobileNavOpen
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["k" /* SvgIcon */],
                { fontSize: 'inherit' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_feather__["d" /* Menu */], null)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["f" /* Hidden */],
            { mdDown: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'flex-end' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: this.getLogo(brand.id), alt: 'brand-logo', style: { marginRight: '10px' } })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontWeight: 'bold', color: '#6F6F6F', fontSize: '15px' } },
              user.email
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Account__["a" /* default */], null)
          )
        )
      );
    }
  }]);

  return TopBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      brand = _ref.brand;
  return { user: user, brand: brand };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps)(TopBar));

/***/ }),

/***/ 3092:
/*!*************************************************************************!*\
  !*** ./src/containers/app/components/DashboardLayout/TopBar/Account.js ***!
  \*************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(/*! react-router-dom */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(/*! react-router */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_feather__ = __webpack_require__(/*! react-feather */ 659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_003_user_1_png__ = __webpack_require__(/*! ../../../../../images/003-user-1.png */ 3093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_003_user_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_003_user_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mui_icons_material_AccountCircleOutlined__ = __webpack_require__(/*! @mui/icons-material/AccountCircleOutlined */ 3094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mui_icons_material_AccountCircleOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mui_icons_material_AccountCircleOutlined__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import { useDispatch, useSelector } from 'react-redux';
// import { useSnackbar } from 'notistack';



// import { logout } from 'src/actions/accountActions';

// const classes = {
//   avatar: {
//     height: 32,
//     width: 32,
//     marginRight: '10px'
//   },
//   popover: {
//     width: 200
//   }
// };

// const ref = useRef(null);
//   // const dispatch = useDispatch();
//   // const account = useSelector((state) => state.account);
//   // const { enqueueSnackbar } = useSnackbar();
//   // const [isOpen, setOpen] = useState(false);


//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       handleClose();
//       // await dispatch(logout());
//       // history.push('/');
//     } catch (error) {
//       // enqueueSnackbar('Unable to logout', {
//       //   variant: 'error'
//       // });
//     }
//   };

var Account = function (_Component) {
  _inherits(Account, _Component);

  // const history = useHistory();
  function Account(props) {
    _classCallCheck(this, Account);

    var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));

    _this.handleOpen = function () {
      _this.setState({ isOpen: true });
    };

    _this.handleClose = function () {
      _this.setState({ isOpen: false });
    };

    _this.logout = function () {
      window.location.replace('/auth/logout');
    };

    _this.state = {
      isOpen: false
    };
    _this.settingsRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this;
  }

  _createClass(Account, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;
      var isOpen = this.state.isOpen;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: "flex", alignItems: "center" },
            onClick: this.handleOpen,
            ref: this.settingsRef
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* Hidden */],
            { smDown: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["m" /* Typography */], {
              variant: 'body1',
              color: 'inherit'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__material_ui_core__["g" /* IconButton */],
              { style: { color: '#000', padding: '6px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__mui_icons_material_AccountCircleOutlined___default.a, { sx: { color: 'rgb(111, 111, 111)' } })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__material_ui_core__["i" /* Menu */],
          {
            className: 'settings-menu',
            onClose: this.handleClose,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center'
            },
            keepMounted: true
            // PaperProps={{ className: classes.popover }}
            , getContentAnchorEl: null,
            anchorEl: this.settingsRef.current,
            open: isOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__material_ui_core__["j" /* MenuItem */],
            {
              onClick: this.logout
            },
            'Logout'
          )
        )
      );
    }
  }]);

  return Account;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref) {
  var app = _ref.app,
      user = _ref.user,
      brand = _ref.brand;

  return { app: app, user: user, brand: brand };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, {})(Account));

/***/ }),

/***/ 3093:
/*!***********************************!*\
  !*** ./src/images/003-user-1.png ***!
  \***********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATbSURBVHgBtVhLUhtJEE01IoLd9A2ml7MDFsDskHazG+YEwI7gK58A6QSW+AU7NCcwPoGb3QQsBp/A7RNY3hH85PearFbSVqurZftFdFR/Xle9yqrKzKqaTIFWqxU+PT2tBUEwPxwOG7hCvI4MJeGF77fgXT0+Pt6en58nUhG1KuTd3d1GrVY7xG1DqiNGJ3onJyeXvj94iZsgaoAGY1jo8/Pz88C9xHOI53n8E8lrixIJrPnP2dnZrfyIOA4fGj9EQ62coB7KGFaIpQTb29sLENuC0FUrFO+6eNfpdruDyuIgLEIPP5gKU1H1er07rkJ25O7uLpybmxsUNbi3t7eB4tDUmTw8PDSL5mPNU9jlzMzMZr5RCoJVDyB6w3AFFrllR/DP5Zh/IiyQNjjrZQJrZcLQSAfD187zOFxo/J18P6csChvGPG7rPC7k1XLC6CL+LxOmHSAvVB5X4nvMowEsGaLRv3E1lD5Aw4s+AtHZRWvpuiVz8pcJI9SyoT5ugtfPUbo7OzstiH1L3uzs7AXKZr4e1g+BogIjbf+N+z7jbjhMIPX1sY8f34zRxd6ugbdlOtAdx7u5uflvaWnpK7h/seHl5eWr6+vrJM/Du3hlZWUBt3+gvj8tL8hUvswfguPfkQJwyByvyLIOp6enFD7Q/9aLeFxshueG+UUcrSGjid0pCTWO91E8wLmoZVTE4TxT30k06PQzcVB7oB+S4+Pjvvjhi/xE0H9KznoBV56MwlLsUY+rYEH8MK/8r5NIeevRcwRwiFkjWIU9KQFcxRVLVLTgzF8Edtx0wifgx+7m/v5+jcPa0OfEJxjDLfRlZL2Lra2tSAqEqctJ68Yii6UEGqvTuuGGFgI0kJodlkjEAzQ/rOdWcwSxHxgzOQwqKqSPs1EG/F6FfC5WcauBVFx9BF2EmR8RrguI+QKRQ5bqfPk+9YXqUrwA/mctw7qYrMPnZxPs13349G/7+/tDzKF/Pa3ndESBVAAXACzzCcLaMgpfXGWXENGjlbTk5E9cI+Rz+NWfeqPuS0TvD1VUCgZ7FJ1JCaeu5g2NDly571BP++joqCMeoOUSvQ/FTxgt1YSoZlkmzO+4NnC76dphPaxvwm9ORxKA7NxCNI7JoTDC6BIWfdJzC0YdxM+mFVjkI633oOWu9P1qnqhO9K0R1pxmi0fABSUqMPORzv3k4Jz2R/o553jDfG+wKtO5oo+daYVZgbDIpj4yXbcbpzRtk9GwxgHzfPO9Ycm6N0gnf4WEYCJ03xrzngmHtR60uAREuBEPNC3+jpxPo+Qngi5Hb0Mb22VknPccpWAMuZUjDqougDLYGAqkvk+3jZHqSSNKYMi8MuuZVVOaDEyJOBWAGKppW7bRccbIIoS1HqLAhUwRc6vAxlC0l22seFThOJk4qjXB3M43r5g7BbIYimtDXoT2bNr2KrYiVW7LKGKkwPD+Lr8GeR+XaPsZXonjyrWeXBHJL4Cb004YHXz+6ML3rKTP7eKPOmGt283pNSvM66xkgsAEV2daZ2zyQLqqsEzYRHGuQj0ROjCvE1wxN0M+ew6GRLqLnCjR47T2VOdzFhNOlFjxrZ79Zls/cH+DlchtSG7i++SBlcQ5aGJwAEtWymirinKoJM5BDwB5nNooOPtl9jHA9ytGmHGHiD74BsTfQ/uB1i2eAAAAAElFTkSuQmCC"

/***/ }),

/***/ 3095:
/*!****************************************!*\
  !*** ./src/images/BlueMailAccount.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 3096:
/*!*******************************************!*\
  !*** ./src/images/type-white-100x100.svg ***!
  \*******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/type-white-100x100.c0da3c1b.svg";

/***/ }),

/***/ 3097:
/*!**************************************!*\
  !*** ./src/images/White-bplus_1.png ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/White-bplus_1.4aad8c96.png";

/***/ }),

/***/ 3098:
/*!****************************************!*\
  !*** ./src/redux/middlewares/index.js ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(/*! ./api */ 3099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Firewall__ = __webpack_require__(/*! ./Firewall */ 3100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(/*! redux-logger */ 3101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_promise__ = __webpack_require__(/*! redux-promise */ 3102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(/*! redux-thunk */ 3106);



var logger = Object(__WEBPACK_IMPORTED_MODULE_2_redux_logger__["createLogger"])();



/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_4_redux_thunk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_redux_promise___default.a, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* axiosMiddleware */],
// windowMiddleware,
__WEBPACK_IMPORTED_MODULE_1__Firewall__["a" /* default */], logger]);

/***/ }),

/***/ 3099:
/*!**************************************!*\
  !*** ./src/redux/middlewares/api.js ***!
  \**************************************/
/*! exports provided: axiosMiddleware, windowMiddleware */
/*! exports used: axiosMiddleware */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosMiddleware; });
/* unused harmony export windowMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 70);
var _apiObject;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var middlewareFactory = function middlewareFactory(callbackType) {
    return function (store) {
        return function (next) {
            return function (action) {
                if (apiObject[action.type]) {
                    var _apiObject$action$typ = apiObject[action.type],
                        callback = _apiObject$action$typ[callbackType],
                        isPromise = _apiObject$action$typ.isPromise;

                    if (isPromise) {
                        return callback(action.payload).then(function (payload) {
                            action.onSuccess && action.onSuccess();
                            next(Object.assign({}, action, { payload: payload }));
                        }).catch(function (payload) {
                            action.onFailure && action.onFailure();
                            next(Object.assign({}, action, { payload: payload, error: true }));
                        });
                    }
                    return next(Object.assign({}, action, { payload: callback(action.payload) }));
                }
                return next(action);
            };
        };
    };
};

var axiosMiddleware = middlewareFactory('axiosCallback');

var windowMiddleware = middlewareFactory('windowCallback');

var apiGenerator = function apiGenerator(isPromise, axiosCallback, windowCallback) {
    return { isPromise: isPromise, axiosCallback: axiosCallback, windowCallback: windowCallback };
};

window.selfPortal = {
    getBrand: function getBrand() {},
    getDevices: function getDevices() {},
    destroyAccount: function destroyAccount() {},
    destroyAnyMailAccount: function destroyAnyMailAccount() {},
    getDestroyStatus: function getDestroyStatus() {},
    deleteShare: function deleteShare() {},
    getAccountPII: function getAccountPII() {},
    getAnyMailAccountPII: function getAnyMailAccountPII() {},
    getAccountPIIStatus: function getAccountPIIStatus() {},
    removeAccountFromDevice: function removeAccountFromDevice() {},
    getEnv: function getEnv() {}
};

var apiObject = (_apiObject = {}, _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["h" /* GET_BRAND */], apiGenerator(true, function () {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/brand');
}, window.selfPortal.getBrand)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["j" /* GET_DEVICES */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/devices/' + email);
}, window.selfPortal.getDevices)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* DESTROY_ACCOUNT */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/api/account/destroy/' + email);
}, window.selfPortal.destroyAccount)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* DESTROY_ANY_MAIL_ACCOUNT */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/api/account/destroy/anyMail/' + email);
}, window.selfPortal.destroyAnyMailAccount)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["i" /* GET_DESTROY_STATUS */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/account/destroy/status/' + email);
}, window.selfPortal.getDestroyStatus)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* DELETE_SHARE */], apiGenerator(true, function (share_url) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["delete"]('/api/account/delete/share', { data: { share_url: share_url } });
}, window.selfPortal.deleteShare)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* GET_ACCOUNT_PII */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/account-pii/' + email);
}, window.selfPortal.getAccountPII)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* GET_ANY_MAIL_ACCOUNT_PII */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/account-pii/anyMail/' + email);
}, window.selfPortal.getAnyMailAccountPII)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* GET_ACCOUNT_PII_STATUS */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/account-pii/status/' + email);
}, window.selfPortal.getAccountPIIStatus)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* GET_ANY_MAIL_ACCOUNT_PII_STATUS */], apiGenerator(true, function (email) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/account-pii/status/anyMail/' + email);
}, window.selfPortal.getAnyMailAccountPIIStatus)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["l" /* SET_COMMAND */], apiGenerator(true, function (action) {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/api/devices-command?brand=' + brand, action);
}, window.selfPortal.removeAccountFromDevice)), _defineProperty(_apiObject, __WEBPACK_IMPORTED_MODULE_1__types__["k" /* GET_ENV */], apiGenerator(true, function () {
    return __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/env');
}, window.selfPortal.getEnv)), _apiObject);

/***/ }),

/***/ 3100:
/*!*******************************************!*\
  !*** ./src/redux/middlewares/Firewall.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_login_LoginActions__ = __webpack_require__(/*! ../../containers/login/LoginActions */ 248);



var HTTP_STATUS_UNAUTHORIZED = 401;
/* harmony default export */ __webpack_exports__["a"] = (function (store) {
    return function (next) {
        return function (action) {
            if (action.payload && action.error && (action.payload.response && action.payload.response.status === HTTP_STATUS_UNAUTHORIZED || action.payload.status === HTTP_STATUS_UNAUTHORIZED)) {
                store.dispatch(__WEBPACK_IMPORTED_MODULE_0__containers_login_LoginActions__["e" /* sessionExpired */]());
            }
            return next(action);
        };
    };
});

/***/ }),

/***/ 3226:
/*!****************************!*\
  !*** ./src/redux/epics.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_billing_BillingsEpics__ = __webpack_require__(/*! ../containers/billing/BillingsEpics */ 3227);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = ([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__containers_billing_BillingsEpics__["a" /* default */])));

/***/ }),

/***/ 3227:
/*!*************************************************!*\
  !*** ./src/containers/billing/BillingsEpics.js ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators__ = __webpack_require__(/*! rxjs/operators */ 674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(/*! redux-observable */ 1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(/*! rxjs */ 234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_AppActions__ = __webpack_require__(/*! ../app/AppActions */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__ = __webpack_require__(/*! ../login/LoginActions */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BillingActions__ = __webpack_require__(/*! ./BillingActions */ 161);








var getCreditDetailsEpic = function getCreditDetailsEpic(action$, state$, _ref) {
    var sendGet = _ref.sendGet;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["n" /* GET_CREDIT_DETAILS_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendGet('/api/payment/credit').pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["J" /* getCreditDetailsFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["J" /* getCreditDetailsFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

var deleteCreditEpic = function deleteCreditEpic(action$, state$, _ref2) {
    var sendDelete = _ref2.sendDelete;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["h" /* DELETE_CREDIT_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendDelete("/api/payment/credit?last4digits=" + action.payload).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* mergeMap */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["C" /* deleteCreditFulfilled */])(response));
        }, Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["P" /* toggleCreditDetails */])()), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["C" /* deleteCreditFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */], __WEBPACK_IMPORTED_MODULE_6__BillingActions__["u" /* TOGGLE_CREDIT_DETAILS */]))));
    }));
};

var createOrUpdateCreditEpic = function createOrUpdateCreditEpic(action$, state$, _ref3) {
    var sendPost = _ref3.sendPost;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["f" /* CREATE_OR_UPDATE_CREDIT_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendPost('/api/payment/creditsubscribe', action.payload.info, { email: action.payload.email }).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* mergeMap */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["A" /* createOrUpdateCreditFulfilled */])(response));
        }, Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["P" /* toggleCreditDetails */])()), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["A" /* createOrUpdateCreditFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */], __WEBPACK_IMPORTED_MODULE_6__BillingActions__["u" /* TOGGLE_CREDIT_DETAILS */]))));
    }));
};

//B 
var getPlansEpic = function getPlansEpic(action$, state$, _ref4) {
    var sendGet = _ref4.sendGet;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["t" /* GET_PLANS_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendGet('/api/premium/email/plans/available', action.payload.info, { email: action.payload.email }).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["H" /* getAvailablePlansFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["H" /* getAvailablePlansFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

var getInvoicesEpic = function getInvoicesEpic(action$, state$, _ref5) {
    var sendGet = _ref5.sendGet;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["r" /* GET_INVOICES_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendGet('/api/premium/email/invoices', action.payload.info, { email: action.payload.email }).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["N" /* getInvoicesFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["N" /* getInvoicesFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

//B 
var getEmailPlansEpic = function getEmailPlansEpic(action$, state$, _ref6) {
    var sendGet = _ref6.sendGet;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["p" /* GET_EMAIL_PLANS_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendGet('/api/premium/email/plans', action.payload.info).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["L" /* getEmailPlansFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["L" /* getEmailPlansFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

//B 
var attachPlanToClientEpic = function attachPlanToClientEpic(action$, state$, _ref7) {
    var sendPost = _ref7.sendPost;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["b" /* ATTACH_PLAN_TO_CLIENT_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendPost('/api/premium/email/subscription', [{ id: action.payload.planId }]).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["v" /* atachPlanToClientFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["v" /* atachPlanToClientFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

//B 
var deletePlanFromClientEpic = function deletePlanFromClientEpic(action$, state$, _ref8) {
    var sendPost = _ref8.sendPost;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["l" /* DETACH_PLAN_FROM_CLIENT_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendPost('/api/premium/email/subscription', []).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["D" /* deletePlanFromClientFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["D" /* deletePlanFromClientFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

var deletePlansFromClientEpic = function deletePlansFromClientEpic(action$, state$, _ref9) {
    var sendPost = _ref9.sendPost;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["j" /* DELETE_PLANS_FROM_CLIENT_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendPost('/api/premium/email/subscription/cancelAll', []).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["F" /* deletePlansFromClientFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["F" /* deletePlansFromClientFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

var confirm3dSecureEpic = function confirm3dSecureEpic(action$, state$, _ref10) {
    var sendPost = _ref10.sendPost;
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["d" /* CONFIRM_3D_SECURE_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["g" /* switchMap */])(function (action) {
        return sendPost('/api/payment/confirmation/email/' + action.payload.email, [{ subId: action.payload.subId }]).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["c" /* map */])(function (response) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["y" /* confirm3dSecureFulfilled */])(response);
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs__["e" /* of */])(Object(__WEBPACK_IMPORTED_MODULE_6__BillingActions__["y" /* confirm3dSecureFulfilled */])(err, true));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["h" /* takeUntil */])(action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__app_AppActions__["d" /* ROUTE_CHANGED */], __WEBPACK_IMPORTED_MODULE_5__login_LoginActions__["c" /* SESSION_EXPIRED */]))));
    }));
};

//getPlansEpic
/* harmony default export */ __webpack_exports__["a"] = ([getCreditDetailsEpic, createOrUpdateCreditEpic, getPlansEpic, attachPlanToClientEpic, getEmailPlansEpic, deletePlanFromClientEpic, deleteCreditEpic, deletePlansFromClientEpic, confirm3dSecureEpic, getInvoicesEpic]);

/***/ }),

/***/ 3235:
/*!*************************!*\
  !*** ./src/styles.scss ***!
  \*************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/*!************************************************************!*\
  !*** ./src/components/material-pro/Grid/GridContainer.jsx ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/styles/withStyles */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(/*! @material-ui/core/Grid */ 1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



// @material-ui/core components



var style = {
  grid: {
    margin: "0 -15px",
    width: "calc(100% + 30px)"
    // '&:before,&:after':{
    //   display: 'table',
    //   content: '" "',
    // },
    // '&:after':{
    //   clear: 'both',
    // }
  }
};

function GridContainer(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var classes = props.classes,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, ["classes", "children", "className"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,
    Object.assign({ container: true }, rest, { className: classes.grid + " " + className }),
    children
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridContainer));

/***/ }),

/***/ 340:
/*!*******************************************************!*\
  !*** ./src/components/material-pro/Grid/GridItem.jsx ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/es/styles/withStyles */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_Grid_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid/Grid */ 872);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var style = {
  grid: {
    padding: "0 15px !important"
  }
};

function GridItem(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var classes = props.classes,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, ["classes", "children", "className"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__material_ui_core_es_Grid_Grid__["a" /* default */],
    Object.assign({ item: true }, rest, { className: classes.grid + " " + className }),
    children
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_styles_withStyles__["a" /* default */])(style)(GridItem));

/***/ }),

/***/ 369:
/*!******************************************************!*\
  !*** ./src/containers/signature/SignatureActions.js ***!
  \******************************************************/
/*! exports provided: SAVE_SIGNATURE_START, SAVE_SIGNATURE_SUCCESS, SAVE_SIGNATURE_FAILURE, FETCH_SIGNATURE_START, FETCH_SIGNATURE_SUCCESS, FETCH_SIGNATURE_FAILURE, FETCH_TWEETS_START, FETCH_TWEETS_SUCCESS, FETCH_TWEETS_FAILURE, FETCH_INSTAGRAM_START, FETCH_INSTAGRAM_SUCCESS, FETCH_INSTAGRAM_FAILURE, saveSignature, fetchSignature, fetchTweets, fetchInstagramLastPost */
/*! exports used: FETCH_INSTAGRAM_FAILURE, FETCH_INSTAGRAM_START, FETCH_INSTAGRAM_SUCCESS, FETCH_SIGNATURE_FAILURE, FETCH_SIGNATURE_START, FETCH_SIGNATURE_SUCCESS, FETCH_TWEETS_FAILURE, FETCH_TWEETS_START, FETCH_TWEETS_SUCCESS, SAVE_SIGNATURE_FAILURE, SAVE_SIGNATURE_START, SAVE_SIGNATURE_SUCCESS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_SIGNATURE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_SIGNATURE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SIGNATURE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_SIGNATURE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_TWEETS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_TWEETS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_TWEETS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_INSTAGRAM_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_INSTAGRAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_INSTAGRAM_FAILURE; });
/* unused harmony export saveSignature */
/* unused harmony export fetchSignature */
/* unused harmony export fetchTweets */
/* unused harmony export fetchInstagramLastPost */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var SAVE_SIGNATURE_START = "SAVE_SIGNATURE_START";
var SAVE_SIGNATURE_SUCCESS = "SAVE_SIGNATURE_SUCCESS";
var SAVE_SIGNATURE_FAILURE = "SAVE_SIGNATURE_FAILURE";

var FETCH_SIGNATURE_START = "FETCH_SIGNATURE_START";
var FETCH_SIGNATURE_SUCCESS = "FETCH_SIGNATURE_SUCCESS";
var FETCH_SIGNATURE_FAILURE = "FETCH_SIGNATURE_FAILURE";

var FETCH_TWEETS_START = "FETCH_TWEETS_START";
var FETCH_TWEETS_SUCCESS = "FETCH_TWEETS_SUCCESS";
var FETCH_TWEETS_FAILURE = "FETCH_TWEETS_FAILURE";

var FETCH_INSTAGRAM_START = "FETCH_INSTAGRAM_START";
var FETCH_INSTAGRAM_SUCCESS = "FETCH_INSTAGRAM_SUCCESS";
var FETCH_INSTAGRAM_FAILURE = "FETCH_INSTAGRAM_FAILURE";

var URL = '/api/signature';

var saveSignature = function saveSignature(email, signature, fields) {
    return function (dispatch) {
        dispatch({ type: SAVE_SIGNATURE_START });

        var postData = {
            email: email, signature: signature, fields: fields
        };

        var axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*"
            }
        };

        __WEBPACK_IMPORTED_MODULE_0_axios__["put"](URL, postData, axiosConfig).then(function (res) {
            dispatch({ type: "SAVE_SIGNATURE_SUCCESS", payload: res });
        }).catch(function (err) {
            dispatch({ type: "SAVE_SIGNATURE_FAILURE", payload: err });
        });
    };
};

var fetchSignature = function fetchSignature(email) {
    return function (dispatch) {
        dispatch({ type: FETCH_SIGNATURE_START });

        __WEBPACK_IMPORTED_MODULE_0_axios__["get"](URL + '?email=' + email).then(function (response) {

            if (!response.data && !response.data.url) {
                dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: { 'error': 'no url' } });
            }

            __WEBPACK_IMPORTED_MODULE_0_axios__["get"](response.data.url).then(function (response) {
                dispatch({ type: "FETCH_SIGNATURE_SUCCESS", payload: response.data });
            }).catch(function (err) {
                dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: err });
            });
        }).catch(function (err) {
            dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: err });
        });
    };
};

var fetchTweets = function fetchTweets(data) {
    return function (dispatch) {
        dispatch({ type: FETCH_TWEETS_START });

        var username = data.username,
            count = data.count;


        __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/signature/getTweets' + '?username=' + username + '&count=' + count).then(function (response) {

            if (response.status != 200 && !response.data) {
                dispatch({ type: "FETCH_TWEETS_FAILURE", payload: { 'error': response.statusText } });
            }

            dispatch({ type: "FETCH_TWEETS_SUCCESS", payload: response.data });
        }).catch(function (err) {
            dispatch({ type: "FETCH_TWEETS_FAILURE", payload: err });
        });
    };
};

var fetchInstagramLastPost = function fetchInstagramLastPost(data) {
    return function (dispatch) {
        dispatch({ type: FETCH_INSTAGRAM_START });
        var username = data.username;

        __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/signature/instagramLastPost' + '?username=' + username).then(function (response) {
            if (response.status != 200 && !response.data) {
                dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: { 'error': response.statusText } });
            }
            dispatch({ type: "FETCH_INSTAGRAM_SUCCESS", payload: response.data });
        }).catch(function (err) {
            dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: err });
        });
    };
};

/***/ }),

/***/ 370:
/*!**************************************************!*\
  !*** ./src/containers/devices/DevicesActions.js ***!
  \**************************************************/
/*! exports provided: GET_DEVICES_START, getDevices, SET_COMMAND_START, setCommand */
/*! exports used: GET_DEVICES_START, getDevices, setCommand */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_DEVICES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDevices; });
/* unused harmony export SET_COMMAND_START */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);


var GET_DEVICES_START = "GET_DEVICES_START";

var getDevices = function getDevices(email) {
    return function (dispatch) {
        dispatch({ type: GET_DEVICES_START });

        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_0__redux_types__["j" /* GET_DEVICES */],
            payload: email
        });
    };
};

var SET_COMMAND_START = "SET_COMMAND_START";

var setCommand = function setCommand(action) {
    return function (dispatch) {
        dispatch({ type: SET_COMMAND_START });

        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_0__redux_types__["l" /* SET_COMMAND */],
            payload: action
        });
    };
};

/***/ }),

/***/ 409:
/*!***********************************************!*\
  !*** ./src/components/common/LabelAndText.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_grey__ = __webpack_require__(/*! @material-ui/core/colors/grey */ 105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_grey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_grey__);



var grey600 = __WEBPACK_IMPORTED_MODULE_2__material_ui_core_colors_grey___default.a['600'];

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
    var label = _ref.label,
        content = _ref.content,
        autoSize = _ref.autoSize;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Grid__["a" /* default */],
        { container: true, spacing: 8, style: { padding: '10px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: autoSize ? undefined : 12, sm: autoSize ? undefined : 3, style: { color: grey600 } },
            label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__material_ui_core_es_Grid__["a" /* default */],
            { item: true, xs: autoSize ? undefined : 12, sm: autoSize ? undefined : 9 },
            content
        )
    );
});

/***/ }),

/***/ 597:
/*!**********************************************************************!*\
  !*** ./src/containers/delete-account/components/UploadsInfoTable.js ***!
  \**********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_List__ = __webpack_require__(/*! @material-ui/core/es/List */ 219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mui_material_ListItemText__ = __webpack_require__(/*! @mui/material/ListItemText */ 324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mui_material_ListItemButton__ = __webpack_require__(/*! @mui/material/ListItemButton */ 323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_ListItemText__ = __webpack_require__(/*! @material-ui/core/es/ListItemText */ 330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_es_ListItemSecondaryAction__ = __webpack_require__(/*! @material-ui/core/es/ListItemSecondaryAction */ 1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Button__ = __webpack_require__(/*! @material-ui/core/es/Button */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DeleteAccountActions__ = __webpack_require__(/*! ../DeleteAccountActions */ 144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Icon__ = __webpack_require__(/*! @material-ui/core/es/Icon */ 598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_icons_fa__ = __webpack_require__(/*! react-icons/fa */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_toastify__ = __webpack_require__(/*! react-toastify */ 2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_toastify_dist_ReactToastify_css__ = __webpack_require__(/*! react-toastify/dist/ReactToastify.css */ 2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_toastify_dist_ReactToastify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_toastify_dist_ReactToastify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_emails_scrollbarCss_css__ = __webpack_require__(/*! ../../shared-emails/scrollbarCss.css */ 2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_emails_scrollbarCss_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__shared_emails_scrollbarCss_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var DeviceInfoList = function (_Component) {
    _inherits(DeviceInfoList, _Component);

    function DeviceInfoList() {
        _classCallCheck(this, DeviceInfoList);

        return _possibleConstructorReturn(this, (DeviceInfoList.__proto__ || Object.getPrototypeOf(DeviceInfoList)).apply(this, arguments));
    }

    _createClass(DeviceInfoList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                account = _props.account,
                timeout = _props.timeout,
                content = _props.content,
                deleteShare = _props.deleteShare;
            var uploadsInfo = account.pii.uploadsInfo;

            var data = content || uploadsInfo;

            if (!data) {
                return null;
            }

            if (account && account.deleteShareStatus && account.deleteShareStatus.result == "ok") {
                Object(__WEBPACK_IMPORTED_MODULE_14_react_toastify__["b" /* toast */])("The link was successfully removed", { type: "success" });
            }

            if (account && account.deleteShareStatus && account.deleteShareStatus.result == "error") {
                Object(__WEBPACK_IMPORTED_MODULE_14_react_toastify__["b" /* toast */])("Error - Please try again...", { type: "error" });
            }

            return (
                // <Grow in timeout={timeout || 1000}>
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Paper__["a" /* default */],
                    { style: { padding: '20px', marginBottom: '40px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { className: classes.title },
                        "Shared Emails"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: classes.tableWrapper },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { style: { minWidth: 'fit-content' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_List__["a" /* default */],
                                { id: "sharedList", className: classes.contactsList, subheader: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null) },
                                data.map(function (_ref, index) {
                                    var url = _ref.url;
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6__mui_material_ListItemText__["a" /* default */],
                                        { key: url, style: { paddingLeft: '0', paddingRight: '0' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "a",
                                                    { className: classes.link, href: url, target: "_blank" },
                                                    url
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "div",
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_7__mui_material_ListItemButton__["a" /* default */],
                                                    { style: { top: '70%' } },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_ListItemText__["a" /* default */],
                                                        { style: { maxWidth: '58px', padding: '0' }, onClick: function onClick() {
                                                                return deleteShare(url);
                                                            } },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_icons_fa__["c" /* FaTrash */], null)
                                                    )
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_toastify__["a" /* ToastContainer */], { position: 'bottom-center', hideProgressBar: true, autoClose: 5000 })
                    )
                )
                // </Grow>

            );
        }
    }]);

    return DeviceInfoList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref2) {
    var account = _ref2.account;

    return { account: account };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        deleteShare: __WEBPACK_IMPORTED_MODULE_11__DeleteAccountActions__["f" /* deleteShare */]
    }, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DeviceInfoList));

/***/ }),

/***/ 599:
/*!*****************************************************************!*\
  !*** ./src/containers/delete-account/components/DaInfoTable.js ***!
  \*****************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TablePaginationActions__ = __webpack_require__(/*! ./TablePaginationActions */ 1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Table__ = __webpack_require__(/*! @material-ui/core/es/Table */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody__ = __webpack_require__(/*! @material-ui/core/TableBody */ 221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__ = __webpack_require__(/*! @material-ui/core/es/TableRow */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__ = __webpack_require__(/*! @material-ui/core/es/TableCell */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter__ = __webpack_require__(/*! @material-ui/core/TableFooter */ 600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_TablePagination__ = __webpack_require__(/*! @material-ui/core/es/TablePagination */ 601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead__ = __webpack_require__(/*! @material-ui/core/TableHead */ 227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_LabelAndText__ = __webpack_require__(/*! ../../../components/common/LabelAndText */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_List__ = __webpack_require__(/*! @material-ui/core/es/List */ 219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_es_ListSubheader__ = __webpack_require__(/*! @material-ui/core/es/ListSubheader */ 609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_es_ListItem__ = __webpack_require__(/*! @material-ui/core/es/ListItem */ 226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_es_ListItemText__ = __webpack_require__(/*! @material-ui/core/es/ListItemText */ 330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames__ = __webpack_require__(/*! classnames */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var DaInfoList = function (_Component) {
    _inherits(DaInfoList, _Component);

    function DaInfoList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DaInfoList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DaInfoList.__proto__ || Object.getPrototypeOf(DaInfoList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            page: 0,
            rowsPerPage: 5
        }, _this.handleChangePage = function (event, page) {
            return _this.setState({ page: page });
        }, _this.handleChangeRowsPerPage = function (event) {
            return _this.setState({ rowsPerPage: event.target.value });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DaInfoList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                account = _props.account,
                timeout = _props.timeout,
                content = _props.content;
            var _state = this.state,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page;
            var _account$pii = account.pii,
                daInfo = _account$pii.daInfo,
                index = _account$pii.index,
                userInfo = _account$pii.userInfo;

            var data = content || daInfo;
            if (!data && !index && !userInfo) {
                return null;
            }

            // const emptyRows = data ? rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage) : undefined;

            return (
                // <Grow in>
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Paper__["a" /* default */],
                    { className: classes.pageContainer },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { className: classes.title },
                        "Account Info"
                    ),
                    data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: __WEBPACK_IMPORTED_MODULE_19_classnames__(classes.tableWrapper, classes.infoTable) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_Table__["a" /* default */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableHead___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__["a" /* default */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                        null,
                                        "Name"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                        null,
                                        "Description"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                        null,
                                        "Phone"
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                        null,
                                        "Phone Manufacturer"
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableBody___default.a,
                                null,
                                data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (n, i) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__["a" /* default */],
                                        { key: n.model + n.description + n.dManufacturer + i },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                            { className: classes.tableCell },
                                            n.displayName
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                            { className: classes.tableCell },
                                            n.description
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                            { className: classes.tableCell },
                                            n.model
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_TableCell__["a" /* default */],
                                            { className: classes.tableCell },
                                            n.dManufacturer
                                        )
                                    );
                                })
                            ),
                            data.length > 5 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableFooter___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_TableRow__["a" /* default */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_TablePagination__["a" /* default */], {
                                        colSpan: 4,
                                        count: data.length,
                                        rowsPerPage: rowsPerPage,
                                        page: page,
                                        rowsPerPageOptions: [5],
                                        onChangePage: this.handleChangePage,
                                        onChangeRowsPerPage: this.handleChangeRowsPerPage,
                                        Actions: __WEBPACK_IMPORTED_MODULE_3__TablePaginationActions__["a" /* default */]
                                    })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_18__material_ui_core_es_Grid__["a" /* default */],
                        { container: true, className: classes.additionalInfo },
                        index && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18__material_ui_core_es_Grid__["a" /* default */],
                            { item: true, xs: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_LabelAndText__["a" /* default */], { label: "Push Services", content: index.isCredentialsExist, autoSize: true })
                        ),
                        userInfo && userInfo.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_18__material_ui_core_es_Grid__["a" /* default */],
                            { item: true, xs: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_List__["a" /* default */],
                                { className: classes.contactsList, subheader: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_15__material_ui_core_es_ListSubheader__["a" /* default */],
                                    null,
                                    "Phone Numbers"
                                ),
                                userInfo.map(function (_ref2, index) {
                                    var phone = _ref2.phone;
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_16__material_ui_core_es_ListItem__["a" /* default */],
                                        { key: phone },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_es_ListItemText__["a" /* default */], { primary: phone })
                                    );
                                })
                            )
                        )
                    )
                )
                // </Grow>

            );
        }
    }]);

    return DaInfoList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref3) {
    var account = _ref3.account;

    return { account: account };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DaInfoList));

/***/ }),

/***/ 610:
/*!**************************************************************!*\
  !*** ./src/containers/delete-account/components/RtscInfo.js ***!
  \**************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(/*! redux */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Paper__ = __webpack_require__(/*! @material-ui/core/es/Paper */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grow__ = __webpack_require__(/*! @material-ui/core/es/Grow */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_List__ = __webpack_require__(/*! @material-ui/core/es/List */ 219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_ListSubheader__ = __webpack_require__(/*! @material-ui/core/es/ListSubheader */ 609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_ListItem__ = __webpack_require__(/*! @material-ui/core/es/ListItem */ 226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_ListItemText__ = __webpack_require__(/*! @material-ui/core/es/ListItemText */ 330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_LabelAndText__ = __webpack_require__(/*! ../../../components/common/LabelAndText */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Avatar__ = __webpack_require__(/*! @material-ui/core/es/Avatar */ 1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_es_Collapse__ = __webpack_require__(/*! @material-ui/core/es/Collapse */ 264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_ExpansionPanel__ = __webpack_require__(/*! @material-ui/core/es/ExpansionPanel */ 399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_es_ExpansionPanelSummary__ = __webpack_require__(/*! @material-ui/core/es/ExpansionPanelSummary */ 400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_Typography__ = __webpack_require__(/*! @material-ui/core/es/Typography */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_es_ExpansionPanelDetails__ = __webpack_require__(/*! @material-ui/core/es/ExpansionPanelDetails */ 407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_es_Grid__ = __webpack_require__(/*! @material-ui/core/es/Grid */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_icons_md__ = __webpack_require__(/*! react-icons/md */ 267);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var RtscInfo = function (_Component) {
    _inherits(RtscInfo, _Component);

    function RtscInfo() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RtscInfo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RtscInfo.__proto__ || Object.getPrototypeOf(RtscInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            openedGroup: null
        }, _this.toggleGroupCollapse = function (index) {
            _this.setState({ openedGroup: index === _this.state.openedGroup ? null : index });
        }, _this.renderContactsList = function (list, header) {
            var classes = _this.props.classes;

            list = list.map(function (c) {
                return c.split('@')[0].replace('\\40', '@');
            });
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_List__["a" /* default */],
                { className: classes.contactsList, subheader: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null) },
                header && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_ListSubheader__["a" /* default */],
                    null,
                    header
                ),
                list.length > 0 ? list.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_ListItem__["a" /* default */],
                        { divider: !!header, key: item },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_ListItemText__["a" /* default */], { primary: item })
                    );
                }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_ListItem__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_ListItemText__["a" /* default */], { secondary: "No contacts found" })
                )
            );
        }, _this.renderGroupsList = function () {
            var _this$props = _this.props,
                classes = _this$props.classes,
                account = _this$props.account;

            var list = account.pii.rtsc.groups;
            if (list && list.length > 0) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__material_ui_core_es_List__["a" /* default */],
                { className: classes.groupsList, subheader: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__material_ui_core_es_ListSubheader__["a" /* default */],
                    null,
                    "Groups"
                ),
                list.map(function (item, index) {
                    var fields = item.nodeconfig.form.fields.reduce(function (acc, item) {
                        acc[item.name.split('#')[1]] = item.value;
                        return acc;
                    }, {});
                    var members = item.affiliations.a_list.map(function (a) {
                        return a.jid;
                    });
                    var isOpened = _this.state.openedGroup === index;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_ListItem__["a" /* default */],
                        { divider: index < list.length - 1, key: item.jid, style: { padding: 0 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_12__material_ui_core_es_ExpansionPanel__["a" /* default */],
                            { expanded: isOpened, className: classes.expPanel,
                                onChange: function onChange() {
                                    return _this.toggleGroupCollapse(index);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_13__material_ui_core_es_ExpansionPanelSummary__["a" /* default */],
                                { expandIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_icons_md__["d" /* MdExpandMore */], null) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14__material_ui_core_es_Typography__["a" /* default */],
                                    { className: classes.heading },
                                    fields.title || 'Unnamed'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_15__material_ui_core_es_ExpansionPanelDetails__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_16__material_ui_core_es_Grid__["a" /* default */],
                                    { container: true, justify: "center", style: { opacity: isOpened ? 1 : 0 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_16__material_ui_core_es_Grid__["a" /* default */],
                                        { item: true, xs: 12, style: { backgroundColor: 'white' } },
                                        fields.img && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_LabelAndText__["a" /* default */], { label: "Image", content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Avatar__["a" /* default */], { src: fields.img }) }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_LabelAndText__["a" /* default */], { label: "Created at", content: fields.create_date }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_LabelAndText__["a" /* default */], { label: "Members", content: _this.renderContactsList(members) })
                                    )
                                )
                            )
                        )
                    );
                })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RtscInfo, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                account = _props.account,
                timeout = _props.timeout,
                content = _props.content;
            var rtsc = account.pii.rtsc;

            var data = content || rtsc;
            if (!data || Object.keys(data.profile).length === 0 && data.profile.constructor === Object && !(data.groups && data.groups.length > 0)) {
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__material_ui_core_es_Grow__["a" /* default */],
                { "in": true, timeout: timeout || 1000 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__material_ui_core_es_Paper__["a" /* default */],
                    { className: classes.pageContainer },
                    data.profile && Object.keys(data.profile).length > 0 && data.profile.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__material_ui_core_es_ListItem__["a" /* default */],
                        null,
                        data.profile.photo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_es_Avatar__["a" /* default */], { src: data.profile.photo }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_es_ListItemText__["a" /* default */], { primary: data.profile.name,
                            secondary: data.profile.email || data.profile.email_address })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: classes.tableWrapper },
                        this.renderGroupsList()
                    )
                )
            );
        }
    }]);

    return RtscInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(_ref2) {
    var account = _ref2.account;

    return { account: account };
}

function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(RtscInfo));

/***/ }),

/***/ 628:
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/*! exports provided: inIframe, inPopUp, getAppProps */
/*! exports used: getAppProps, inPopUp */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inIframe */
/* harmony export (immutable) */ __webpack_exports__["b"] = inPopUp;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__images_typeapp_logo_big_png__ = __webpack_require__(/*! ./images/typeapp-logo-big.png */ 2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__images_typeapp_logo_big_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__images_typeapp_logo_big_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_bluemail_logo_big_png__ = __webpack_require__(/*! ./images/bluemail-logo-big.png */ 2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_bluemail_logo_big_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__images_bluemail_logo_big_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_bluemailplus_logo_big_png__ = __webpack_require__(/*! ./images/bluemailplus-logo-big.png */ 2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_bluemailplus_logo_big_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_bluemailplus_logo_big_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_ultima_logo_big_png__ = __webpack_require__(/*! ./images/ultima-logo-big.png */ 2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_ultima_logo_big_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_ultima_logo_big_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_blix_logo_big_png__ = __webpack_require__(/*! ./images/blix-logo-big.png */ 2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_blix_logo_big_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_blix_logo_big_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_typeapp_logo_png__ = __webpack_require__(/*! ./images/typeapp-logo.png */ 2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_typeapp_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_typeapp_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_bluemail_logo_png__ = __webpack_require__(/*! ./images/bluemail-logo.png */ 2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_bluemail_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_bluemail_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_bluemailplus_logo_png__ = __webpack_require__(/*! ./images/bluemailplus-logo.png */ 2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_bluemailplus_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_bluemailplus_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ultima_logo_png__ = __webpack_require__(/*! ./images/ultima-logo.png */ 2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ultima_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_ultima_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_blix_logo_png__ = __webpack_require__(/*! ./images/blix-logo.png */ 2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_blix_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_blix_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_bluemail_favicon_png__ = __webpack_require__(/*! ./images/bluemail-favicon.png */ 2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_bluemail_favicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_bluemail_favicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_bluemailplus_favicon_png__ = __webpack_require__(/*! ./images/bluemailplus-favicon.png */ 2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_bluemailplus_favicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_bluemailplus_favicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ultima_favicon_png__ = __webpack_require__(/*! ./images/ultima-favicon.png */ 2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ultima_favicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ultima_favicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_typeapp_favicon_png__ = __webpack_require__(/*! ./images/typeapp-favicon.png */ 2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_typeapp_favicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_typeapp_favicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_blix_favicon_png__ = __webpack_require__(/*! ./images/blix-favicon.png */ 2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_blix_favicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_blix_favicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__typeapp_theme__ = __webpack_require__(/*! ./typeapp-theme */ 2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ultimahq_theme__ = __webpack_require__(/*! ./ultimahq-theme */ 2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__bluemail_theme__ = __webpack_require__(/*! ./bluemail-theme */ 2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__blix_theme__ = __webpack_require__(/*! ./blix-theme */ 2350);




















function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        console.error('inIframe ' + e);
        return true;
    }
}

function inPopUp() {
    try {
        return window.opener && window.opener !== window;
    } catch (e) {
        console.error('inPopUp ' + e);
        return false;
    }
}

function getAppProps(brand) {
    var appProps = {};
    if (brand && brand.id) {
        switch (brand.id) {
            case 'BM':
                {
                    appProps.favIcon = __WEBPACK_IMPORTED_MODULE_13__images_typeapp_favicon_png___default.a;
                    appProps.logo = __WEBPACK_IMPORTED_MODULE_5__images_typeapp_logo_png___default.a;
                    appProps.logoBig = __WEBPACK_IMPORTED_MODULE_0__images_typeapp_logo_big_png___default.a;
                    appProps.theme = __WEBPACK_IMPORTED_MODULE_15__typeapp_theme__["a" /* default */];
                    break;
                }
            case 'EB':
                {
                    appProps.favIcon = __WEBPACK_IMPORTED_MODULE_12__images_ultima_favicon_png___default.a;
                    appProps.logo = __WEBPACK_IMPORTED_MODULE_8__images_ultima_logo_png___default.a;
                    appProps.logoBig = __WEBPACK_IMPORTED_MODULE_3__images_ultima_logo_big_png___default.a;
                    appProps.theme = __WEBPACK_IMPORTED_MODULE_16__ultimahq_theme__["a" /* default */];
                    break;
                }
            case 'BX':
                {
                    appProps.favIcon = __WEBPACK_IMPORTED_MODULE_14__images_blix_favicon_png___default.a;
                    appProps.logo = __WEBPACK_IMPORTED_MODULE_9__images_blix_logo_png___default.a;
                    appProps.logoBig = __WEBPACK_IMPORTED_MODULE_4__images_blix_logo_big_png___default.a;
                    appProps.theme = __WEBPACK_IMPORTED_MODULE_18__blix_theme__["a" /* default */];
                    break;
                }
            case 'BP':
                {
                    appProps.favIcon = __WEBPACK_IMPORTED_MODULE_11__images_bluemailplus_favicon_png___default.a;
                    appProps.logo = __WEBPACK_IMPORTED_MODULE_7__images_bluemailplus_logo_png___default.a;
                    appProps.logoBig = __WEBPACK_IMPORTED_MODULE_2__images_bluemailplus_logo_big_png___default.a;
                    appProps.theme = __WEBPACK_IMPORTED_MODULE_17__bluemail_theme__["a" /* default */];
                    break;
                }
            case 'BL':
            default:
                {
                    appProps.favIcon = __WEBPACK_IMPORTED_MODULE_10__images_bluemail_favicon_png___default.a;
                    appProps.logo = __WEBPACK_IMPORTED_MODULE_6__images_bluemail_logo_png___default.a;
                    appProps.logoBig = __WEBPACK_IMPORTED_MODULE_1__images_bluemail_logo_big_png___default.a;
                    appProps.theme = __WEBPACK_IMPORTED_MODULE_17__bluemail_theme__["a" /* default */];
                }
        }
    } else {
        appProps.favIcon = __WEBPACK_IMPORTED_MODULE_10__images_bluemail_favicon_png___default.a;
        appProps.logo = __WEBPACK_IMPORTED_MODULE_6__images_bluemail_logo_png___default.a;
        appProps.logoBig = __WEBPACK_IMPORTED_MODULE_1__images_bluemail_logo_big_png___default.a;
        appProps.theme = __WEBPACK_IMPORTED_MODULE_17__bluemail_theme__["a" /* default */];
    }
    return appProps;
}

/***/ }),

/***/ 699:
/*!**********************************************!*\
  !*** ./src/components/brand/BrandActions.js ***!
  \**********************************************/
/*! exports provided: GET_BRAND_START, getBrand */
/*! exports used: GET_BRAND_START, getBrand */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BRAND_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBrand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);


var GET_BRAND_START = "GET_BRAND_START";

var getBrand = function getBrand() {
    return function (dispatch) {
        dispatch({ type: GET_BRAND_START });
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__redux_types__["h" /* GET_BRAND */] });
    };
};

/***/ }),

/***/ 70:
/*!****************************!*\
  !*** ./src/redux/types.js ***!
  \****************************/
/*! exports provided: GET_BRAND, GET_DEVICES, DESTROY_ACCOUNT, DESTROY_ANY_MAIL_ACCOUNT, GET_DESTROY_STATUS, GET_ACCOUNT_PII, DELETE_SHARE, GET_ANY_MAIL_ACCOUNT_PII, SET_COMMAND, GET_ACCOUNT_PII_STATUS, GET_ANY_MAIL_ACCOUNT_PII_STATUS, GET_ENV */
/*! exports used: DELETE_SHARE, DESTROY_ACCOUNT, DESTROY_ANY_MAIL_ACCOUNT, GET_ACCOUNT_PII, GET_ACCOUNT_PII_STATUS, GET_ANY_MAIL_ACCOUNT_PII, GET_ANY_MAIL_ACCOUNT_PII_STATUS, GET_BRAND, GET_DESTROY_STATUS, GET_DEVICES, GET_ENV, SET_COMMAND */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_BRAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DESTROY_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DESTROY_ANY_MAIL_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_DESTROY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ACCOUNT_PII; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ANY_MAIL_ACCOUNT_PII; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_COMMAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ACCOUNT_PII_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ANY_MAIL_ACCOUNT_PII_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_ENV; });
var GET_BRAND = 'GET_BRAND [self_portal]';
var GET_DEVICES = 'GET_DEVICES [self_portal]';
var DESTROY_ACCOUNT = 'DESTROY_ACCOUNT [self_portal]';
var DESTROY_ANY_MAIL_ACCOUNT = 'DESTROY_ANY_MAIL_ACCOUNT [self_portal]';
var GET_DESTROY_STATUS = 'GET_DESTROY_STATUS [self_portal]';
var GET_ACCOUNT_PII = 'GET_ACCOUNT_PII [self_portal]';
var DELETE_SHARE = 'DELETE_SHARE [self_portal]';
var GET_ANY_MAIL_ACCOUNT_PII = 'GET_ANY_MAIL_ACCOUNT_PII [self_portal]';
var SET_COMMAND = 'SET_COMMAND [self_portal]';
var GET_ACCOUNT_PII_STATUS = 'GET_ACCOUNT_PII_STATUS [self_portal]';
var GET_ANY_MAIL_ACCOUNT_PII_STATUS = 'GET_ANY_MAIL_ACCOUNT_PII_STATUS [self_portal]';
var GET_ENV = 'GET_ENV [self_portal]';

/***/ }),

/***/ 700:
/*!**************************************************************!*\
  !*** ./src/components/notifications/NotificationsActions.js ***!
  \**************************************************************/
/*! exports provided: CLOSE_NOTIFICATION, closeNotification */
/*! exports used: CLOSE_NOTIFICATION, closeNotification */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeNotification; });

var CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';

var closeNotification = function closeNotification() {
  return { type: CLOSE_NOTIFICATION };
};

/***/ }),

/***/ 701:
/*!****************************************************!*\
  !*** ./src/containers/settings/SettingsActions.js ***!
  \****************************************************/
/*! exports provided: GET_SETTINGS_START, GET_SETTINGS, getSettings, UPDATE_SETTINGS_START, UPDATE_SETTINGS, updateSettings */
/*! exports used: GET_SETTINGS, GET_SETTINGS_START, UPDATE_SETTINGS, UPDATE_SETTINGS_START, getSettings, updateSettings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_SETTINGS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SETTINGS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var GET_SETTINGS_START = 'GET_SETTINGS_START';
var GET_SETTINGS = 'GET_SETTINGS';

var getSettings = function getSettings(email) {
    return function (dispatch) {
        dispatch({ type: GET_SETTINGS_START });
        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/settings/' + email);
        dispatch({
            type: GET_SETTINGS,
            payload: payload
        });
    };
};

var UPDATE_SETTINGS_START = 'UPDATE_SETTINGS_START';
var UPDATE_SETTINGS = 'UPDATE_SETTINGS';

var updateSettings = function updateSettings(props) {
    return function (dispatch) {
        dispatch({ type: UPDATE_SETTINGS_START });
        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/api/settingssubscribe', props);
        dispatch({
            type: UPDATE_SETTINGS,
            payload: payload
        });
    };
};

/***/ }),

/***/ 92:
/*!******************************************!*\
  !*** ./src/containers/app/AppActions.js ***!
  \******************************************/
/*! exports provided: CHANGE_PAGE_HEADER, changePageHeader, SET_MAIN_ELEMENT, setMainElement, getEnv, ROUTE_CHANGED, routeChanged, GET_API_CONFIG_START, GET_API_CONFIG, getApiConfig */
/*! exports used: CHANGE_PAGE_HEADER, GET_API_CONFIG, GET_API_CONFIG_START, ROUTE_CHANGED, SET_MAIN_ELEMENT, changePageHeader, getApiConfig, getEnv, setMainElement */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_PAGE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changePageHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_MAIN_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setMainElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROUTE_CHANGED; });
/* unused harmony export routeChanged */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_API_CONFIG_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_API_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getApiConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_types__ = __webpack_require__(/*! ../../redux/types */ 70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(/*! axios */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




var CHANGE_PAGE_HEADER = 'CHANGE_PAGE_HEADER';
var changePageHeader = function changePageHeader(page, leftDrawer) {
    return { type: CHANGE_PAGE_HEADER, payload: { page: page, leftDrawer: leftDrawer } };
};

var SET_MAIN_ELEMENT = 'SET_MAIN_ELEMENT';
var setMainElement = function setMainElement(mainElement) {
    return { type: SET_MAIN_ELEMENT, payload: mainElement };
};

var getEnv = function getEnv() {
    return { type: __WEBPACK_IMPORTED_MODULE_0__redux_types__["k" /* GET_ENV */] };
};

var ROUTE_CHANGED = 'ROUTE_CHANGED';
var routeChanged = function routeChanged() {
    return { type: ROUTE_CHANGED };
};

//B
var GET_API_CONFIG_START = 'GET_API_CONFIG_START';
var GET_API_CONFIG = 'GET_API_CONFIG';

var getApiConfig = function getApiConfig() {
    return function (dispatch) {
        dispatch({ type: GET_API_CONFIG_START });
        var payload = __WEBPACK_IMPORTED_MODULE_1_axios__["get"]('/api/config');
        dispatch({
            type: GET_API_CONFIG,
            payload: payload
        });
    };
};

/***/ })

},[1310]);


// WEBPACK FOOTER //
// client.bundle.js